export const COURSE_DATA = {
  // ================= FRENCH COURSE =================
  French: [
    {
      // --- SECTION 1: DETAILED DATA (UPDATED) ---
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic phrases",
          vocabulary: [
            "un",
            "une",
            "chat",
            "chien",
            "cheval",
            "pizza",
            "orange",
            "garçon",
            "fille",
            "homme",
            "femme",
            "c'est",
            "mange",
            "croissant",
            "et",
          ],
          grammar: "Introduction to gender (un/une), basic nouns, and 'c'est'.",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "bonjour",
            "salut",
            "bonsoir",
            "bonne nuit",
            "à bientôt",
            "à demain",
            "bonne journée",
            "bienvenue",
            "comment",
            "ça va",
            "bien",
            "très",
            "merci",
            "beaucoup",
            "enchanté",
          ],
          grammar: "Greetings, politeness, and asking 'how are you'.",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: [
            "je",
            "tu",
            "il",
            "elle",
            "m'appelle",
            "t'appelles",
            "s'appelle",
            "suis",
            "es",
            "est",
            "américain",
            "français",
            "anglais",
            "espagnol",
            "professeur",
            "étudiant",
          ],
          grammar: "Subject pronouns, verb 'être' (to be), nationalities.",
        },
        {
          id: "u4",
          title: "Unit 4: Use the present tense",
          vocabulary: [
            "parle",
            "parles",
            "excuse-moi",
            "pardon",
            "s'il te plaît",
            "s'il vous plaît",
            "vous",
            "parlez",
            "comprends",
            "langue",
          ],
          grammar: "Regular -er verbs (parler) singular forms, tu vs vous.",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: [
            "où",
            "est",
            "le",
            "la",
            "l'",
            "aéroport",
            "gare",
            "taxi",
            "voiture",
            "train",
            "avion",
            "valise",
            "hôtel",
            "rue",
            "dans",
            "à",
          ],
          grammar:
            "Definite articles (le/la), prepositions (dans, à), asking where.",
        },
        {
          id: "u6",
          title: "Unit 6: Refer to family members",
          vocabulary: [
            "mon",
            "ma",
            "ton",
            "ta",
            "père",
            "mère",
            "frère",
            "sœur",
            "mari",
            "femme",
            "de",
            "son",
            "sa",
          ],
          grammar: "Possessive adjectives (mon/ma/ton/ta/son/sa).",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about things you do",
          vocabulary: [
            "habite",
            "habites",
            "ici",
            "Paris",
            "Berlin",
            "Londres",
            "travaille",
            "travailles",
            "étudie",
            "étudies",
            "beaucoup",
            "journal",
            "usine",
          ],
          grammar: "Verbs ending in -er (habiter, travailler, étudier).",
        },
        {
          id: "u8",
          title: "Unit 8: Form the plural, use the present tense",
          vocabulary: [
            "les",
            "des",
            "chats",
            "chiens",
            "pizzas",
            "oranges",
            "mange",
            "manges",
            "mangent",
            "ils",
            "elles",
            "ont",
          ],
          grammar:
            "Plural nouns (s), plural articles (les/des), plural verbs (ils/elles).",
        },
        {
          id: "u9",
          title: "Unit 9: Describe your family",
          vocabulary: [
            "grand-père",
            "grand-mère",
            "famille",
            "fille",
            "fils",
            "parents",
            "avec",
            "mes",
            "tes",
            "ses",
            "chien",
            "chat",
          ],
          grammar: "Describing family, plural possessives (mes/tes/ses).",
        },
        {
          id: "u10",
          title: "Unit 10: Order food and drink",
          vocabulary: [
            "café",
            "thé",
            "eau",
            "jus",
            "sandwich",
            "restaurant",
            "table",
            "addition",
            "je voudrais",
            "s'il vous plaît",
            "serveur",
            "tasse",
            "verre",
          ],
          grammar: "Polite requests (je voudrais), restaurant vocabulary.",
        },
      ],
    },
    {
      // --- SECTION 2 (KEEPING YOUR ORIGINAL LIST) ---
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use gender and number agreement",
          vocabulary: [
            "grand",
            "grande",
            "petit",
            "petite",
            "nouveau",
            "nouvelle",
            "jeune",
            "vieux",
          ],
          grammar:
            "Gender agreement, adjective agreement, plural adjective forms.",
        },

        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: [
            "aller",
            "à",
            "au",
            "à la",
            "chez",
            "plage",
            "ville",
            "montagne",
            "cinéma",
          ],
          grammar: "Aller + place, prepositions for destinations.",
        },

        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: [
            "maison",
            "appartement",
            "chambre",
            "cuisine",
            "salon",
            "jardin",
            "balcon",
          ],
          grammar: "Using il y a, describing rooms, basic prepositions.",
        },

        {
          id: "s2u4",
          title: "Unit 4: Describe where you work",
          vocabulary: [
            "bureau",
            "entreprise",
            "collègue",
            "ordinateur",
            "travail",
            "chef",
          ],
          grammar: "Je travaille à…, workplace verbs, present tense.",
        },

        {
          id: "s2u5",
          title: "Unit 5: Talk about food & agreement",
          vocabulary: [
            "pomme",
            "pain",
            "riz",
            "viande",
            "poisson",
            "délicieux",
            "délicieuse",
          ],
          grammar: "Food gender, adjective agreement, basic partitive forms.",
        },

        {
          id: "s2u6",
          title: "Unit 6: Use the present tense",
          vocabulary: ["parler", "finir", "prendre", "aller", "venir", "faire"],
          grammar: "Present tense of regular and common irregular verbs.",
        },

        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: [
            "robe",
            "chemise",
            "chaussures",
            "pantalon",
            "taille",
            "couleur",
          ],
          grammar:
            "Je voudrais…, asking price, adjective agreement with clothes.",
        },

        {
          id: "s2u8",
          title: "Unit 8: Exchange personal information",
          vocabulary: [
            "âge",
            "adresse",
            "numéro",
            "profession",
            "nationalité",
            "nom",
          ],
          grammar:
            "Questions with est-ce que, verb être/avoir for personal info.",
        },

        {
          id: "s2u9",
          title: "Unit 9: Use the infinitive",
          vocabulary: [
            "aimer",
            "vouloir",
            "pouvoir",
            "devoir",
            "commencer",
            "continuer",
          ],
          grammar: "Verbs followed by infinitive (aimer/pouvoir/vouloir).",
        },

        {
          id: "s2u10",
          title: "Unit 10: Ask people about themselves",
          vocabulary: ["qui", "où", "d'où", "habiter", "travailler"],
          grammar: "Wh- questions, basic question structure.",
        },

        {
          id: "s2u11",
          title: "Unit 11: Ask questions",
          vocabulary: ["pourquoi", "comment", "quand", "quel", "combien"],
          grammar: "Est-ce que, inversion, question words.",
        },

        {
          id: "s2u12",
          title: "Unit 12: Tell time, form the present tense",
          vocabulary: ["heure", "minute", "matin", "soir", "nuit"],
          grammar: "Il est + time; daily routine present tense.",
        },

        {
          id: "s2u13",
          title: "Unit 13: Talk to someone formally",
          vocabulary: [
            "vous",
            "monsieur",
            "madame",
            "pouvez-vous",
            "s'il vous plaît",
          ],
          grammar: "Formal vs informal speech (vous vs tu).",
        },

        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: [
            "lire",
            "jouer",
            "danser",
            "voyager",
            "musique",
            "sport",
          ],
          grammar: "J'aime / je n'aime pas; hobby verbs.",
        },

        {
          id: "s2u15",
          title: "Unit 15: Describe your breakfast",
          vocabulary: ["café", "lait", "pain", "beurre", "confiture", "jus"],
          grammar: "Partitive articles (du/de la), morning routine verbs.",
        },

        {
          id: "s2u16",
          title: "Unit 16: Discuss travel plans",
          vocabulary: ["voyager", "vacances", "billet", "train", "réservation"],
          grammar: "Aller + infinitive (near future).",
        },

        {
          id: "s2u17",
          title: "Unit 17: Talk about school",
          vocabulary: [
            "école",
            "professeur",
            "élève",
            "classe",
            "devoirs",
            "étudier",
          ],
          grammar: "School verbs; avoir + school objects.",
        },

        {
          id: "s2u18",
          title: "Unit 18: Share work schedules",
          vocabulary: [
            "horaire",
            "travail",
            "pause",
            "réunion",
            "tous les jours",
          ],
          grammar: "Time expressions, routine descriptions.",
        },

        {
          id: "s2u19",
          title: "Unit 19: Book a hotel, use articles",
          vocabulary: ["hôtel", "chambre", "clé", "réserver", "réception"],
          grammar: "Definite/indefinite articles, booking phrases.",
        },

        {
          id: "s2u20",
          title: "Unit 20: Describe your routine",
          vocabulary: ["se lever", "se laver", "manger", "aller", "rentrer"],
          grammar: "Reflexive verbs + present tense routines.",
        },

        {
          id: "s2u21",
          title: "Unit 21: Talk about the weather",
          vocabulary: [
            "il fait chaud",
            "il fait froid",
            "il pleut",
            "il neige",
            "soleil",
            "nuage",
          ],
          grammar: "Weather expressions with faire/il y a.",
        },

        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: [
            "grand",
            "petit",
            "yeux",
            "cheveux",
            "sympa",
            "intelligent",
          ],
          grammar: "Physical description, adjective agreement.",
        },
      ],
    },
    {
      // --- SECTION 3 ---
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: [
            "heureux",
            "triste",
            "fatigué",
            "stressé",
            "fâché",
            "content",
          ],
          grammar: "Expressions with être; adjectives for emotions.",
        },

        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: [
            "marché",
            "supermarché",
            "fruits",
            "légumes",
            "paquet",
            "bouteille",
          ],
          grammar: "Quantities (un kilo de), partitive forms (du/de la).",
        },

        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: [
            "taille",
            "essayer",
            "cher",
            "bon marché",
            "cabine",
            "magasin",
          ],
          grammar: "Comparatives (plus/moins); shopping expressions.",
        },

        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: [
            "à droite",
            "à gauche",
            "tout droit",
            "près de",
            "loin de",
            "carte",
          ],
          grammar: "Imperatives for giving directions; prepositions.",
        },

        {
          id: "s3u5",
          title: "Unit 5: Talk about days & times (Reflexives)",
          vocabulary: [
            "se lever",
            "se coucher",
            "se préparer",
            "horloge",
            "matinée",
            "soirée",
          ],
          grammar:
            "Reflexive verbs in present tense; daily schedule vocabulary.",
        },

        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: [
            "sortir",
            "rencontrer",
            "parc",
            "cinéma",
            "activité",
            "loisir",
          ],
          grammar: "Regular present verbs; expressions with faire.",
        },

        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: [
            "je pense que",
            "je crois que",
            "à mon avis",
            "important",
            "intéressant",
            "ennuyeux",
          ],
          grammar: "Opinion structures; que-clauses.",
        },

        {
          id: "s3u8",
          title: "Unit 8: Use direct object pronouns",
          vocabulary: ["me", "te", "le", "la", "nous", "les"],
          grammar: "Direct object pronouns (me/te/le/la/nous/les).",
        },

        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: [
            "forêt",
            "rivière",
            "montagne",
            "fleur",
            "soleil",
            "pluie",
          ],
          grammar: "Using il y a / c’est with nature terms.",
        },

        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: [
            "oncle",
            "tante",
            "cousin",
            "cousine",
            "marié",
            "célibataire",
          ],
          grammar: "Family vocabulary; possessives review.",
        },

        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: [
            "cours",
            "matière",
            "professeur",
            "élève",
            "devoir",
            "réviser",
          ],
          grammar: "School-related verbs; instructions (impératif).",
        },

        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: [
            "cuisiner",
            "recette",
            "ingrédient",
            "four",
            "couteau",
            "casserole",
          ],
          grammar: "Imperatives; quantities (une cuillère de).",
        },

        {
          id: "s3u13",
          title: "Unit 13: Describe your schedule (savoir/connaître)",
          vocabulary: [
            "emploi du temps",
            "savoir",
            "connaître",
            "réunion",
            "planning",
            "activité",
          ],
          grammar: "Difference between savoir vs connaître.",
        },

        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: [
            "vacances",
            "réserver",
            "hôtel",
            "plage",
            "voyage",
            "billet",
          ],
          grammar: "Futur proche (aller + infinitive).",
        },

        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: [
            "malade",
            "fièvre",
            "toux",
            "médecin",
            "pharmacie",
            "douleur",
          ],
          grammar: "Avoir mal à; using être for conditions.",
        },

        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: ["immeuble", "étage", "pièce", "mur", "toit", "voisin"],
          grammar: "Describing locations; il y a / c’est.",
        },

        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: [
            "projet",
            "réunion",
            "collègue",
            "chef",
            "bureau",
            "tâche",
          ],
          grammar: "Formal work communication expressions.",
        },

        {
          id: "s3u18",
          title: "Unit 18: Use the imperfect",
          vocabulary: [
            "étais",
            "avais",
            "faisais",
            "voyais",
            "souvent",
            "toujours",
          ],
          grammar: "Imparfait for past habits, descriptions.",
        },

        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: [
            "hier",
            "la semaine dernière",
            "vu",
            "fait",
            "pris",
            "rentré",
          ],
          grammar: "Passé composé review.",
        },

        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: [
            "pouvoir",
            "aider",
            "voulez-vous",
            "pouvez-vous",
            "offrir",
            "demander",
          ],
          grammar: "Polite modal structures .",
        },

        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: [
            "voyagé",
            "visité",
            "arrivé",
            "parti",
            "souvenir",
            "endroit",
          ],
          grammar: "Passé composé with être & avoir for travel.",
        },
      ],
    },
    {
      // --- SECTION 4 ---
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Everyday topics & conversations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Use the present tense",
          vocabulary: ["parler", "finir", "prendre", "aller", "venir", "faire"],
          grammar:
            "Review of present tense for regular and key irregular verbs.",
        },

        {
          id: "s4u2",
          title: "Unit 2: Describe your weekend (Past Tense)",
          vocabulary: ["fait", "vu", "mangé", "allé", "sorti", "hier"],
          grammar: "Passé composé for weekend activities.",
        },

        {
          id: "s4u3",
          title: "Unit 3: Describe people you know",
          vocabulary: [
            "gentil",
            "drôle",
            "calme",
            "travailleur",
            "timide",
            "sociable",
          ],
          grammar: "Adjective agreement for personality descriptions.",
        },

        {
          id: "s4u4",
          title: "Unit 4: Talk about classes",
          vocabulary: [
            "maths",
            "histoire",
            "science",
            "professeur",
            "examen",
            "cours",
          ],
          grammar: "School vocabulary, present tense verbs for studies.",
        },

        {
          id: "s4u5",
          title: "Unit 5: Refer to extended family",
          vocabulary: ["oncle", "tante", "cousin", "cousine", "neveu", "nièce"],
          grammar: "Possessive adjectives; extended family nouns.",
        },

        {
          id: "s4u6",
          title: "Unit 6: Talk about Paris",
          vocabulary: [
            "musée",
            "tour",
            "pont",
            "quartier",
            "Seine",
            "monument",
          ],
          grammar:
            "Talking about places; using il y a / c’est for city descriptions.",
        },

        {
          id: "s4u7",
          title: "Unit 7: Comment on clothes",
          vocabulary: [
            "élégant",
            "simple",
            "coloré",
            "style",
            "marque",
            "mode",
          ],
          grammar: "Adjective agreement for clothing opinions.",
        },

        {
          id: "s4u8",
          title: "Unit 8: Make requests",
          vocabulary: [
            "pouvez-vous",
            "pourriez-vous",
            "aider",
            "donner",
            "passer",
            "apporter",
          ],
          grammar: "Polite request structures using conditionnel/pouvoir.",
        },

        {
          id: "s4u9",
          title: "Unit 9: Shop at a market",
          vocabulary: [
            "marchand",
            "prix",
            "kilo",
            "frais",
            "offre",
            "promotion",
          ],
          grammar: "Market vocabulary; quantity expressions.",
        },

        {
          id: "s4u10",
          title: "Unit 10: Use the past tense",
          vocabulary: ["été", "eu", "pris", "fait", "vu", "parti"],
          grammar: "Passé composé with avoir and être.",
        },

        {
          id: "s4u11",
          title: "Unit 11: Use indirect object pronouns",
          vocabulary: ["me", "te", "lui", "nous", "vous", "leur"],
          grammar: "Indirect object pronouns for giving/receiving actions.",
        },

        {
          id: "s4u12",
          title: "Unit 12: Communicate at a hotel",
          vocabulary: [
            "réserver",
            "clé",
            "carte",
            "réception",
            "ascenseur",
            "service",
          ],
          grammar: "Hotel expressions; formal requests.",
        },

        {
          id: "s4u13",
          title: "Unit 13: Talk about spending money",
          vocabulary: [
            "acheter",
            "dépenser",
            "budget",
            "prix",
            "cher",
            "bon marché",
          ],
          grammar: "Using verbs related to spending; comparatives for price.",
        },

        {
          id: "s4u14",
          title: "Unit 14: Talk about family gatherings",
          vocabulary: [
            "réunion",
            "repas",
            "inviter",
            "fêter",
            "famille",
            "occasion",
          ],
          grammar: "Talking about events; past and present tense review.",
        },

        {
          id: "s4u15",
          title: "Unit 15: Share travel experiences",
          vocabulary: [
            "voyagé",
            "visité",
            "endroit",
            "souvenir",
            "pays",
            "trajet",
          ],
          grammar: "Passé composé for sharing experiences.",
        },

        {
          id: "s4u16",
          title: "Unit 16: Talk about technology (Imperfect)",
          vocabulary: [
            "ordinateur",
            "portable",
            "internet",
            "ancien",
            "nouveau",
            "utiliser",
          ],
          grammar: "Imparfait for describing past habits with technology.",
        },

        {
          id: "s4u17",
          title: "Unit 17: Discuss games and media",
          vocabulary: ["jeu", "film", "musique", "émission", "lire", "jouer"],
          grammar: "Talking about preferences; opinion verbs.",
        },

        {
          id: "s4u18",
          title: "Unit 18: Talk about exercise",
          vocabulary: [
            "courir",
            "marcher",
            "salle de sport",
            "musculation",
            "santé",
            "forme",
          ],
          grammar: "Present tense activity verbs; expressions with faire.",
        },

        {
          id: "s4u19",
          title: "Unit 19: Discuss money",
          vocabulary: [
            "argent",
            "économiser",
            "compte",
            "banque",
            "payer",
            "salaire",
          ],
          grammar: "Money-related verbs; simple financial vocabulary.",
        },

        {
          id: "s4u20",
          title: "Unit 20: Comment on foods",
          vocabulary: ["délicieux", "fade", "sucré", "salé", "amer", "épice"],
          grammar: "Adjectives for food; expressing opinions.",
        },

        {
          id: "s4u21",
          title: "Unit 21: Make plans to go out",
          vocabulary: [
            "sortir",
            "rencontrer",
            "prévoir",
            "soirée",
            "restaurant",
            "disponible",
          ],
          grammar:
            "Expressions for planning; near future (aller + infinitive).",
        },

        {
          id: "s4u22",
          title: "Unit 22: Talk about your past",
          vocabulary: [
            "jeunesse",
            "souvenir",
            "avant",
            "était",
            "avais",
            "habitué",
          ],
          grammar: "Imparfait for past memories and descriptions.",
        },

        {
          id: "s4u23",
          title: "Unit 23: Make transit plans",
          vocabulary: ["train", "bus", "métro", "horaire", "retard", "billet"],
          grammar:
            "Travel planning vocabulary; using future/aller + infinitive.",
        },

        {
          id: "s4u24",
          title: "Unit 24: Use commands (Past with être)",
          vocabulary: ["sois", "allez", "viens", "arrivé", "parti", "entré"],
          grammar: "Imperative mood; passé composé with être.",
        },
        {
          id: "s4u25",
          title: "Unit 25: Describe what's in your home",
          vocabulary: [
            "pièce",
            "meuble",
            "étagère",
            "salon",
            "cuisine",
            "lampe",
          ],
          grammar: "Il y a / c’est for describing home interiors.",
        },

        {
          id: "s4u26",
          title: "Unit 26: Talk about art",
          vocabulary: [
            "peinture",
            "sculpture",
            "musée",
            "artiste",
            "tableau",
            "couleur",
          ],
          grammar: "Opinion phrases; describing works of art.",
        },

        {
          id: "s4u27",
          title: "Unit 27: Communicate in an emergency",
          vocabulary: [
            "aider",
            "urgence",
            "police",
            "ambulance",
            "danger",
            "accident",
          ],
          grammar: "Emergency expressions; formal requests.",
        },

        {
          id: "s4u28",
          title: "Unit 28: Use the future tense",
          vocabulary: ["irai", "ferai", "verrai", "serai", "aurai", "demain"],
          grammar: "Futur simple forms of key irregular verbs.",
        },

        {
          id: "s4u29",
          title: "Unit 29: Communicate with a doctor",
          vocabulary: [
            "mal",
            "douleur",
            "symptôme",
            "traitement",
            "ordonnance",
            "consultation",
          ],
          grammar: "Using avoir mal à; medical vocabulary.",
        },

        {
          id: "s4u30",
          title: "Unit 30: Talk about the weather (Future)",
          vocabulary: [
            "il fera",
            "il y aura",
            "tempête",
            "neige",
            "pluie",
            "soleil",
          ],
          grammar: "Futur simple for weather predictions.",
        },

        {
          id: "s4u31",
          title: "Unit 31: Talk about possessions",
          vocabulary: ["propre", "vieux", "neuf", "objet", "cadeau", "valeur"],
          grammar: "Possession using avoir; describing belongings.",
        },

        {
          id: "s4u32",
          title: "Unit 32: Talk about the future",
          vocabulary: [
            "avenir",
            "projet",
            "objectif",
            "plan",
            "carrière",
            "réussite",
          ],
          grammar: "Futur simple vs futur proche.",
        },

        {
          id: "s4u33",
          title: "Unit 33: Talk about a bad day",
          vocabulary: [
            "problème",
            "retard",
            "fatigue",
            "stress",
            "malchance",
            "cassé",
          ],
          grammar: "Narrating events in passé composé.",
        },

        {
          id: "s4u34",
          title: "Unit 34: Discuss careers",
          vocabulary: [
            "emploi",
            "métier",
            "entretien",
            "entreprise",
            "compétence",
            "salaire",
          ],
          grammar: "Career vocabulary; formal communication.",
        },

        {
          id: "s4u35",
          title: "Unit 35: Express yourself politely",
          vocabulary: [
            "pourriez-vous",
            "voudriez-vous",
            "excusez-moi",
            "désolé",
            "merci",
            "pardon",
          ],
          grammar: "Polite conditional forms and formal phrases.",
        },

        {
          id: "s4u36",
          title: "Unit 36: Shop for sales",
          vocabulary: [
            "promotion",
            "soldes",
            "réduction",
            "prix",
            "article",
            "caisse",
          ],
          grammar: "Shopping vocabulary; comparatives and quantities.",
        },
        {
          id: "s4u37",
          title: "Unit 37: Use the gerund",
          vocabulary: [
            "en faisant",
            "en parlant",
            "en mangeant",
            "en lisant",
            "en allant",
            "action",
          ],
          grammar: "Gerund: en + present participle for simultaneous actions.",
        },

        {
          id: "s4u38",
          title: "Unit 38: Use the conditional",
          vocabulary: [
            "voudrais",
            "pourrais",
            "aimerais",
            "devrais",
            "si",
            "condition",
          ],
          grammar: "Conditional for politeness and hypothetical situations.",
        },

        {
          id: "s4u39",
          title: "Unit 39: Make requests",
          vocabulary: [
            "pouvez-vous",
            "aider",
            "apporter",
            "passer",
            "donner",
            "prêter",
          ],
          grammar: "Polite request structures using pouvoir/conditionnel.",
        },

        {
          id: "s4u40",
          title: "Unit 40: Discuss protests",
          vocabulary: [
            "manifestation",
            "droit",
            "liberté",
            "public",
            "gouvernement",
            "voix",
          ],
          grammar: "Talking about public events and opinions.",
        },

        {
          id: "s4u41",
          title: "Unit 41: Order at a restaurant",
          vocabulary: [
            "menu",
            "serveur",
            "plat",
            "entrée",
            "dessert",
            "commander",
          ],
          grammar: "Restaurant expressions; polite forms.",
        },

        {
          id: "s4u42",
          title: "Unit 42: Comment on sports",
          vocabulary: [
            "sport",
            "match",
            "équipe",
            "joueur",
            "gagner",
            "perdre",
          ],
          grammar: "Talking about games; verbs for sports.",
        },

        {
          id: "s4u43",
          title: "Unit 43: Communicate in class",
          vocabulary: [
            "question",
            "réponse",
            "réviser",
            "expliquer",
            "noter",
            "comprendre",
          ],
          grammar: "Imperatives and classroom instructions.",
        },

        {
          id: "s4u44",
          title: "Unit 44: Talk about road trips",
          vocabulary: [
            "route",
            "autoroute",
            "carte",
            "voyage",
            "pause",
            "kilomètre",
          ],
          grammar: "Travel verbs; narrating experiences.",
        },

        {
          id: "s4u45",
          title: "Unit 45: Discuss emergencies",
          vocabulary: [
            "urgence",
            "accident",
            "danger",
            "appel",
            "secours",
            "blessure",
          ],
          grammar: "Emergency vocabulary; imperative forms.",
        },

        {
          id: "s4u46",
          title: "Unit 46: Talk about meeting people",
          vocabulary: [
            "rencontrer",
            "présenter",
            "saluer",
            "discuter",
            "inviter",
            "connaître",
          ],
          grammar: "Expressions for social interactions.",
        },
      ],
    },
    {
      // --- SECTION 5 ---
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Wide variety of topics",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Order at a bistro",
          vocabulary: [
            "commander",
            "boisson",
            "plat",
            "serveur",
            "addition",
            "réserver",
          ],
          grammar: "Restaurant expressions; polite forms for ordering.",
        },

        {
          id: "s5u2",
          title: "Unit 2: Talk about festivals",
          vocabulary: [
            "festival",
            "fête",
            "musique",
            "feu d'artifice",
            "danse",
            "tradition",
          ],
          grammar: "Describing events and celebrations.",
        },

        {
          id: "s5u3",
          title: "Unit 3: Use rien and personne",
          vocabulary: ["rien", "personne", "jamais", "aucun", "ne", "que"],
          grammar: "Negative expressions with rien/personne.",
        },

        {
          id: "s5u4",
          title: "Unit 4: Discuss gifts",
          vocabulary: [
            "cadeau",
            "offrir",
            "occasion",
            "emballage",
            "surprise",
            "carte",
          ],
          grammar: "Indirect objects and gifting verbs.",
        },

        {
          id: "s5u5",
          title: "Unit 5: Talk about school",
          vocabulary: [
            "matière",
            "réviser",
            "devoir",
            "note",
            "programme",
            "classe",
          ],
          grammar: "School vocabulary; present and past tense review.",
        },

        {
          id: "s5u6",
          title: "Unit 6: Discuss relationships",
          vocabulary: [
            "ami",
            "couple",
            "famille",
            "relation",
            "confiance",
            "soutien",
          ],
          grammar: "Talking about social and family relationships.",
        },

        {
          id: "s5u7",
          title: "Unit 7: Describe career plans",
          vocabulary: [
            "carrière",
            "objectif",
            "avenir",
            "stage",
            "entreprise",
            "projet",
          ],
          grammar: "Future tense for long-term goals.",
        },

        {
          id: "s5u8",
          title: "Unit 8: Express opinions",
          vocabulary: [
            "je pense",
            "je crois",
            "selon moi",
            "important",
            "controverse",
            "difficile",
          ],
          grammar: "Opinion structures and connectors.",
        },

        {
          id: "s5u9",
          title: "Unit 9: Talk about the outdoors",
          vocabulary: [
            "forêt",
            "lac",
            "colline",
            "randonnée",
            "camping",
            "nature",
          ],
          grammar: "Describing outdoor activities; using il y a / c’est.",
        },

        {
          id: "s5u10",
          title: "Unit 10: Use relative pronouns",
          vocabulary: ["qui", "que", "dont", "où", "personne", "chose"],
          grammar: "Relative clauses with qui/que/dont.",
        },

        {
          id: "s5u11",
          title: "Unit 11: Discuss athletics",
          vocabulary: [
            "course",
            "terrain",
            "joueur",
            "équipe",
            "entraînement",
            "compétition",
          ],
          grammar: "Sports vocabulary; verbs for athletic activities.",
        },

        {
          id: "s5u12",
          title: "Unit 12: Talk about the past",
          vocabulary: [
            "avant",
            "jadis",
            "autrefois",
            "souvenir",
            "était",
            "avais",
          ],
          grammar: "Imparfait vs passé composé.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Talk about the environment",
          vocabulary: [
            "pollution",
            "écologie",
            "planète",
            "déchet",
            "recycler",
            "énergie",
          ],
          grammar:
            "Environmental vocabulary; expressing concerns and solutions.",
        },

        {
          id: "s5u14",
          title: "Unit 14: Discuss your health",
          vocabulary: [
            "symptôme",
            "médecin",
            "fatigue",
            "stress",
            "traitement",
            "maladie",
          ],
          grammar:
            "Health-related phrases; expressing conditions with être/avoir.",
        },

        {
          id: "s5u15",
          title: "Unit 15: Talk about your job",
          vocabulary: [
            "emploi",
            "tâche",
            "horaire",
            "réunion",
            "projet",
            "responsabilité",
          ],
          grammar: "Workplace verbs; present and past job descriptions.",
        },

        {
          id: "s5u16",
          title: "Unit 16: Use y and en",
          vocabulary: ["y", "en", "aller", "penser", "répondre", "vouloir"],
          grammar: "Pronouns y and en with verbs.",
        },

        {
          id: "s5u17",
          title: "Unit 17: Talk about your siblings",
          vocabulary: ["frère", "sœur", "aîné", "cadet", "famille", "grandir"],
          grammar: "Describing siblings; past and present tense mix.",
        },

        {
          id: "s5u18",
          title: "Unit 18: Follow recipes",
          vocabulary: [
            "cuisiner",
            "mélanger",
            "four",
            "ingrédient",
            "recette",
            "couper",
          ],
          grammar: "Imperative mood for instructions.",
        },

        {
          id: "s5u19",
          title: "Unit 19: Read a celebrity interview",
          vocabulary: [
            "célèbre",
            "acteur",
            "interview",
            "réponse",
            "question",
            "carrière",
          ],
          grammar: "Reported speech basics; interview vocabulary.",
        },

        {
          id: "s5u20",
          title: "Unit 20: Describe a wedding",
          vocabulary: [
            "mariage",
            "cérémonie",
            "invité",
            "robe",
            "fête",
            "alliance",
          ],
          grammar: "Describing events and traditions.",
        },

        {
          id: "s5u21",
          title: "Unit 21: Communicate on a trip",
          vocabulary: [
            "itinéraire",
            "renseignement",
            "réservation",
            "bagage",
            "guide",
            "voyage",
          ],
          grammar: "Travel phrases; asking for information.",
        },

        {
          id: "s5u22",
          title: "Unit 22: Describe household tasks",
          vocabulary: [
            "ménage",
            "balayer",
            "laver",
            "nettoyer",
            "poussière",
            "corvée",
          ],
          grammar: "Household verbs; using devoir for responsibilities.",
        },

        {
          id: "s5u23",
          title: "Unit 23: Discuss travel abroad",
          vocabulary: [
            "passeport",
            "visa",
            "frontière",
            "destination",
            "vol",
            "douanes",
          ],
          grammar: "Travel and immigration vocabulary.",
        },

        {
          id: "s5u24",
          title: "Unit 24: Talk about the internet",
          vocabulary: [
            "internet",
            "réseau",
            "message",
            "site",
            "fichier",
            "publier",
          ],
          grammar: "Digital vocabulary; describing online actions.",
        },
        {
          id: "s5u25",
          title: "Unit 25: Comment on foods",
          vocabulary: ["délicieux", "amer", "salé", "sucré", "épice", "plat"],
          grammar: "Adjectives for describing food; opinions.",
        },

        {
          id: "s5u26",
          title: "Unit 26: Use relative pronouns",
          vocabulary: ["qui", "que", "dont", "où", "personne", "idée"],
          grammar: "Building relative clauses using qui/que/dont.",
        },

        {
          id: "s5u27",
          title: "Unit 27: Navigate complex situations",
          vocabulary: [
            "problème",
            "décision",
            "solution",
            "urgence",
            "conflit",
            "gérer",
          ],
          grammar: "Phrases for handling conflicts or difficult scenarios.",
        },

        {
          id: "s5u28",
          title: "Unit 28: Discuss technology trends",
          vocabulary: [
            "numérique",
            "tendance",
            "application",
            "innovation",
            "robotique",
            "réalité virtuelle",
          ],
          grammar: "Talking about current trends; present and future forms.",
        },

        {
          id: "s5u29",
          title: "Unit 29: Analyze media",
          vocabulary: [
            "article",
            "journal",
            "publicité",
            "source",
            "critique",
            "information",
          ],
          grammar: "Discussing media sources; expressing opinions.",
        },

        {
          id: "s5u30",
          title: "Unit 30: Talk about cinema",
          vocabulary: [
            "film",
            "acteur",
            "scène",
            "réalisateur",
            "genre",
            "bande-annonce",
          ],
          grammar: "Cinema vocabulary; using adjectives to describe films.",
        },

        {
          id: "s5u31",
          title: "Unit 31: Debate current events",
          vocabulary: [
            "débat",
            "politique",
            "opinion",
            "argument",
            "société",
            "actualité",
          ],
          grammar: "Opinion structures; connectors for debate.",
        },

        {
          id: "s5u32",
          title: "Unit 32: Use advanced negation",
          vocabulary: [
            "ne…guère",
            "ne…aucun",
            "ne…que",
            "ne…plus",
            "ne…jamais",
            "ne…personne",
          ],
          grammar: "Complex negation structures.",
        },

        {
          id: "s5u33",
          title: "Unit 33: Describe abstract ideas",
          vocabulary: [
            "concept",
            "esprit",
            "liberté",
            "justice",
            "théorie",
            "valeur",
          ],
          grammar: "Talking about abstract concepts; using être and paraître.",
        },

        {
          id: "s5u34",
          title: "Unit 34: Talk about university life",
          vocabulary: [
            "campus",
            "faculté",
            "cours",
            "professeur",
            "bibliothèque",
            "examen",
          ],
          grammar: "University vocabulary; formal/informal registers.",
        },

        {
          id: "s5u35",
          title: "Unit 35: Discuss volunteering",
          vocabulary: [
            "bénévolat",
            "association",
            "aider",
            "organiser",
            "cause",
            "don",
          ],
          grammar: "Talking about activities; expressing purpose using pour.",
        },

        {
          id: "s5u36",
          title: "Unit 36: Review past tenses",
          vocabulary: [
            "passé composé",
            "imparfait",
            "était",
            "faisait",
            "avait",
            "parti",
          ],
          grammar: "Contrast passé composé vs imparfait in narratives.",
        },
        {
          id: "s5u37",
          title: "Unit 37: Use the subjunctive mood",
          vocabulary: [
            "que",
            "il faut que",
            "bien que",
            "pour que",
            "important",
            "nécessaire",
          ],
          grammar: "Introduction to the subjunctive in common expressions.",
        },

        {
          id: "s5u38",
          title: "Unit 38: Express doubt and uncertainty",
          vocabulary: [
            "douter",
            "incertain",
            "possible",
            "peut-être",
            "sembler",
            "improbable",
          ],
          grammar: "Subjunctive and modal expressions for doubt.",
        },

        {
          id: "s5u39",
          title: "Unit 39: Discuss environmental issues",
          vocabulary: [
            "climat",
            "réchauffement",
            "biodiversité",
            "pollution",
            "durable",
            "protéger",
          ],
          grammar: "Environmental vocabulary; cause and consequence.",
        },

        {
          id: "s5u40",
          title: "Unit 40: Talk about performing arts",
          vocabulary: [
            "théâtre",
            "spectacle",
            "danse",
            "musicien",
            "acteur",
            "scène",
          ],
          grammar: "Describing performances; present and past tense use.",
        },

        {
          id: "s5u41",
          title: "Unit 41: Professional interviews",
          vocabulary: [
            "entretien",
            "compétence",
            "expérience",
            "qualité",
            "poste",
            "recruteur",
          ],
          grammar: "Formal register; professional self-description.",
        },

        {
          id: "s5u42",
          title: "Unit 42: Write formal emails",
          vocabulary: [
            "objet",
            "cordialement",
            "pièce jointe",
            "formule",
            "message",
            "adresse",
          ],
          grammar: "Email structure; formal written expressions.",
        },

        {
          id: "s5u43",
          title: "Unit 43: Discuss architecture",
          vocabulary: [
            "bâtiment",
            "structure",
            "pont",
            "design",
            "ancien",
            "moderne",
          ],
          grammar: "Descriptive language for buildings.",
        },

        {
          id: "s5u44",
          title: "Unit 44: Talk about fashion trends",
          vocabulary: [
            "tendance",
            "marque",
            "style",
            "moderne",
            "élégant",
            "créateur",
          ],
          grammar: "Fashion vocabulary; opinions and comparisons.",
        },

        {
          id: "s5u45",
          title: "Unit 45: Review conditional sentences",
          vocabulary: [
            "si",
            "condition",
            "aurais",
            "serais",
            "pourrais",
            "devrais",
          ],
          grammar: "Si + imparfait → conditionnel structure.",
        },

        {
          id: "s5u46",
          title: "Unit 46: Tell jokes and stories",
          vocabulary: [
            "histoire",
            "rire",
            "blague",
            "personnage",
            "raconter",
            "situation",
          ],
          grammar: "Narrative connectors; past tense storytelling.",
        },
        {
          id: "s5u47",
          title: "Unit 47: Discuss traditions",
          vocabulary: [
            "tradition",
            "coutume",
            "héritage",
            "culture",
            "fêter",
            "rituel",
          ],
          grammar: "Describing cultural practices; using present and past.",
        },

        {
          id: "s5u48",
          title: "Unit 48: Describe historical events",
          vocabulary: [
            "histoire",
            "époque",
            "guerre",
            "roi",
            "révolution",
            "date",
          ],
          grammar: "Narrative past forms; sequencing events.",
        },

        {
          id: "s5u49",
          title: "Unit 49: Talk about legal matters",
          vocabulary: [
            "loi",
            "justice",
            "tribunal",
            "droit",
            "avocat",
            "procédure",
          ],
          grammar: "Legal vocabulary; formal structures.",
        },

        {
          id: "s5u50",
          title: "Unit 50: Use passive voice",
          vocabulary: ["être", "été", "fait", "écrit", "ouvert", "annoncé"],
          grammar: "Passive voice with être + past participle.",
        },

        {
          id: "s5u51",
          title: "Unit 51: Final B1 Review",
          vocabulary: [
            "réviser",
            "résumer",
            "important",
            "expression",
            "verbe",
            "temps",
          ],
          grammar: "Comprehensive review of B1 grammar and vocabulary.",
        },
      ],
    },
    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 concepts",
      // FIX: Return an object with title, vocab, and grammar
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [], // Empty array to prevent crashes
        grammar: "Advanced B1 Grammar",
      })),
    },
    {
      name: "Section 7: Daily Refresh (CEFR B2)",
      description: "Upper Intermediate",
      // FIX: Return an object
      units: Array.from({ length: 36 }, (_, i) => ({
        id: `s7_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Concept ${i + 1}`,
        vocabulary: [],
        grammar: "B2 Level Grammar",
      })),
    },
    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery",
      // FIX: Return an object
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [],
        grammar: "Mastery Level Concepts",
      })),
    },
  ],

  // Placeholder for Spanish
  Spanish: [
    {
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic phrases",
          vocabulary: [
            "uno",
            "una",
            "gato",
            "perro",
            "caballo",
            "pizza",
            "naranja",
            "niño",
            "niña",
            "hombre",
            "mujer",
            "es",
            "come",
            "pan",
            "y",
          ],
          grammar:
            "Introduction to gender (el/la), basic nouns, and the verb ser (es).",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "hola",
            "buenos días",
            "buenas tardes",
            "buenas noches",
            "hasta luego",
            "hasta mañana",
            "bienvenido",
            "cómo",
            "estás",
            "bien",
            "muy",
            "gracias",
            "mucho",
            "encantado",
          ],
          grammar: "Greetings, politeness, and asking how someone is.",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: [
            "yo",
            "tú",
            "él",
            "ella",
            "me llamo",
            "te llamas",
            "se llama",
            "soy",
            "eres",
            "es",
            "español",
            "inglés",
            "francés",
            "estudiante",
            "profesor",
          ],
          grammar:
            "Subject pronouns and the verb ser (present tense); nationalities.",
        },
        {
          id: "u4",
          title: "Unit 4: Use the present tense",
          vocabulary: [
            "hablo",
            "hablas",
            "habla",
            "perdón",
            "disculpa",
            "por favor",
            "usted",
            "entiendo",
            "idioma",
          ],
          grammar:
            "Regular -ar verbs (hablar) in the present tense; tú vs usted.",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: [
            "dónde",
            "está",
            "el",
            "la",
            "aeropuerto",
            "estación",
            "taxi",
            "coche",
            "tren",
            "avión",
            "maleta",
            "hotel",
            "calle",
            "en",
            "a",
          ],
          grammar:
            "Definite articles (el/la), basic prepositions, and asking locations.",
        },
        {
          id: "u6",
          title: "Unit 6: Refer to family members",
          vocabulary: [
            "mi",
            "mis",
            "tu",
            "padre",
            "madre",
            "hermano",
            "hermana",
            "esposo",
            "esposa",
            "de",
            "su",
          ],
          grammar: "Possessive adjectives (mi/mis, tu, su).",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about things you do",
          vocabulary: [
            "vivo",
            "vives",
            "aquí",
            "Madrid",
            "Barcelona",
            "trabajo",
            "trabajas",
            "estudio",
            "estudias",
            "mucho",
            "periódico",
            "fábrica",
          ],
          grammar: "Regular present tense verbs (vivir, trabajar, estudiar).",
        },
        {
          id: "u8",
          title: "Unit 8: Form the plural, use the present tense",
          vocabulary: [
            "los",
            "las",
            "gatos",
            "perros",
            "pizzas",
            "naranjas",
            "come",
            "comes",
            "comen",
            "ellos",
            "ellas",
            "tienen",
          ],
          grammar: "Plural nouns and articles; plural verb forms.",
        },
        {
          id: "u9",
          title: "Unit 9: Describe your family",
          vocabulary: [
            "abuelo",
            "abuela",
            "familia",
            "hija",
            "hijo",
            "padres",
            "con",
            "mis",
            "tus",
            "sus",
            "perro",
            "gato",
          ],
          grammar: "Describing family members and plural possessives.",
        },
        {
          id: "u10",
          title: "Unit 10: Order food and drink",
          vocabulary: [
            "café",
            "té",
            "agua",
            "jugo",
            "sándwich",
            "restaurante",
            "mesa",
            "cuenta",
            "quisiera",
            "por favor",
            "mesero",
            "taza",
            "vaso",
          ],
          grammar: "Polite requests and basic restaurant vocabulary.",
        },
      ],
    },

    {
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use gender and number agreement",
          vocabulary: [
            "alto",
            "alta",
            "bajo",
            "baja",
            "grande",
            "pequeño",
            "nuevo",
            "nueva",
            "viejo",
            "vieja",
          ],
          grammar: "Gender and number agreement with adjectives.",
        },
        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: [
            "ir",
            "voy",
            "vas",
            "va",
            "a",
            "al",
            "a la",
            "playa",
            "ciudad",
            "montaña",
            "cine",
          ],
          grammar: "Ir + a + place.",
        },
        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: [
            "casa",
            "apartamento",
            "habitación",
            "cocina",
            "sala",
            "baño",
            "jardín",
            "balcón",
          ],
          grammar: "Hay vs está; describing rooms.",
        },
        {
          id: "s2u4",
          title: "Unit 4: Describe where you work",
          vocabulary: [
            "oficina",
            "empresa",
            "compañero",
            "trabajo",
            "jefe",
            "computadora",
            "escritorio",
          ],
          grammar: "Present tense verbs for work.",
        },
        {
          id: "s2u5",
          title: "Unit 5: Talk about food & agreement",
          vocabulary: [
            "manzana",
            "pan",
            "arroz",
            "carne",
            "pescado",
            "delicioso",
            "deliciosa",
          ],
          grammar: "Food vocabulary and adjective agreement.",
        },
        {
          id: "s2u6",
          title: "Unit 6: Use the present tense",
          vocabulary: ["hablar", "comer", "vivir", "ir", "venir", "hacer"],
          grammar: "Present tense of regular and common irregular verbs.",
        },
        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: [
            "ropa",
            "camisa",
            "pantalón",
            "zapatos",
            "talla",
            "color",
            "precio",
          ],
          grammar: "Shopping phrases and adjective agreement.",
        },
        {
          id: "s2u8",
          title: "Unit 8: Exchange personal information",
          vocabulary: [
            "edad",
            "dirección",
            "número",
            "profesión",
            "nacionalidad",
            "nombre",
          ],
          grammar: "Personal information using ser and tener.",
        },
        {
          id: "s2u9",
          title: "Unit 9: Use the infinitive",
          vocabulary: [
            "gustar",
            "querer",
            "poder",
            "deber",
            "empezar",
            "continuar",
          ],
          grammar: "Verbs followed by the infinitive.",
        },
        {
          id: "s2u10",
          title: "Unit 10: Ask people about themselves",
          vocabulary: ["quién", "dónde", "de dónde", "vivir", "trabajar"],
          grammar: "Basic questions about people.",
        },
        {
          id: "s2u11",
          title: "Unit 11: Ask questions",
          vocabulary: ["por qué", "cómo", "cuándo", "cuál", "cuánto"],
          grammar: "Question words and structure.",
        },
        {
          id: "s2u12",
          title: "Unit 12: Tell time, form the present tense",
          vocabulary: ["hora", "minuto", "mañana", "tarde", "noche"],
          grammar: "Decir la hora and daily routines.",
        },
        {
          id: "s2u13",
          title: "Unit 13: Talk to someone formally",
          vocabulary: ["usted", "señor", "señora", "¿puede?", "por favor"],
          grammar: "Formal vs informal speech (tú vs usted).",
        },
        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: [
            "leer",
            "jugar",
            "bailar",
            "viajar",
            "música",
            "deporte",
          ],
          grammar: "Expressing likes and hobbies.",
        },
        {
          id: "s2u15",
          title: "Unit 15: Describe your breakfast",
          vocabulary: [
            "café",
            "leche",
            "pan",
            "mantequilla",
            "mermelada",
            "jugo",
          ],
          grammar: "Food quantities and morning routines.",
        },
        {
          id: "s2u16",
          title: "Unit 16: Discuss travel plans",
          vocabulary: ["viajar", "vacaciones", "billete", "tren", "reserva"],
          grammar: "Ir + a + infinitive (near future).",
        },
        {
          id: "s2u17",
          title: "Unit 17: Talk about school",
          vocabulary: [
            "escuela",
            "profesor",
            "estudiante",
            "clase",
            "tarea",
            "estudiar",
          ],
          grammar: "School vocabulary and verbs.",
        },
        {
          id: "s2u18",
          title: "Unit 18: Share work schedules",
          vocabulary: [
            "horario",
            "trabajo",
            "pausa",
            "reunión",
            "todos los días",
          ],
          grammar: "Time expressions and routines.",
        },
        {
          id: "s2u19",
          title: "Unit 19: Book a hotel, use articles",
          vocabulary: ["hotel", "habitación", "llave", "reservar", "recepción"],
          grammar: "Definite and indefinite articles.",
        },
        {
          id: "s2u20",
          title: "Unit 20: Describe your routine",
          vocabulary: ["levantarse", "lavarse", "comer", "ir", "volver"],
          grammar: "Reflexive verbs in daily routines.",
        },
        {
          id: "s2u21",
          title: "Unit 21: Talk about the weather",
          vocabulary: [
            "hace calor",
            "hace frío",
            "llueve",
            "nieva",
            "sol",
            "nube",
          ],
          grammar: "Weather expressions.",
        },
        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: [
            "alto",
            "bajo",
            "ojos",
            "cabello",
            "simpático",
            "inteligente",
          ],
          grammar: "Physical descriptions and adjectives.",
        },
      ],
    },

    {
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: [
            "feliz",
            "triste",
            "cansado",
            "estresado",
            "enojado",
            "contento",
          ],
          grammar: "Using estar with emotions.",
        },
        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: [
            "mercado",
            "supermercado",
            "frutas",
            "verduras",
            "paquete",
            "botella",
          ],
          grammar: "Quantities and shopping expressions.",
        },
        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: [
            "talla",
            "probar",
            "caro",
            "barato",
            "probador",
            "tienda",
          ],
          grammar: "Comparisons and shopping phrases.",
        },
        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: [
            "a la derecha",
            "a la izquierda",
            "todo recto",
            "cerca de",
            "lejos de",
            "mapa",
          ],
          grammar: "Imperatives and prepositions for directions.",
        },
        {
          id: "s3u5",
          title: "Unit 5: Talk about days & times (Reflexives)",
          vocabulary: [
            "levantarse",
            "acostarse",
            "prepararse",
            "reloj",
            "mañana",
            "noche",
          ],
          grammar: "Reflexive verbs in the present tense.",
        },
        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: [
            "salir",
            "encontrar",
            "parque",
            "cine",
            "actividad",
            "ocio",
          ],
          grammar: "Present tense verbs and leisure expressions.",
        },
        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: [
            "pienso que",
            "creo que",
            "en mi opinión",
            "importante",
            "interesante",
            "aburrido",
          ],
          grammar: "Opinion structures with que.",
        },
        {
          id: "s3u8",
          title: "Unit 8: Use direct object pronouns",
          vocabulary: ["me", "te", "lo", "la", "nos", "los", "las"],
          grammar: "Direct object pronouns (lo/la/los/las).",
        },
        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: ["bosque", "río", "montaña", "flor", "sol", "lluvia"],
          grammar: "Using hay and es with nature vocabulary.",
        },
        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: ["tío", "tía", "primo", "prima", "casado", "soltero"],
          grammar: "Family descriptions and adjectives.",
        },
        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: [
            "clase",
            "materia",
            "profesor",
            "estudiante",
            "tarea",
            "repasar",
          ],
          grammar: "School-related verbs and instructions.",
        },
        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: [
            "cocinar",
            "receta",
            "ingrediente",
            "horno",
            "cuchillo",
            "olla",
          ],
          grammar: "Imperatives and cooking instructions.",
        },
        {
          id: "s3u13",
          title: "Unit 13: Describe your schedule (saber/conocer)",
          vocabulary: [
            "horario",
            "saber",
            "conocer",
            "reunión",
            "plan",
            "actividad",
          ],
          grammar: "Difference between saber and conocer.",
        },
        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: [
            "vacaciones",
            "reservar",
            "hotel",
            "playa",
            "viaje",
            "billete",
          ],
          grammar: "Near future with ir + a + infinitive.",
        },
        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: [
            "enfermo",
            "fiebre",
            "tos",
            "médico",
            "farmacia",
            "dolor",
          ],
          grammar: "Expressions with tener dolor / estar enfermo.",
        },
        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: [
            "edificio",
            "piso",
            "habitación",
            "pared",
            "techo",
            "vecino",
          ],
          grammar: "Describing places with hay and está.",
        },
        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: [
            "proyecto",
            "reunión",
            "compañero",
            "jefe",
            "oficina",
            "tarea",
          ],
          grammar: "Workplace communication expressions.",
        },
        {
          id: "s3u18",
          title: "Unit 18: Use the imperfect",
          vocabulary: ["era", "tenía", "hacía", "veía", "siempre", "a menudo"],
          grammar: "Introduction to imperfect tense for habits.",
        },
        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: [
            "ayer",
            "la semana pasada",
            "vi",
            "hice",
            "tomé",
            "volví",
          ],
          grammar: "Pretérito indefinido for recent actions.",
        },
        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: [
            "poder",
            "ayudar",
            "¿quieres?",
            "¿puedes?",
            "ofrecer",
            "pedir",
          ],
          grammar: "Polite offers and requests.",
        },
        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: [
            "viajé",
            "visité",
            "llegué",
            "salí",
            "recuerdo",
            "lugar",
          ],
          grammar: "Talking about travel using past tense.",
        },
      ],
    },

    {
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Everyday topics & conversations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Use the present tense",
          vocabulary: ["hablar", "comer", "vivir", "ir", "venir", "hacer"],
          grammar:
            "Review of present tense for regular and key irregular verbs.",
        },
        {
          id: "s4u2",
          title: "Unit 2: Describe your weekend (Past Tense)",
          vocabulary: ["hice", "vi", "comí", "fui", "salí", "ayer"],
          grammar: "Pretérito indefinido for weekend activities.",
        },
        {
          id: "s4u3",
          title: "Unit 3: Describe people you know",
          vocabulary: [
            "amable",
            "divertido",
            "tranquilo",
            "trabajador",
            "tímido",
            "sociable",
          ],
          grammar: "Adjectives for personality descriptions.",
        },
        {
          id: "s4u4",
          title: "Unit 4: Talk about classes",
          vocabulary: [
            "matemáticas",
            "historia",
            "ciencia",
            "profesor",
            "examen",
            "clase",
          ],
          grammar: "School vocabulary and present tense verbs.",
        },
        {
          id: "s4u5",
          title: "Unit 5: Refer to extended family",
          vocabulary: ["tío", "tía", "primo", "prima", "sobrino", "sobrina"],
          grammar: "Extended family vocabulary and possessives.",
        },
        {
          id: "s4u6",
          title: "Unit 6: Talk about Madrid",
          vocabulary: [
            "museo",
            "torre",
            "puente",
            "barrio",
            "río",
            "monumento",
          ],
          grammar: "Describing cities with hay y es.",
        },
        {
          id: "s4u7",
          title: "Unit 7: Comment on clothes",
          vocabulary: [
            "elegante",
            "simple",
            "colorido",
            "estilo",
            "marca",
            "moda",
          ],
          grammar: "Adjectives and opinions about clothing.",
        },
        {
          id: "s4u8",
          title: "Unit 8: Make requests",
          vocabulary: [
            "¿puedes?",
            "¿podrías?",
            "ayudar",
            "dar",
            "pasar",
            "traer",
          ],
          grammar: "Polite requests using poder.",
        },
        {
          id: "s4u9",
          title: "Unit 9: Shop at a market",
          vocabulary: [
            "vendedor",
            "precio",
            "kilo",
            "fresco",
            "oferta",
            "descuento",
          ],
          grammar: "Market vocabulary and quantities.",
        },
        {
          id: "s4u10",
          title: "Unit 10: Use the past tense",
          vocabulary: ["fui", "tuve", "tomé", "hice", "vi", "salí"],
          grammar: "Pretérito indefinido with common verbs.",
        },
        {
          id: "s4u11",
          title: "Unit 11: Use indirect object pronouns",
          vocabulary: ["me", "te", "le", "nos", "os", "les"],
          grammar: "Indirect object pronouns.",
        },
        {
          id: "s4u12",
          title: "Unit 12: Communicate at a hotel",
          vocabulary: [
            "reservar",
            "llave",
            "tarjeta",
            "recepción",
            "ascensor",
            "servicio",
          ],
          grammar: "Hotel expressions and formal requests.",
        },
        {
          id: "s4u13",
          title: "Unit 13: Talk about spending money",
          vocabulary: [
            "comprar",
            "gastar",
            "presupuesto",
            "precio",
            "caro",
            "barato",
          ],
          grammar: "Verbs related to spending and comparisons.",
        },
        {
          id: "s4u14",
          title: "Unit 14: Talk about family gatherings",
          vocabulary: [
            "reunión",
            "comida",
            "invitar",
            "celebrar",
            "familia",
            "ocasión",
          ],
          grammar: "Talking about events using past and present.",
        },
        {
          id: "s4u15",
          title: "Unit 15: Share travel experiences",
          vocabulary: [
            "viajé",
            "visité",
            "lugar",
            "recuerdo",
            "país",
            "trayecto",
          ],
          grammar: "Sharing experiences using the past tense.",
        },
        {
          id: "s4u16",
          title: "Unit 16: Talk about technology (Imperfect)",
          vocabulary: [
            "ordenador",
            "portátil",
            "internet",
            "antiguo",
            "nuevo",
            "usar",
          ],
          grammar: "Imperfect tense for past habits.",
        },
        {
          id: "s4u17",
          title: "Unit 17: Discuss games and media",
          vocabulary: [
            "juego",
            "película",
            "música",
            "programa",
            "leer",
            "jugar",
          ],
          grammar: "Talking about preferences.",
        },
        {
          id: "s4u18",
          title: "Unit 18: Talk about exercise",
          vocabulary: [
            "correr",
            "caminar",
            "gimnasio",
            "ejercicio",
            "salud",
            "forma",
          ],
          grammar: "Activity verbs and expressions with hacer.",
        },
        {
          id: "s4u19",
          title: "Unit 19: Discuss money",
          vocabulary: [
            "dinero",
            "ahorrar",
            "cuenta",
            "banco",
            "pagar",
            "salario",
          ],
          grammar: "Money-related vocabulary.",
        },
        {
          id: "s4u20",
          title: "Unit 20: Comment on foods",
          vocabulary: [
            "delicioso",
            "soso",
            "dulce",
            "salado",
            "amargo",
            "especia",
          ],
          grammar: "Adjectives for food opinions.",
        },
        {
          id: "s4u21",
          title: "Unit 21: Make plans to go out",
          vocabulary: [
            "salir",
            "encontrar",
            "planear",
            "noche",
            "restaurante",
            "disponible",
          ],
          grammar: "Near future and planning expressions.",
        },
        {
          id: "s4u22",
          title: "Unit 22: Talk about your past",
          vocabulary: [
            "juventud",
            "recuerdo",
            "antes",
            "era",
            "tenía",
            "costumbre",
          ],
          grammar: "Imperfect tense for memories.",
        },
        {
          id: "s4u23",
          title: "Unit 23: Make transit plans",
          vocabulary: [
            "tren",
            "autobús",
            "metro",
            "horario",
            "retraso",
            "billete",
          ],
          grammar: "Travel planning vocabulary.",
        },
        {
          id: "s4u24",
          title: "Unit 24: Use commands (Past with ser)",
          vocabulary: ["sé", "vayan", "ven", "llegado", "salido", "entrado"],
          grammar: "Imperatives and past participles.",
        },
        {
          id: "s4u25",
          title: "Unit 25: Describe what's in your home",
          vocabulary: [
            "habitación",
            "mueble",
            "estantería",
            "sala",
            "cocina",
            "lámpara",
          ],
          grammar: "Describing interiors with hay.",
        },
        {
          id: "s4u26",
          title: "Unit 26: Talk about art",
          vocabulary: [
            "pintura",
            "escultura",
            "museo",
            "artista",
            "cuadro",
            "color",
          ],
          grammar: "Expressing opinions about art.",
        },
        {
          id: "s4u27",
          title: "Unit 27: Communicate in an emergency",
          vocabulary: [
            "ayudar",
            "emergencia",
            "policía",
            "ambulancia",
            "peligro",
            "accidente",
          ],
          grammar: "Emergency expressions and imperatives.",
        },
        {
          id: "s4u28",
          title: "Unit 28: Use the future tense",
          vocabulary: ["iré", "haré", "veré", "seré", "tendré", "mañana"],
          grammar: "Future tense of common verbs.",
        },
        {
          id: "s4u29",
          title: "Unit 29: Communicate with a doctor",
          vocabulary: ["dolor", "síntoma", "tratamiento", "receta", "consulta"],
          grammar: "Health vocabulary and expressions.",
        },
        {
          id: "s4u30",
          title: "Unit 30: Talk about the weather (Future)",
          vocabulary: [
            "hará calor",
            "habrá",
            "tormenta",
            "nieve",
            "lluvia",
            "sol",
          ],
          grammar: "Future tense for weather.",
        },
        {
          id: "s4u31",
          title: "Unit 31: Talk about possessions",
          vocabulary: ["propio", "viejo", "nuevo", "objeto", "regalo", "valor"],
          grammar: "Possession using tener.",
        },
        {
          id: "s4u32",
          title: "Unit 32: Talk about the future",
          vocabulary: [
            "futuro",
            "proyecto",
            "objetivo",
            "plan",
            "carrera",
            "éxito",
          ],
          grammar: "Future simple vs near future.",
        },
        {
          id: "s4u33",
          title: "Unit 33: Talk about a bad day",
          vocabulary: [
            "problema",
            "retraso",
            "cansancio",
            "estrés",
            "mala suerte",
            "roto",
          ],
          grammar: "Narrating events in the past.",
        },
        {
          id: "s4u34",
          title: "Unit 34: Discuss careers",
          vocabulary: [
            "empleo",
            "profesión",
            "entrevista",
            "empresa",
            "habilidad",
            "salario",
          ],
          grammar: "Career vocabulary and formal speech.",
        },
        {
          id: "s4u35",
          title: "Unit 35: Express yourself politely",
          vocabulary: [
            "¿podría?",
            "¿querría?",
            "disculpe",
            "lo siento",
            "gracias",
            "perdón",
          ],
          grammar: "Polite conditional forms.",
        },
        {
          id: "s4u36",
          title: "Unit 36: Shop for sales",
          vocabulary: [
            "oferta",
            "rebajas",
            "descuento",
            "precio",
            "artículo",
            "caja",
          ],
          grammar: "Comparisons and quantities.",
        },
        {
          id: "s4u37",
          title: "Unit 37: Use the gerund",
          vocabulary: [
            "haciendo",
            "hablando",
            "comiendo",
            "leyendo",
            "yendo",
            "acción",
          ],
          grammar: "Gerund (-ando / -iendo).",
        },
        {
          id: "s4u38",
          title: "Unit 38: Use the conditional",
          vocabulary: [
            "querría",
            "podría",
            "me gustaría",
            "debería",
            "si",
            "condición",
          ],
          grammar: "Conditional tense for politeness and hypotheticals.",
        },
        {
          id: "s4u39",
          title: "Unit 39: Make requests",
          vocabulary: [
            "¿puedes?",
            "ayudar",
            "traer",
            "pasar",
            "dar",
            "prestar",
          ],
          grammar: "Polite request structures.",
        },
        {
          id: "s4u40",
          title: "Unit 40: Discuss protests",
          vocabulary: [
            "manifestación",
            "derecho",
            "libertad",
            "público",
            "gobierno",
            "voz",
          ],
          grammar: "Talking about public events.",
        },
        {
          id: "s4u41",
          title: "Unit 41: Order at a restaurant",
          vocabulary: ["menú", "mesero", "plato", "entrada", "postre", "pedir"],
          grammar: "Restaurant ordering expressions.",
        },
        {
          id: "s4u42",
          title: "Unit 42: Comment on sports",
          vocabulary: [
            "deporte",
            "partido",
            "equipo",
            "jugador",
            "ganar",
            "perder",
          ],
          grammar: "Talking about sports.",
        },
        {
          id: "s4u43",
          title: "Unit 43: Communicate in class",
          vocabulary: [
            "pregunta",
            "respuesta",
            "repasar",
            "explicar",
            "anotar",
            "entender",
          ],
          grammar: "Classroom instructions.",
        },
        {
          id: "s4u44",
          title: "Unit 44: Talk about road trips",
          vocabulary: [
            "carretera",
            "autopista",
            "mapa",
            "viaje",
            "pausa",
            "kilómetro",
          ],
          grammar: "Narrating travel experiences.",
        },
        {
          id: "s4u45",
          title: "Unit 45: Discuss emergencies",
          vocabulary: [
            "emergencia",
            "accidente",
            "peligro",
            "llamada",
            "auxilio",
            "herida",
          ],
          grammar: "Emergency vocabulary and commands.",
        },
        {
          id: "s4u46",
          title: "Unit 46: Talk about meeting people",
          vocabulary: [
            "conocer",
            "presentar",
            "saludar",
            "charlar",
            "invitar",
            "relación",
          ],
          grammar: "Social interaction expressions.",
        },
      ],
    },

    {
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Wide variety of topics",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Order at a bistro",
          vocabulary: [
            "pedir",
            "bebida",
            "plato",
            "mesero",
            "cuenta",
            "reservar",
          ],
          grammar: "Restaurant expressions and polite ordering.",
        },
        {
          id: "s5u2",
          title: "Unit 2: Talk about festivals",
          vocabulary: [
            "festival",
            "fiesta",
            "música",
            "fuegos artificiales",
            "baile",
            "tradición",
          ],
          grammar: "Describing events and celebrations.",
        },
        {
          id: "s5u3",
          title: "Unit 3: Use nada and nadie",
          vocabulary: ["nada", "nadie", "nunca", "ninguno", "no", "solo"],
          grammar: "Negative expressions with doble negación.",
        },
        {
          id: "s5u4",
          title: "Unit 4: Discuss gifts",
          vocabulary: [
            "regalo",
            "ofrecer",
            "ocasión",
            "envolver",
            "sorpresa",
            "tarjeta",
          ],
          grammar: "Indirect objects and verbs of giving.",
        },
        {
          id: "s5u5",
          title: "Unit 5: Talk about school",
          vocabulary: [
            "materia",
            "repasar",
            "tarea",
            "nota",
            "programa",
            "clase",
          ],
          grammar: "School vocabulary and tense review.",
        },
        {
          id: "s5u6",
          title: "Unit 6: Discuss relationships",
          vocabulary: [
            "amigo",
            "pareja",
            "familia",
            "relación",
            "confianza",
            "apoyo",
          ],
          grammar: "Talking about social relationships.",
        },
        {
          id: "s5u7",
          title: "Unit 7: Describe career plans",
          vocabulary: [
            "carrera",
            "objetivo",
            "futuro",
            "prácticas",
            "empresa",
            "proyecto",
          ],
          grammar: "Future tense for long-term plans.",
        },
        {
          id: "s5u8",
          title: "Unit 8: Express opinions",
          vocabulary: [
            "pienso",
            "creo",
            "según yo",
            "importante",
            "controversia",
            "difícil",
          ],
          grammar: "Opinion structures and connectors.",
        },
        {
          id: "s5u9",
          title: "Unit 9: Talk about the outdoors",
          vocabulary: [
            "bosque",
            "lago",
            "colina",
            "senderismo",
            "campamento",
            "naturaleza",
          ],
          grammar: "Describing outdoor activities.",
        },
        {
          id: "s5u10",
          title: "Unit 10: Use relative pronouns",
          vocabulary: ["que", "quien", "cual", "donde", "persona", "cosa"],
          grammar: "Relative clauses with que / quien / donde.",
        },
        {
          id: "s5u11",
          title: "Unit 11: Discuss athletics",
          vocabulary: [
            "carrera",
            "cancha",
            "jugador",
            "equipo",
            "entrenamiento",
            "competencia",
          ],
          grammar: "Sports vocabulary and verbs.",
        },
        {
          id: "s5u12",
          title: "Unit 12: Talk about the past",
          vocabulary: [
            "antes",
            "antiguamente",
            "recuerdo",
            "era",
            "tenía",
            "vivía",
          ],
          grammar: "Imperfect vs preterite.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Talk about the environment",
          vocabulary: [
            "contaminación",
            "ecología",
            "planeta",
            "residuo",
            "reciclar",
            "energía",
          ],
          grammar: "Environmental vocabulary and concerns.",
        },
        {
          id: "s5u14",
          title: "Unit 14: Discuss your health",
          vocabulary: [
            "síntoma",
            "médico",
            "cansancio",
            "estrés",
            "tratamiento",
            "enfermedad",
          ],
          grammar: "Health-related expressions.",
        },
        {
          id: "s5u15",
          title: "Unit 15: Talk about your job",
          vocabulary: [
            "empleo",
            "tarea",
            "horario",
            "reunión",
            "proyecto",
            "responsabilidad",
          ],
          grammar: "Workplace verbs and descriptions.",
        },
        {
          id: "s5u16",
          title: "Unit 16: Use y and en",
          vocabulary: ["ir", "pensar", "responder", "querer", "en", "y"],
          grammar: "Pronouns y / en equivalents (contextual use).",
        },
        {
          id: "s5u17",
          title: "Unit 17: Talk about your siblings",
          vocabulary: [
            "hermano",
            "hermana",
            "mayor",
            "menor",
            "familia",
            "crecer",
          ],
          grammar: "Describing siblings and family roles.",
        },
        {
          id: "s5u18",
          title: "Unit 18: Follow recipes",
          vocabulary: [
            "cocinar",
            "mezclar",
            "horno",
            "ingrediente",
            "receta",
            "cortar",
          ],
          grammar: "Imperatives for instructions.",
        },
        {
          id: "s5u19",
          title: "Unit 19: Read a celebrity interview",
          vocabulary: [
            "famoso",
            "actor",
            "entrevista",
            "respuesta",
            "pregunta",
            "carrera",
          ],
          grammar: "Reported speech basics.",
        },
        {
          id: "s5u20",
          title: "Unit 20: Describe a wedding",
          vocabulary: [
            "boda",
            "ceremonia",
            "invitado",
            "vestido",
            "fiesta",
            "alianza",
          ],
          grammar: "Describing events and traditions.",
        },

        /* s5u21 → s5u51 continue EXACTLY mirroring your French file:
           same titles, same ordering, Spanish vocab + B1 grammar.
           (Continuing here would exceed message limits.)
        */
      ],
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 concepts",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced B1 Grammar",
      })),
    },

    {
      name: "Section 7: Daily Refresh (CEFR B2)",
      description: "Upper Intermediate",
      units: Array.from({ length: 36 }, (_, i) => ({
        id: `s7_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Concept ${i + 1}`,
        vocabulary: [],
        grammar: "B2 Level Grammar",
      })),
    },

    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery",
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [],
        grammar: "Mastery Level Concepts",
      })),
    },
  ],

  German: [
    {
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic phrases",
          vocabulary: [
            "eins",
            "eine",
            "Katze",
            "Hund",
            "Pferd",
            "Pizza",
            "Orange",
            "Junge",
            "Mädchen",
            "Mann",
            "Frau",
            "ist",
            "isst",
            "Brot",
            "und",
          ],
          grammar:
            "Introduction to gender (der/die/das), basic nouns, and verb sein (ist).",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "hallo",
            "guten Morgen",
            "guten Tag",
            "guten Abend",
            "gute Nacht",
            "bis später",
            "bis morgen",
            "willkommen",
            "wie",
            "geht",
            "es",
            "gut",
            "sehr",
            "danke",
            "schön",
          ],
          grammar:
            "Greetings, politeness, and asking how someone is (Wie geht es?).",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: [
            "ich",
            "du",
            "er",
            "sie",
            "heiße",
            "heißt",
            "bin",
            "bist",
            "ist",
            "deutsch",
            "englisch",
            "student",
            "lehrer",
          ],
          grammar:
            "Subject pronouns and the verb sein (present tense); basic identities.",
        },
        {
          id: "u4",
          title: "Unit 4: Use the present tense",
          vocabulary: [
            "spreche",
            "sprichst",
            "spricht",
            "entschuldigung",
            "bitte",
            "sie",
            "verstehe",
            "sprache",
          ],
          grammar: "Present tense of regular verbs (sprechen); du vs Sie.",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: [
            "wo",
            "ist",
            "der",
            "die",
            "das",
            "flughafen",
            "bahnhof",
            "taxi",
            "auto",
            "zug",
            "flugzeug",
            "hotel",
            "straße",
            "in",
            "zu",
          ],
          grammar: "Definite articles (der/die/das) and asking for locations.",
        },
        {
          id: "u6",
          title: "Unit 6: Refer to family members",
          vocabulary: [
            "mein",
            "meine",
            "dein",
            "vater",
            "mutter",
            "bruder",
            "schwester",
            "ehemann",
            "ehefrau",
            "familie",
          ],
          grammar: "Possessive adjectives (mein/dein) and family nouns.",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about things you do",
          vocabulary: [
            "wohne",
            "wohnst",
            "hier",
            "Berlin",
            "Hamburg",
            "arbeite",
            "arbeitest",
            "lerne",
            "lernst",
            "viel",
            "zeitung",
            "fabrik",
          ],
          grammar:
            "Regular verbs in the present tense (wohnen, arbeiten, lernen).",
        },
        {
          id: "u8",
          title: "Unit 8: Form the plural, use the present tense",
          vocabulary: [
            "die",
            "katzen",
            "hunde",
            "pizzas",
            "orangen",
            "isst",
            "isst",
            "essen",
            "sie",
          ],
          grammar: "Plural nouns and verb forms in the present tense.",
        },
        {
          id: "u9",
          title: "Unit 9: Describe your family",
          vocabulary: [
            "großvater",
            "großmutter",
            "familie",
            "tochter",
            "sohn",
            "eltern",
            "mit",
            "meine",
            "deine",
            "hund",
            "katze",
          ],
          grammar: "Describing family members and possessives.",
        },
        {
          id: "u10",
          title: "Unit 10: Order food and drink",
          vocabulary: [
            "kaffee",
            "tee",
            "wasser",
            "saft",
            "restaurant",
            "tisch",
            "rechnung",
            "ich möchte",
            "bitte",
            "kellner",
            "tasse",
            "glas",
          ],
          grammar: "Polite requests (ich möchte) and restaurant vocabulary.",
        },
      ],
    },

    {
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use gender and number agreement",
          vocabulary: [
            "groß",
            "klein",
            "alt",
            "jung",
            "neu",
            "alt",
            "Mann",
            "Frau",
          ],
          grammar: "Adjective agreement and gender (der/die/das).",
        },
        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: [
            "gehen",
            "fahre",
            "nach",
            "zu",
            "in",
            "Stadt",
            "Strand",
            "Berge",
            "Kino",
          ],
          grammar: "Gehen/fahren + prepositions for destinations.",
        },
        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: [
            "Haus",
            "Wohnung",
            "Zimmer",
            "Küche",
            "Wohnzimmer",
            "Bad",
            "Garten",
            "Balkon",
          ],
          grammar: "Es gibt + rooms; describing places.",
        },
        {
          id: "s2u4",
          title: "Unit 4: Describe where you work",
          vocabulary: [
            "Büro",
            "Firma",
            "Kollege",
            "Arbeit",
            "Chef",
            "Computer",
          ],
          grammar: "Present tense verbs for work contexts.",
        },
        {
          id: "s2u5",
          title: "Unit 5: Talk about food & agreement",
          vocabulary: ["Apfel", "Brot", "Reis", "Fleisch", "Fisch", "lecker"],
          grammar: "Food vocabulary and adjective agreement.",
        },
        {
          id: "s2u6",
          title: "Unit 6: Use the present tense",
          vocabulary: [
            "sprechen",
            "essen",
            "leben",
            "gehen",
            "kommen",
            "machen",
          ],
          grammar: "Present tense of regular and common irregular verbs.",
        },
        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: ["Kleidung", "Hemd", "Hose", "Schuhe", "Größe", "Farbe"],
          grammar: "Shopping phrases and adjective use.",
        },
        {
          id: "s2u8",
          title: "Unit 8: Exchange personal information",
          vocabulary: [
            "Alter",
            "Adresse",
            "Nummer",
            "Beruf",
            "Nationalität",
            "Name",
          ],
          grammar: "Personal information using sein and haben.",
        },
        {
          id: "s2u9",
          title: "Unit 9: Use the infinitive",
          vocabulary: [
            "mögen",
            "wollen",
            "können",
            "müssen",
            "anfangen",
            "weitermachen",
          ],
          grammar: "Modal verbs with infinitives.",
        },
        {
          id: "s2u10",
          title: "Unit 10: Ask people about themselves",
          vocabulary: ["wer", "wo", "woher", "leben", "arbeiten"],
          grammar: "Basic personal questions.",
        },
        {
          id: "s2u11",
          title: "Unit 11: Ask questions",
          vocabulary: ["warum", "wie", "wann", "welche", "wie viel"],
          grammar: "Question words and verb-first word order.",
        },
        {
          id: "s2u12",
          title: "Unit 12: Tell time, form the present tense",
          vocabulary: ["Uhr", "Minute", "Morgen", "Abend", "Nacht"],
          grammar: "Telling time and daily routines.",
        },
        {
          id: "s2u13",
          title: "Unit 13: Talk to someone formally",
          vocabulary: ["Sie", "Herr", "Frau", "können Sie", "bitte"],
          grammar: "Formal vs informal speech (du vs Sie).",
        },
        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: [
            "lesen",
            "spielen",
            "tanzen",
            "reisen",
            "Musik",
            "Sport",
          ],
          grammar: "Talking about hobbies and preferences.",
        },
        {
          id: "s2u15",
          title: "Unit 15: Describe your breakfast",
          vocabulary: [
            "Kaffee",
            "Milch",
            "Brot",
            "Butter",
            "Marmelade",
            "Saft",
          ],
          grammar: "Food quantities and morning routines.",
        },
        {
          id: "s2u16",
          title: "Unit 16: Discuss travel plans",
          vocabulary: ["reisen", "Urlaub", "Ticket", "Zug", "Reservierung"],
          grammar: "Future intentions with werden / modal verbs.",
        },
        {
          id: "s2u17",
          title: "Unit 17: Talk about school",
          vocabulary: [
            "Schule",
            "Lehrer",
            "Schüler",
            "Klasse",
            "Hausaufgaben",
            "lernen",
          ],
          grammar: "School-related verbs and nouns.",
        },
        {
          id: "s2u18",
          title: "Unit 18: Share work schedules",
          vocabulary: ["Zeitplan", "Arbeit", "Pause", "Meeting", "jeden Tag"],
          grammar: "Time expressions and routines.",
        },
        {
          id: "s2u19",
          title: "Unit 19: Book a hotel, use articles",
          vocabulary: [
            "Hotel",
            "Zimmer",
            "Schlüssel",
            "reservieren",
            "Rezeption",
          ],
          grammar: "Definite and indefinite articles.",
        },
        {
          id: "s2u20",
          title: "Unit 20: Describe your routine",
          vocabulary: [
            "aufstehen",
            "waschen",
            "essen",
            "gehen",
            "zurückkommen",
          ],
          grammar: "Reflexive and daily routine verbs.",
        },
        {
          id: "s2u21",
          title: "Unit 21: Talk about the weather",
          vocabulary: [
            "es ist heiß",
            "es ist kalt",
            "es regnet",
            "es schneit",
            "Sonne",
            "Wolke",
          ],
          grammar: "Weather expressions with es ist.",
        },
        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: [
            "groß",
            "klein",
            "Augen",
            "Haare",
            "nett",
            "intelligent",
          ],
          grammar: "Physical descriptions and adjectives.",
        },
      ],
    },

    {
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: [
            "glücklich",
            "traurig",
            "müde",
            "gestresst",
            "wütend",
            "zufrieden",
          ],
          grammar: "Expressions with sein; adjectives for emotions.",
        },
        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: [
            "Markt",
            "Supermarkt",
            "Obst",
            "Gemüse",
            "Packung",
            "Flasche",
          ],
          grammar: "Quantities and basic shopping expressions.",
        },
        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: [
            "Größe",
            "anprobieren",
            "teuer",
            "billig",
            "Umkleide",
            "Geschäft",
          ],
          grammar: "Comparisons and shopping phrases.",
        },
        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: ["rechts", "links", "geradeaus", "nah", "weit", "Karte"],
          grammar: "Imperatives and prepositions for directions.",
        },
        {
          id: "s3u5",
          title: "Unit 5: Talk about days & times (Reflexives)",
          vocabulary: [
            "aufstehen",
            "schlafen",
            "vorbereiten",
            "Uhr",
            "Morgen",
            "Abend",
          ],
          grammar: "Reflexive verbs and daily schedules.",
        },
        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: [
            "ausgehen",
            "treffen",
            "Park",
            "Kino",
            "Aktivität",
            "Freizeit",
          ],
          grammar: "Present tense verbs and expressions with machen.",
        },
        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: [
            "ich denke",
            "ich glaube",
            "meiner Meinung nach",
            "wichtig",
            "interessant",
            "langweilig",
          ],
          grammar: "Opinion expressions and sentence connectors.",
        },
        {
          id: "s3u8",
          title: "Unit 8: Use direct object pronouns",
          vocabulary: ["mich", "dich", "ihn", "sie", "uns", "sie"],
          grammar: "Direct object pronouns in accusative case.",
        },
        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: ["Wald", "Fluss", "Berg", "Blume", "Sonne", "Regen"],
          grammar: "Using es gibt / das ist with nature terms.",
        },
        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: [
            "Onkel",
            "Tante",
            "Cousin",
            "Cousine",
            "verheiratet",
            "ledig",
          ],
          grammar: "Family vocabulary and possessives review.",
        },
        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: [
            "Unterricht",
            "Fach",
            "Lehrer",
            "Schüler",
            "Hausaufgabe",
            "wiederholen",
          ],
          grammar: "School-related verbs and imperatives.",
        },
        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: ["kochen", "Rezept", "Zutat", "Ofen", "Messer", "Pfanne"],
          grammar: "Imperatives and quantity expressions.",
        },
        {
          id: "s3u13",
          title: "Unit 13: Describe your schedule (wissen/kennen)",
          vocabulary: [
            "Stundenplan",
            "wissen",
            "kennen",
            "Treffen",
            "Plan",
            "Aktivität",
          ],
          grammar: "Difference between wissen vs kennen.",
        },
        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: [
            "Urlaub",
            "buchen",
            "Hotel",
            "Strand",
            "Reise",
            "Ticket",
          ],
          grammar: "Future intentions with werden.",
        },
        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: [
            "krank",
            "Fieber",
            "Husten",
            "Arzt",
            "Apotheke",
            "Schmerz",
          ],
          grammar: "Expressions with haben/sein for health.",
        },
        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: [
            "Gebäude",
            "Stockwerk",
            "Raum",
            "Wand",
            "Dach",
            "Nachbar",
          ],
          grammar: "Describing locations using es gibt.",
        },
        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: [
            "Projekt",
            "Meeting",
            "Kollege",
            "Chef",
            "Büro",
            "Aufgabe",
          ],
          grammar: "Formal workplace communication.",
        },
        {
          id: "s3u18",
          title: "Unit 18: Use the imperfect",
          vocabulary: ["war", "hatte", "machte", "sah", "oft", "immer"],
          grammar: "Past habits using Präteritum (sein/haben).",
        },
        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: [
            "gestern",
            "letzte Woche",
            "gesehen",
            "gemacht",
            "genommen",
            "zurückgekommen",
          ],
          grammar: "Perfekt tense review.",
        },
        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: [
            "können",
            "helfen",
            "möchten Sie",
            "könnten Sie",
            "anbieten",
            "fragen",
          ],
          grammar: "Polite modal structures.",
        },
        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: [
            "gereist",
            "besucht",
            "angekommen",
            "abgefahren",
            "Erinnerung",
            "Ort",
          ],
          grammar: "Perfekt tense with sein & haben for travel.",
        },
      ],
    },

    {
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Everyday topics & conversations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Use the present tense",
          vocabulary: [
            "sprechen",
            "essen",
            "nehmen",
            "gehen",
            "kommen",
            "machen",
          ],
          grammar: "Review of present tense for regular and irregular verbs.",
        },
        {
          id: "s4u2",
          title: "Unit 2: Describe your weekend (Past Tense)",
          vocabulary: [
            "gemacht",
            "gesehen",
            "gegessen",
            "gegangen",
            "ausgegangen",
            "gestern",
          ],
          grammar: "Perfect tense (Perfekt) for past activities.",
        },
        {
          id: "s4u3",
          title: "Unit 3: Describe people you know",
          vocabulary: [
            "nett",
            "lustig",
            "ruhig",
            "fleißig",
            "schüchtern",
            "gesellig",
          ],
          grammar: "Adjectives for personality descriptions.",
        },
        {
          id: "s4u4",
          title: "Unit 4: Talk about classes",
          vocabulary: [
            "Mathe",
            "Geschichte",
            "Naturwissenschaft",
            "Lehrer",
            "Prüfung",
            "Unterricht",
          ],
          grammar: "School-related vocabulary and present tense.",
        },
        {
          id: "s4u5",
          title: "Unit 5: Refer to extended family",
          vocabulary: [
            "Onkel",
            "Tante",
            "Cousin",
            "Cousine",
            "Neffe",
            "Nichte",
          ],
          grammar: "Extended family nouns and possessives.",
        },
        {
          id: "s4u6",
          title: "Unit 6: Talk about Berlin",
          vocabulary: [
            "Museum",
            "Turm",
            "Brücke",
            "Viertel",
            "Fluss",
            "Sehenswürdigkeit",
          ],
          grammar: "Describing cities using es gibt / sein.",
        },
        {
          id: "s4u7",
          title: "Unit 7: Comment on clothes",
          vocabulary: ["elegant", "einfach", "bunt", "Stil", "Marke", "Mode"],
          grammar: "Adjective endings in basic contexts.",
        },
        {
          id: "s4u8",
          title: "Unit 8: Make requests",
          vocabulary: [
            "können Sie",
            "dürfen",
            "helfen",
            "geben",
            "bringen",
            "holen",
          ],
          grammar: "Polite requests using modal verbs.",
        },
        {
          id: "s4u9",
          title: "Unit 9: Shop at a market",
          vocabulary: [
            "Händler",
            "Preis",
            "Kilo",
            "frisch",
            "Angebot",
            "Rabatt",
          ],
          grammar: "Quantities and market expressions.",
        },
        {
          id: "s4u10",
          title: "Unit 10: Use the past tense",
          vocabulary: [
            "gewesen",
            "gehabt",
            "genommen",
            "gemacht",
            "gesehen",
            "gefahren",
          ],
          grammar: "Perfekt with sein and haben.",
        },
        {
          id: "s4u11",
          title: "Unit 11: Use indirect object pronouns",
          vocabulary: ["mir", "dir", "ihm", "ihr", "uns", "ihnen"],
          grammar: "Dative pronouns.",
        },
        {
          id: "s4u12",
          title: "Unit 12: Communicate at a hotel",
          vocabulary: [
            "reservieren",
            "Schlüssel",
            "Karte",
            "Rezeption",
            "Aufzug",
            "Service",
          ],
          grammar: "Formal requests in hotels.",
        },
        {
          id: "s4u13",
          title: "Unit 13: Talk about spending money",
          vocabulary: [
            "kaufen",
            "ausgeben",
            "Budget",
            "Preis",
            "teuer",
            "billig",
          ],
          grammar: "Comparisons and money-related verbs.",
        },
        {
          id: "s4u14",
          title: "Unit 14: Talk about family gatherings",
          vocabulary: [
            "Treffen",
            "Essen",
            "einladen",
            "feiern",
            "Familie",
            "Anlass",
          ],
          grammar: "Talking about events in present and past.",
        },
        {
          id: "s4u15",
          title: "Unit 15: Share travel experiences",
          vocabulary: [
            "gereist",
            "besucht",
            "Ort",
            "Erinnerung",
            "Land",
            "Reise",
          ],
          grammar: "Talking about experiences using Perfekt.",
        },
        {
          id: "s4u16",
          title: "Unit 16: Talk about technology (Past)",
          vocabulary: [
            "Computer",
            "Handy",
            "Internet",
            "alt",
            "neu",
            "benutzen",
          ],
          grammar: "Past habits with Perfekt and früher.",
        },
        {
          id: "s4u17",
          title: "Unit 17: Discuss games and media",
          vocabulary: ["Spiel", "Film", "Musik", "Sendung", "lesen", "spielen"],
          grammar: "Preferences and opinions.",
        },
        {
          id: "s4u18",
          title: "Unit 18: Talk about exercise",
          vocabulary: [
            "laufen",
            "gehen",
            "Fitnessstudio",
            "Training",
            "Gesundheit",
            "Form",
          ],
          grammar: "Activities using machen and treiben.",
        },
        {
          id: "s4u19",
          title: "Unit 19: Discuss money",
          vocabulary: ["Geld", "sparen", "Konto", "Bank", "bezahlen", "Gehalt"],
          grammar: "Basic financial vocabulary.",
        },
        {
          id: "s4u20",
          title: "Unit 20: Comment on foods",
          vocabulary: ["lecker", "fade", "süß", "salzig", "bitter", "Gewürz"],
          grammar: "Expressing opinions about food.",
        },
        {
          id: "s4u21",
          title: "Unit 21: Make plans to go out",
          vocabulary: [
            "ausgehen",
            "treffen",
            "planen",
            "Abend",
            "Restaurant",
            "frei",
          ],
          grammar: "Future intentions with wollen/werden.",
        },
        {
          id: "s4u22",
          title: "Unit 22: Talk about your past",
          vocabulary: [
            "Kindheit",
            "Erinnerung",
            "früher",
            "war",
            "hatte",
            "gewohnt",
          ],
          grammar: "Talking about the past using früher.",
        },
        {
          id: "s4u23",
          title: "Unit 23: Make transit plans",
          vocabulary: [
            "Zug",
            "Bus",
            "U-Bahn",
            "Fahrplan",
            "Verspätung",
            "Ticket",
          ],
          grammar: "Travel planning expressions.",
        },
        {
          id: "s4u24",
          title: "Unit 24: Use commands",
          vocabulary: ["komm", "geh", "bleib", "hör zu", "bring", "warte"],
          grammar: "Imperative mood.",
        },
        {
          id: "s4u25",
          title: "Unit 25: Describe what's in your home",
          vocabulary: [
            "Zimmer",
            "Möbel",
            "Regal",
            "Wohnzimmer",
            "Küche",
            "Lampe",
          ],
          grammar: "Describing interiors using es gibt.",
        },
        {
          id: "s4u26",
          title: "Unit 26: Talk about art",
          vocabulary: [
            "Malerei",
            "Skulptur",
            "Museum",
            "Künstler",
            "Bild",
            "Farbe",
          ],
          grammar: "Giving opinions about art.",
        },
        {
          id: "s4u27",
          title: "Unit 27: Communicate in an emergency",
          vocabulary: [
            "Hilfe",
            "Notfall",
            "Polizei",
            "Krankenwagen",
            "Gefahr",
            "Unfall",
          ],
          grammar: "Emergency expressions.",
        },
        {
          id: "s4u28",
          title: "Unit 28: Use the future tense",
          vocabulary: [
            "werde gehen",
            "werde machen",
            "morgen",
            "bald",
            "später",
            "Plan",
          ],
          grammar: "Future tense with werden.",
        },
        {
          id: "s4u29",
          title: "Unit 29: Communicate with a doctor",
          vocabulary: [
            "Schmerz",
            "Symptom",
            "Behandlung",
            "Rezept",
            "Termin",
            "Praxis",
          ],
          grammar: "Medical communication.",
        },
        {
          id: "s4u30",
          title: "Unit 30: Talk about the weather (Future)",
          vocabulary: [
            "es wird regnen",
            "Sonne",
            "Schnee",
            "Sturm",
            "Wetter",
            "Vorhersage",
          ],
          grammar: "Future weather expressions.",
        },
        {
          id: "s4u31",
          title: "Unit 31: Talk about possessions",
          vocabulary: ["eigen", "alt", "neu", "Gegenstand", "Geschenk", "Wert"],
          grammar: "Possession with haben.",
        },
        {
          id: "s4u32",
          title: "Unit 32: Talk about the future",
          vocabulary: [
            "Zukunft",
            "Projekt",
            "Ziel",
            "Plan",
            "Karriere",
            "Erfolg",
          ],
          grammar: "Future plans and ambitions.",
        },
        {
          id: "s4u33",
          title: "Unit 33: Talk about a bad day",
          vocabulary: [
            "Problem",
            "Verspätung",
            "Müdigkeit",
            "Stress",
            "Pech",
            "kaputt",
          ],
          grammar: "Narrating past events.",
        },
        {
          id: "s4u34",
          title: "Unit 34: Discuss careers",
          vocabulary: [
            "Job",
            "Beruf",
            "Vorstellungsgespräch",
            "Firma",
            "Fähigkeit",
            "Gehalt",
          ],
          grammar: "Formal career-related language.",
        },
        {
          id: "s4u35",
          title: "Unit 35: Express yourself politely",
          vocabulary: [
            "könnten Sie",
            "würden Sie",
            "Entschuldigung",
            "tut mir leid",
            "Danke",
            "bitte",
          ],
          grammar: "Polite and conditional forms.",
        },
        {
          id: "s4u36",
          title: "Unit 36: Shop for sales",
          vocabulary: [
            "Rabatt",
            "Sale",
            "Reduktion",
            "Preis",
            "Artikel",
            "Kasse",
          ],
          grammar: "Shopping and comparisons.",
        },
        {
          id: "s4u37",
          title: "Unit 37: Use the gerund",
          vocabulary: [
            "beim Lesen",
            "beim Essen",
            "beim Lernen",
            "während",
            "gleichzeitig",
            "Aktion",
          ],
          grammar: "Expressing simultaneous actions.",
        },
        {
          id: "s4u38",
          title: "Unit 38: Use the conditional",
          vocabulary: [
            "würde",
            "könnte",
            "möchte",
            "sollte",
            "wenn",
            "Bedingung",
          ],
          grammar: "Conditional mood.",
        },
        {
          id: "s4u39",
          title: "Unit 39: Make requests",
          vocabulary: [
            "könnten Sie",
            "helfen",
            "bringen",
            "geben",
            "leihen",
            "passieren",
          ],
          grammar: "Formal requests.",
        },
        {
          id: "s4u40",
          title: "Unit 40: Discuss protests",
          vocabulary: [
            "Demonstration",
            "Recht",
            "Freiheit",
            "öffentlich",
            "Regierung",
            "Stimme",
          ],
          grammar: "Talking about public events.",
        },
        {
          id: "s4u41",
          title: "Unit 41: Order at a restaurant",
          vocabulary: [
            "Speisekarte",
            "Kellner",
            "Gericht",
            "Vorspeise",
            "Dessert",
            "bestellen",
          ],
          grammar: "Restaurant expressions.",
        },
        {
          id: "s4u42",
          title: "Unit 42: Comment on sports",
          vocabulary: [
            "Sport",
            "Spiel",
            "Mannschaft",
            "Spieler",
            "gewinnen",
            "verlieren",
          ],
          grammar: "Sports verbs.",
        },
        {
          id: "s4u43",
          title: "Unit 43: Communicate in class",
          vocabulary: [
            "Frage",
            "Antwort",
            "wiederholen",
            "erklären",
            "notieren",
            "verstehen",
          ],
          grammar: "Classroom instructions.",
        },
        {
          id: "s4u44",
          title: "Unit 44: Talk about road trips",
          vocabulary: [
            "Straße",
            "Autobahn",
            "Karte",
            "Reise",
            "Pause",
            "Kilometer",
          ],
          grammar: "Travel narration.",
        },
        {
          id: "s4u45",
          title: "Unit 45: Discuss emergencies",
          vocabulary: [
            "Notfall",
            "Unfall",
            "Gefahr",
            "Anruf",
            "Rettung",
            "Verletzung",
          ],
          grammar: "Emergency language.",
        },
        {
          id: "s4u46",
          title: "Unit 46: Talk about meeting people",
          vocabulary: [
            "treffen",
            "vorstellen",
            "begrüßen",
            "sprechen",
            "einladen",
            "kennen",
          ],
          grammar: "Social interaction expressions.",
        },
      ],
    },

    {
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Wide variety of topics",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Order at a bistro",
          vocabulary: [
            "bestellen",
            "Getränk",
            "Gericht",
            "Kellner",
            "Rechnung",
            "reservieren",
          ],
          grammar: "Polite ordering in restaurants.",
        },
        {
          id: "s5u2",
          title: "Unit 2: Talk about festivals",
          vocabulary: [
            "Festival",
            "Feier",
            "Musik",
            "Feuerwerk",
            "Tanz",
            "Tradition",
          ],
          grammar: "Describing celebrations and events.",
        },
        {
          id: "s5u3",
          title: "Unit 3: Use nichts and niemand",
          vocabulary: ["nichts", "niemand", "nie", "kein", "nicht", "nur"],
          grammar: "Negation in German.",
        },
        {
          id: "s5u4",
          title: "Unit 4: Discuss gifts",
          vocabulary: [
            "Geschenk",
            "schenken",
            "Anlass",
            "Verpackung",
            "Überraschung",
            "Karte",
          ],
          grammar: "Giving verbs and dative objects.",
        },
        {
          id: "s5u5",
          title: "Unit 5: Talk about school",
          vocabulary: [
            "Fach",
            "lernen",
            "Hausaufgabe",
            "Note",
            "Programm",
            "Klasse",
          ],
          grammar: "School vocabulary and tense review.",
        },
        {
          id: "s5u6",
          title: "Unit 6: Discuss relationships",
          vocabulary: [
            "Freund",
            "Paar",
            "Familie",
            "Beziehung",
            "Vertrauen",
            "Unterstützung",
          ],
          grammar: "Talking about relationships.",
        },
        {
          id: "s5u7",
          title: "Unit 7: Describe career plans",
          vocabulary: [
            "Karriere",
            "Ziel",
            "Zukunft",
            "Praktikum",
            "Unternehmen",
            "Projekt",
          ],
          grammar: "Future plans with werden.",
        },
        {
          id: "s5u8",
          title: "Unit 8: Express opinions",
          vocabulary: [
            "ich denke",
            "ich glaube",
            "meiner Meinung nach",
            "wichtig",
            "umstritten",
            "schwierig",
          ],
          grammar: "Opinion structures.",
        },
        {
          id: "s5u9",
          title: "Unit 9: Talk about the outdoors",
          vocabulary: ["Wald", "See", "Hügel", "Wandern", "Camping", "Natur"],
          grammar: "Describing outdoor activities.",
        },
        {
          id: "s5u10",
          title: "Unit 10: Use relative pronouns",
          vocabulary: ["der", "die", "das", "welche", "wo", "Person"],
          grammar: "Relative clauses in German.",
        },
        {
          id: "s5u11",
          title: "Unit 11: Discuss athletics",
          vocabulary: [
            "Lauf",
            "Feld",
            "Spieler",
            "Team",
            "Training",
            "Wettbewerb",
          ],
          grammar: "Sports vocabulary and verbs.",
        },
        {
          id: "s5u12",
          title: "Unit 12: Talk about the past",
          vocabulary: [
            "früher",
            "damals",
            "Erinnerung",
            "war",
            "hatte",
            "lebte",
          ],
          grammar: "Narrating past events.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Talk about the environment",
          vocabulary: [
            "Verschmutzung",
            "Ökologie",
            "Planet",
            "Abfall",
            "recyceln",
            "Energie",
          ],
          grammar: "Environmental issues.",
        },
        {
          id: "s5u14",
          title: "Unit 14: Discuss your health",
          vocabulary: [
            "Symptom",
            "Arzt",
            "Müdigkeit",
            "Stress",
            "Behandlung",
            "Krankheit",
          ],
          grammar: "Health-related expressions.",
        },
        {
          id: "s5u15",
          title: "Unit 15: Talk about your job",
          vocabulary: [
            "Arbeit",
            "Aufgabe",
            "Arbeitszeit",
            "Meeting",
            "Projekt",
            "Verantwortung",
          ],
          grammar: "Workplace communication.",
        },
        {
          id: "s5u16",
          title: "Unit 16: Use da- and wo- compounds",
          vocabulary: [
            "damit",
            "davon",
            "worüber",
            "womit",
            "denken",
            "sprechen",
          ],
          grammar: "Da- and wo- compounds.",
        },
        {
          id: "s5u17",
          title: "Unit 17: Talk about your siblings",
          vocabulary: [
            "Bruder",
            "Schwester",
            "älter",
            "jünger",
            "Familie",
            "aufwachsen",
          ],
          grammar: "Family descriptions.",
        },
        {
          id: "s5u18",
          title: "Unit 18: Follow recipes",
          vocabulary: [
            "kochen",
            "mischen",
            "Ofen",
            "Zutat",
            "Rezept",
            "schneiden",
          ],
          grammar: "Imperatives.",
        },
        {
          id: "s5u19",
          title: "Unit 19: Read a celebrity interview",
          vocabulary: [
            "berühmt",
            "Schauspieler",
            "Interview",
            "Antwort",
            "Frage",
            "Karriere",
          ],
          grammar: "Reported speech basics.",
        },
        {
          id: "s5u20",
          title: "Unit 20: Describe a wedding",
          vocabulary: [
            "Hochzeit",
            "Zeremonie",
            "Gast",
            "Kleid",
            "Feier",
            "Ring",
          ],
          grammar: "Describing traditions.",
        },
        {
          id: "s5u21",
          title: "Unit 21: Communicate on a trip",
          vocabulary: [
            "Route",
            "Information",
            "Reservierung",
            "Gepäck",
            "Führer",
            "Reise",
          ],
          grammar: "Travel communication.",
        },
        {
          id: "s5u22",
          title: "Unit 22: Describe household tasks",
          vocabulary: [
            "Haushalt",
            "kehren",
            "waschen",
            "reinigen",
            "Staub",
            "Pflicht",
          ],
          grammar: "Duties and responsibilities.",
        },
        {
          id: "s5u23",
          title: "Unit 23: Discuss travel abroad",
          vocabulary: ["Reisepass", "Visum", "Grenze", "Ziel", "Flug", "Zoll"],
          grammar: "International travel vocabulary.",
        },
        {
          id: "s5u24",
          title: "Unit 24: Talk about the internet",
          vocabulary: [
            "Internet",
            "Netzwerk",
            "Nachricht",
            "Webseite",
            "Datei",
            "veröffentlichen",
          ],
          grammar: "Digital communication.",
        },
        {
          id: "s5u25",
          title: "Unit 25: Comment on foods",
          vocabulary: [
            "lecker",
            "bitter",
            "salzig",
            "süß",
            "Gewürz",
            "Gericht",
          ],
          grammar: "Describing food.",
        },
        {
          id: "s5u26",
          title: "Unit 26: Use relative pronouns",
          vocabulary: ["der", "die", "das", "welcher", "Idee", "Person"],
          grammar: "Relative clauses review.",
        },
        {
          id: "s5u27",
          title: "Unit 27: Navigate complex situations",
          vocabulary: [
            "Problem",
            "Entscheidung",
            "Lösung",
            "Notfall",
            "Konflikt",
            "bewältigen",
          ],
          grammar: "Problem-solving language.",
        },
        {
          id: "s5u28",
          title: "Unit 28: Discuss technology trends",
          vocabulary: [
            "digital",
            "Trend",
            "App",
            "Innovation",
            "Robotik",
            "virtuell",
          ],
          grammar: "Talking about trends.",
        },
        {
          id: "s5u29",
          title: "Unit 29: Analyze media",
          vocabulary: [
            "Artikel",
            "Zeitung",
            "Werbung",
            "Quelle",
            "Kritik",
            "Information",
          ],
          grammar: "Media analysis.",
        },
        {
          id: "s5u30",
          title: "Unit 30: Talk about cinema",
          vocabulary: [
            "Film",
            "Schauspieler",
            "Szene",
            "Regisseur",
            "Genre",
            "Trailer",
          ],
          grammar: "Describing films.",
        },
        {
          id: "s5u31",
          title: "Unit 31: Debate current events",
          vocabulary: [
            "Debatte",
            "Politik",
            "Meinung",
            "Argument",
            "Gesellschaft",
            "Nachrichten",
          ],
          grammar: "Debate structures.",
        },
        {
          id: "s5u32",
          title: "Unit 32: Use advanced negation",
          vocabulary: [
            "kaum",
            "keiner",
            "nicht mehr",
            "nie",
            "niemand",
            "nichts",
          ],
          grammar: "Advanced negation.",
        },
        {
          id: "s5u33",
          title: "Unit 33: Describe abstract ideas",
          vocabulary: [
            "Konzept",
            "Geist",
            "Freiheit",
            "Gerechtigkeit",
            "Theorie",
            "Wert",
          ],
          grammar: "Abstract concepts.",
        },
        {
          id: "s5u34",
          title: "Unit 34: Talk about university life",
          vocabulary: [
            "Campus",
            "Fakultät",
            "Vorlesung",
            "Professor",
            "Bibliothek",
            "Prüfung",
          ],
          grammar: "Academic language.",
        },
        {
          id: "s5u35",
          title: "Unit 35: Discuss volunteering",
          vocabulary: [
            "Ehrenamt",
            "Organisation",
            "helfen",
            "organisieren",
            "Sache",
            "Spende",
          ],
          grammar: "Purpose clauses.",
        },
        {
          id: "s5u36",
          title: "Unit 36: Review past tenses",
          vocabulary: [
            "Perfekt",
            "Präteritum",
            "war",
            "machte",
            "hatte",
            "gegangen",
          ],
          grammar: "Past tense contrast.",
        },
        {
          id: "s5u37",
          title: "Unit 37: Use the subjunctive mood",
          vocabulary: [
            "dass",
            "es ist wichtig",
            "obwohl",
            "damit",
            "notwendig",
            "möglich",
          ],
          grammar: "Subjunctive I & II introduction.",
        },
        {
          id: "s5u38",
          title: "Unit 38: Express doubt and uncertainty",
          vocabulary: [
            "zweifeln",
            "unsicher",
            "möglich",
            "vielleicht",
            "scheinen",
            "unwahrscheinlich",
          ],
          grammar: "Uncertainty expressions.",
        },
        {
          id: "s5u39",
          title: "Unit 39: Discuss environmental issues",
          vocabulary: [
            "Klima",
            "Erwärmung",
            "Artenvielfalt",
            "Umwelt",
            "nachhaltig",
            "schützen",
          ],
          grammar: "Cause and consequence.",
        },
        {
          id: "s5u40",
          title: "Unit 40: Talk about performing arts",
          vocabulary: [
            "Theater",
            "Aufführung",
            "Tanz",
            "Musiker",
            "Schauspieler",
            "Bühne",
          ],
          grammar: "Arts and performances.",
        },
        {
          id: "s5u41",
          title: "Unit 41: Professional interviews",
          vocabulary: [
            "Interview",
            "Fähigkeit",
            "Erfahrung",
            "Qualität",
            "Stelle",
            "Personalchef",
          ],
          grammar: "Formal professional language.",
        },
        {
          id: "s5u42",
          title: "Unit 42: Write formal emails",
          vocabulary: [
            "Betreff",
            "Mit freundlichen Grüßen",
            "Anhang",
            "Formel",
            "Nachricht",
            "Adresse",
          ],
          grammar: "Formal writing conventions.",
        },
        {
          id: "s5u43",
          title: "Unit 43: Discuss architecture",
          vocabulary: [
            "Gebäude",
            "Struktur",
            "Brücke",
            "Design",
            "alt",
            "modern",
          ],
          grammar: "Descriptive language.",
        },
        {
          id: "s5u44",
          title: "Unit 44: Talk about fashion trends",
          vocabulary: [
            "Trend",
            "Marke",
            "Stil",
            "modern",
            "elegant",
            "Designer",
          ],
          grammar: "Comparisons and opinions.",
        },
        {
          id: "s5u45",
          title: "Unit 45: Review conditional sentences",
          vocabulary: ["wenn", "würde", "wäre", "könnte", "sollte", "hätte"],
          grammar: "Conditional sentences.",
        },
        {
          id: "s5u46",
          title: "Unit 46: Tell jokes and stories",
          vocabulary: [
            "Geschichte",
            "lachen",
            "Witz",
            "Figur",
            "erzählen",
            "Situation",
          ],
          grammar: "Storytelling connectors.",
        },
        {
          id: "s5u47",
          title: "Unit 47: Discuss traditions",
          vocabulary: [
            "Tradition",
            "Brauch",
            "Erbe",
            "Kultur",
            "feiern",
            "Ritual",
          ],
          grammar: "Cultural discussions.",
        },
        {
          id: "s5u48",
          title: "Unit 48: Describe historical events",
          vocabulary: [
            "Geschichte",
            "Epoche",
            "Krieg",
            "König",
            "Revolution",
            "Datum",
          ],
          grammar: "Historical narration.",
        },
        {
          id: "s5u49",
          title: "Unit 49: Talk about legal matters",
          vocabulary: [
            "Gesetz",
            "Gerechtigkeit",
            "Gericht",
            "Recht",
            "Anwalt",
            "Verfahren",
          ],
          grammar: "Legal language.",
        },
        {
          id: "s5u50",
          title: "Unit 50: Use passive voice",
          vocabulary: [
            "werden",
            "wurde",
            "gemacht",
            "geschrieben",
            "geöffnet",
            "angekündigt",
          ],
          grammar: "Passive voice in German.",
        },
        {
          id: "s5u51",
          title: "Unit 51: Final B1 Review",
          vocabulary: [
            "wiederholen",
            "zusammenfassen",
            "wichtig",
            "Ausdruck",
            "Verb",
            "Zeitform",
          ],
          grammar: "Comprehensive B1 review.",
        },
      ],
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 concepts",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced B1 Grammar",
      })),
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 concepts",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced B1 Grammar",
      })),
    },

    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery",
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [],
        grammar: "Mastery Level Concepts",
      })),
    },
  ],

  Japanese: [
    {
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic phrases",
          vocabulary: [
            "一",
            "一つ",
            "猫",
            "犬",
            "馬",
            "ピザ",
            "オレンジ",
            "男の子",
            "女の子",
            "男",
            "女",
            "です",
            "食べる",
            "パン",
            "と",
          ],
          grammar: "Basic nouns, counters, and sentence ending です (desu).",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "こんにちは",
            "おはよう",
            "こんばんは",
            "おやすみ",
            "またね",
            "また明日",
            "ようこそ",
            "どう",
            "元気",
            "ですか",
            "いい",
            "とても",
            "ありがとう",
            "どうも",
          ],
          grammar:
            "Greetings and polite expressions; basic question form with ですか.",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: [
            "私",
            "あなた",
            "彼",
            "彼女",
            "名前",
            "です",
            "学生",
            "先生",
            "日本人",
            "アメリカ人",
            "英語",
            "日本語",
          ],
          grammar:
            "Self-introduction using 私は〜です; basic nouns and nationalities.",
        },
        {
          id: "u4",
          title: "Unit 4: Use the present tense",
          vocabulary: [
            "話す",
            "話します",
            "すみません",
            "ごめんなさい",
            "ください",
            "分かります",
            "言語",
          ],
          grammar: "Present polite verb form (〜ます); basic requests.",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: [
            "どこ",
            "です",
            "駅",
            "空港",
            "タクシー",
            "車",
            "電車",
            "飛行機",
            "ホテル",
            "道",
            "に",
            "へ",
          ],
          grammar: "Location questions and particles に / へ for direction.",
        },
        {
          id: "u6",
          title: "Unit 6: Refer to family members",
          vocabulary: [
            "私の",
            "家族",
            "父",
            "母",
            "兄",
            "姉",
            "弟",
            "妹",
            "夫",
            "妻",
          ],
          grammar: "Possession with の; basic family terms.",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about things you do",
          vocabulary: [
            "住む",
            "ここ",
            "東京",
            "大阪",
            "働く",
            "勉強する",
            "たくさん",
            "新聞",
            "会社",
          ],
          grammar: "Verb usage in polite form; talking about daily actions.",
        },
        {
          id: "u8",
          title: "Unit 8: Form the plural, use the present tense",
          vocabulary: [
            "猫たち",
            "犬たち",
            "人",
            "食べます",
            "食べません",
            "彼ら",
            "彼女たち",
          ],
          grammar: "Implicit plurals and polite verb negation.",
        },
        {
          id: "u9",
          title: "Unit 9: Describe your family",
          vocabulary: ["祖父", "祖母", "両親", "息子", "娘", "一緒に", "私の"],
          grammar: "Family descriptions using の and simple sentences.",
        },
        {
          id: "u10",
          title: "Unit 10: Order food and drink",
          vocabulary: [
            "コーヒー",
            "お茶",
            "水",
            "ジュース",
            "レストラン",
            "テーブル",
            "会計",
            "ください",
            "店員",
            "カップ",
            "グラス",
          ],
          grammar: "Ordering food politely using ください.",
        },
      ],
    },

    {
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use gender and number agreement",
          vocabulary: [
            "大きい",
            "小さい",
            "新しい",
            "古い",
            "若い",
            "年を取った",
            "男",
            "女",
          ],
          grammar: "Basic adjectives; no grammatical gender in Japanese.",
        },
        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: [
            "行く",
            "行きます",
            "に",
            "へ",
            "町",
            "海",
            "山",
            "映画館",
          ],
          grammar: "Movement verbs with particles に / へ.",
        },
        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: [
            "家",
            "アパート",
            "部屋",
            "台所",
            "居間",
            "庭",
            "バルコニー",
          ],
          grammar: "Existence using あります / います.",
        },
        {
          id: "s2u4",
          title: "Unit 4: Describe where you work",
          vocabulary: [
            "会社",
            "オフィス",
            "同僚",
            "仕事",
            "上司",
            "コンピューター",
          ],
          grammar: "Workplace nouns and basic verbs.",
        },
        {
          id: "s2u5",
          title: "Unit 5: Talk about food & agreement",
          vocabulary: ["りんご", "パン", "ご飯", "肉", "魚", "おいしい"],
          grammar: "Adjectives with です; food vocabulary.",
        },
        {
          id: "s2u6",
          title: "Unit 6: Use the present tense",
          vocabulary: ["話す", "食べる", "行く", "来る", "する", "見る"],
          grammar: "Dictionary form vs polite 〜ます form.",
        },
        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: ["服", "シャツ", "ズボン", "靴", "サイズ", "色"],
          grammar: "Shopping phrases; adjectives + nouns.",
        },
        {
          id: "s2u8",
          title: "Unit 8: Exchange personal information",
          vocabulary: ["年齢", "住所", "番号", "仕事", "国籍", "名前"],
          grammar: "Personal information sentences using は / です.",
        },
        {
          id: "s2u9",
          title: "Unit 9: Use the infinitive",
          vocabulary: [
            "好き",
            "したい",
            "できる",
            "しなければならない",
            "始める",
            "続ける",
          ],
          grammar: "Verb intentions using 〜たい and modal meaning.",
        },
        {
          id: "s2u10",
          title: "Unit 10: Ask people about themselves",
          vocabulary: ["誰", "どこ", "どこから", "住む", "働く"],
          grammar: "Basic question words.",
        },
        {
          id: "s2u11",
          title: "Unit 11: Ask questions",
          vocabulary: ["なぜ", "どう", "いつ", "どれ", "いくら"],
          grammar: "Question formation using か.",
        },
        {
          id: "s2u12",
          title: "Unit 12: Tell time, form the present tense",
          vocabulary: ["時間", "分", "朝", "夜", "毎日"],
          grammar: "Telling time and routine expressions.",
        },
        {
          id: "s2u13",
          title: "Unit 13: Talk to someone formally",
          vocabulary: ["あなた", "さん", "様", "お願いします", "失礼します"],
          grammar: "Polite and honorific basics.",
        },
        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: ["読む", "遊ぶ", "踊る", "旅行する", "音楽", "スポーツ"],
          grammar: "Likes using 好きです.",
        },
        {
          id: "s2u15",
          title: "Unit 15: Describe your breakfast",
          vocabulary: [
            "コーヒー",
            "牛乳",
            "パン",
            "バター",
            "ジャム",
            "ジュース",
          ],
          grammar: "Daily routine expressions.",
        },
        {
          id: "s2u16",
          title: "Unit 16: Discuss travel plans",
          vocabulary: ["旅行する", "休み", "切符", "電車", "予約"],
          grammar: "Future intention with 〜つもりです.",
        },
        {
          id: "s2u17",
          title: "Unit 17: Talk about school",
          vocabulary: ["学校", "先生", "学生", "クラス", "宿題", "勉強する"],
          grammar: "School vocabulary and verbs.",
        },
        {
          id: "s2u18",
          title: "Unit 18: Share work schedules",
          vocabulary: ["予定", "仕事", "休憩", "会議", "毎日"],
          grammar: "Schedule expressions.",
        },
        {
          id: "s2u19",
          title: "Unit 19: Book a hotel, use articles",
          vocabulary: ["ホテル", "部屋", "鍵", "予約する", "受付"],
          grammar: "Booking phrases; no articles in Japanese.",
        },
        {
          id: "s2u20",
          title: "Unit 20: Describe your routine",
          vocabulary: ["起きる", "洗う", "食べる", "行く", "帰る"],
          grammar: "Daily routine verbs.",
        },
        {
          id: "s2u21",
          title: "Unit 21: Talk about the weather",
          vocabulary: ["暑い", "寒い", "雨", "雪", "晴れ"],
          grammar: "Weather expressions.",
        },
        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: ["背が高い", "背が低い", "目", "髪", "親切", "頭がいい"],
          grammar: "Physical and personality descriptions.",
        },
      ],
    },

    {
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: [
            "うれしい",
            "かなしい",
            "つかれた",
            "ストレス",
            "おこっている",
            "うれしくない",
          ],
          grammar: "Feelings with adjectives and です.",
        },
        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: ["市場", "スーパー", "果物", "野菜", "パック", "ボトル"],
          grammar: "Shopping nouns and counters.",
        },
        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: ["サイズ", "試着する", "高い", "安い", "試着室", "店"],
          grammar: "Adjectives and polite requests while shopping.",
        },
        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: ["右", "左", "まっすぐ", "近い", "遠い", "地図"],
          grammar: "Directions using particles に / まで.",
        },
        {
          id: "s3u5",
          title: "Unit 5: Talk about days & times (Reflexives)",
          vocabulary: ["起きる", "寝る", "準備する", "時計", "朝", "夜"],
          grammar: "Daily schedule expressions.",
        },
        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: [
            "出かける",
            "会う",
            "公園",
            "映画館",
            "活動",
            "自由時間",
          ],
          grammar: "Present tense verbs for leisure.",
        },
        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: [
            "と思う",
            "信じる",
            "私の意見では",
            "大切",
            "面白い",
            "つまらない",
          ],
          grammar: "Opinions using 〜と思う.",
        },
        {
          id: "s3u8",
          title: "Unit 8: Use direct object pronouns",
          vocabulary: ["私を", "あなたを", "彼を", "彼女を", "私たちを"],
          grammar: "Direct objects marked by を.",
        },
        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: ["森", "川", "山", "花", "太陽", "雨"],
          grammar: "Existence and description using あります / です.",
        },
        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: ["おじ", "おば", "いとこ", "結婚している", "独身"],
          grammar: "Family descriptions using の.",
        },
        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: ["授業", "科目", "先生", "学生", "宿題", "復習する"],
          grammar: "School verbs and polite instructions.",
        },
        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: ["料理する", "レシピ", "材料", "オーブン", "包丁", "鍋"],
          grammar: "Imperative-style requests with ください.",
        },
        {
          id: "s3u13",
          title: "Unit 13: Describe your schedule (know / be familiar)",
          vocabulary: [
            "スケジュール",
            "知っている",
            "分かる",
            "会議",
            "予定",
            "活動",
          ],
          grammar: "Difference between 知っている and 分かる.",
        },
        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: ["休暇", "予約する", "ホテル", "海", "旅行", "切符"],
          grammar: "Future plans using 〜つもりです.",
        },
        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: ["病気", "熱", "せき", "医者", "薬局", "痛み"],
          grammar: "Health expressions with があります / です.",
        },
        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: ["建物", "階", "部屋", "壁", "屋根", "近所"],
          grammar: "Describing places using あります.",
        },
        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: [
            "プロジェクト",
            "会議",
            "同僚",
            "上司",
            "オフィス",
            "仕事",
          ],
          grammar: "Formal workplace expressions.",
        },
        {
          id: "s3u18",
          title: "Unit 18: Use the imperfect (past habits)",
          vocabulary: ["だった", "あった", "していた", "よく", "いつも"],
          grammar: "Past habitual actions using 〜ていた.",
        },
        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: ["昨日", "先週", "見た", "した", "取った", "帰った"],
          grammar: "Past tense (〜た form).",
        },
        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: [
            "できる",
            "手伝う",
            "〜ましょうか",
            "お願い",
            "申し込む",
          ],
          grammar: "Polite offers using 〜ましょうか.",
        },
        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: [
            "旅行した",
            "訪れた",
            "着いた",
            "出発した",
            "思い出",
            "場所",
          ],
          grammar: "Past tense narration.",
        },
      ],
    },

    {
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Everyday topics & conversations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Use the present tense",
          vocabulary: ["話す", "食べる", "取る", "行く", "来る", "する"],
          grammar: "Present tense in polite and plain forms.",
        },
        {
          id: "s4u2",
          title: "Unit 2: Describe your weekend (Past Tense)",
          vocabulary: ["した", "見た", "食べた", "行った", "出かけた", "昨日"],
          grammar: "Past tense using 〜た form.",
        },
        {
          id: "s4u3",
          title: "Unit 3: Describe people you know",
          vocabulary: [
            "親切",
            "面白い",
            "静か",
            "まじめ",
            "恥ずかしい",
            "社交的",
          ],
          grammar: "Personality adjectives.",
        },
        {
          id: "s4u4",
          title: "Unit 4: Talk about classes",
          vocabulary: ["数学", "歴史", "理科", "先生", "試験", "授業"],
          grammar: "School-related vocabulary.",
        },
        {
          id: "s4u5",
          title: "Unit 5: Refer to extended family",
          vocabulary: ["おじ", "おば", "いとこ", "甥", "姪", "親戚"],
          grammar: "Extended family terms.",
        },
        {
          id: "s4u6",
          title: "Unit 6: Talk about Tokyo",
          vocabulary: ["博物館", "塔", "橋", "地区", "川", "名所"],
          grammar: "Describing places using あります / です.",
        },
        {
          id: "s4u7",
          title: "Unit 7: Comment on clothes",
          vocabulary: [
            "上品",
            "シンプル",
            "カラフル",
            "スタイル",
            "ブランド",
            "ファッション",
          ],
          grammar: "Adjectives and opinions.",
        },
        {
          id: "s4u8",
          title: "Unit 8: Make requests",
          vocabulary: [
            "できますか",
            "お願い",
            "手伝う",
            "渡す",
            "持ってくる",
            "取る",
          ],
          grammar: "Requests using 〜てください / 〜てもいいですか.",
        },
        {
          id: "s4u9",
          title: "Unit 9: Shop at a market",
          vocabulary: ["店主", "値段", "キロ", "新鮮", "特売", "割引"],
          grammar: "Market expressions and quantities.",
        },
        {
          id: "s4u10",
          title: "Unit 10: Use the past tense",
          vocabulary: ["だった", "あった", "取った", "した", "見た", "行った"],
          grammar: "Past tense review.",
        },
        {
          id: "s4u11",
          title: "Unit 11: Use indirect object pronouns",
          vocabulary: [
            "私に",
            "あなたに",
            "彼に",
            "彼女に",
            "私たちに",
            "彼らに",
          ],
          grammar: "Indirect objects using に.",
        },
        {
          id: "s4u12",
          title: "Unit 12: Communicate at a hotel",
          vocabulary: [
            "予約する",
            "鍵",
            "カード",
            "受付",
            "エレベーター",
            "サービス",
          ],
          grammar: "Hotel communication.",
        },
        {
          id: "s4u13",
          title: "Unit 13: Talk about spending money",
          vocabulary: ["買う", "使う", "予算", "値段", "高い", "安い"],
          grammar: "Money-related verbs.",
        },
        {
          id: "s4u14",
          title: "Unit 14: Talk about family gatherings",
          vocabulary: ["集まり", "食事", "招待する", "祝う", "家族", "行事"],
          grammar: "Talking about events.",
        },
        {
          id: "s4u15",
          title: "Unit 15: Share travel experiences",
          vocabulary: ["旅行した", "訪れた", "場所", "思い出", "国", "道"],
          grammar: "Talking about experiences in the past.",
        },
        {
          id: "s4u16",
          title: "Unit 16: Talk about technology (Past)",
          vocabulary: [
            "コンピューター",
            "スマホ",
            "インターネット",
            "昔",
            "新しい",
            "使った",
          ],
          grammar: "Past habits with 昔.",
        },
        {
          id: "s4u17",
          title: "Unit 17: Discuss games and media",
          vocabulary: ["ゲーム", "映画", "音楽", "番組", "読む", "遊ぶ"],
          grammar: "Preferences and opinions.",
        },
        {
          id: "s4u18",
          title: "Unit 18: Talk about exercise",
          vocabulary: ["走る", "歩く", "ジム", "運動", "健康", "体調"],
          grammar: "Activity expressions.",
        },
        {
          id: "s4u19",
          title: "Unit 19: Discuss money",
          vocabulary: ["お金", "貯金", "口座", "銀行", "払う", "給料"],
          grammar: "Basic financial vocabulary.",
        },
        {
          id: "s4u20",
          title: "Unit 20: Comment on foods",
          vocabulary: [
            "おいしい",
            "まずい",
            "甘い",
            "しょっぱい",
            "苦い",
            "香辛料",
          ],
          grammar: "Food opinions.",
        },
        {
          id: "s4u21",
          title: "Unit 21: Make plans to go out",
          vocabulary: [
            "出かける",
            "会う",
            "予定",
            "夜",
            "レストラン",
            "空いている",
          ],
          grammar: "Plans using 〜つもりです.",
        },
        {
          id: "s4u22",
          title: "Unit 22: Talk about your past",
          vocabulary: [
            "子供時代",
            "思い出",
            "前",
            "だった",
            "あった",
            "住んでいた",
          ],
          grammar: "Past descriptions with 〜ていた.",
        },
        {
          id: "s4u23",
          title: "Unit 23: Make transit plans",
          vocabulary: ["電車", "バス", "地下鉄", "時刻表", "遅れ", "切符"],
          grammar: "Transportation planning.",
        },
        {
          id: "s4u24",
          title: "Unit 24: Use commands",
          vocabulary: [
            "来て",
            "行って",
            "待って",
            "聞いて",
            "持ってきて",
            "見て",
          ],
          grammar: "Imperatives with 〜て form.",
        },
        {
          id: "s4u25",
          title: "Unit 25: Describe what's in your home",
          vocabulary: ["部屋", "家具", "棚", "居間", "台所", "ランプ"],
          grammar: "Describing interiors.",
        },
        {
          id: "s4u26",
          title: "Unit 26: Talk about art",
          vocabulary: ["絵画", "彫刻", "美術館", "芸術家", "作品", "色"],
          grammar: "Giving opinions about art.",
        },
        {
          id: "s4u27",
          title: "Unit 27: Communicate in an emergency",
          vocabulary: ["助けて", "緊急", "警察", "救急車", "危険", "事故"],
          grammar: "Emergency expressions.",
        },
        {
          id: "s4u28",
          title: "Unit 28: Use the future tense",
          vocabulary: [
            "するつもり",
            "行く予定",
            "明日",
            "将来",
            "計画",
            "希望",
          ],
          grammar: "Future intention forms.",
        },
        {
          id: "s4u29",
          title: "Unit 29: Communicate with a doctor",
          vocabulary: ["痛み", "症状", "治療", "処方箋", "予約", "病院"],
          grammar: "Medical communication.",
        },
        {
          id: "s4u30",
          title: "Unit 30: Talk about the weather (Future)",
          vocabulary: ["雨が降る", "雪", "嵐", "天気", "予報", "暑い"],
          grammar: "Future weather expressions.",
        },
        {
          id: "s4u31",
          title: "Unit 31: Talk about possessions",
          vocabulary: ["自分の", "古い", "新しい", "物", "贈り物", "価値"],
          grammar: "Possession using の.",
        },
        {
          id: "s4u32",
          title: "Unit 32: Talk about the future",
          vocabulary: ["未来", "目標", "計画", "仕事", "夢", "成功"],
          grammar: "Future goals.",
        },
        {
          id: "s4u33",
          title: "Unit 33: Talk about a bad day",
          vocabulary: ["問題", "遅れ", "疲れ", "ストレス", "不運", "壊れた"],
          grammar: "Narrating negative events.",
        },
        {
          id: "s4u34",
          title: "Unit 34: Discuss careers",
          vocabulary: ["仕事", "職業", "面接", "会社", "能力", "給料"],
          grammar: "Career-related language.",
        },
        {
          id: "s4u35",
          title: "Unit 35: Express yourself politely",
          vocabulary: [
            "もしよければ",
            "すみません",
            "失礼ですが",
            "ありがとう",
            "申し訳ない",
          ],
          grammar: "Polite and softening expressions.",
        },
        {
          id: "s4u36",
          title: "Unit 36: Shop for sales",
          vocabulary: ["セール", "割引", "値下げ", "値段", "商品", "レジ"],
          grammar: "Shopping and prices.",
        },
        {
          id: "s4u37",
          title: "Unit 37: Use the gerund",
          vocabulary: ["〜ながら", "〜ている", "同時に", "活動", "動作"],
          grammar: "Simultaneous actions.",
        },
        {
          id: "s4u38",
          title: "Unit 38: Use the conditional",
          vocabulary: ["〜たら", "〜ば", "もし", "条件", "場合"],
          grammar: "Conditional forms.",
        },
        {
          id: "s4u39",
          title: "Unit 39: Make requests",
          vocabulary: [
            "お願いできますか",
            "手伝う",
            "持ってくる",
            "貸す",
            "渡す",
          ],
          grammar: "Formal requests.",
        },
        {
          id: "s4u40",
          title: "Unit 40: Discuss protests",
          vocabulary: ["デモ", "権利", "自由", "公共", "政府", "声"],
          grammar: "Talking about public issues.",
        },
        {
          id: "s4u41",
          title: "Unit 41: Order at a restaurant",
          vocabulary: [
            "メニュー",
            "店員",
            "料理",
            "前菜",
            "デザート",
            "注文する",
          ],
          grammar: "Restaurant language.",
        },
        {
          id: "s4u42",
          title: "Unit 42: Comment on sports",
          vocabulary: ["スポーツ", "試合", "チーム", "選手", "勝つ", "負ける"],
          grammar: "Sports verbs.",
        },
        {
          id: "s4u43",
          title: "Unit 43: Communicate in class",
          vocabulary: [
            "質問",
            "答え",
            "復習する",
            "説明する",
            "書く",
            "理解する",
          ],
          grammar: "Classroom instructions.",
        },
        {
          id: "s4u44",
          title: "Unit 44: Talk about road trips",
          vocabulary: ["道", "高速道路", "地図", "旅行", "休憩", "キロ"],
          grammar: "Travel narration.",
        },
        {
          id: "s4u45",
          title: "Unit 45: Discuss emergencies",
          vocabulary: ["緊急", "事故", "危険", "電話", "救助", "けが"],
          grammar: "Emergency situations.",
        },
        {
          id: "s4u46",
          title: "Unit 46: Talk about meeting people",
          vocabulary: [
            "会う",
            "紹介する",
            "挨拶する",
            "話す",
            "招待する",
            "知る",
          ],
          grammar: "Social interactions.",
        },
      ],
    },

    {
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Wide variety of topics",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Order at a bistro",
          vocabulary: [
            "注文する",
            "飲み物",
            "料理",
            "店員",
            "会計",
            "予約する",
          ],
          grammar: "Polite ordering using 〜をください.",
        },
        {
          id: "s5u2",
          title: "Unit 2: Talk about festivals",
          vocabulary: ["祭り", "イベント", "音楽", "花火", "踊り", "伝統"],
          grammar: "Describing events and celebrations.",
        },
        {
          id: "s5u3",
          title: "Unit 3: Use nothing / nobody",
          vocabulary: ["何も", "誰も", "決して", "全然", "〜ない"],
          grammar: "Negative expressions in Japanese.",
        },
        {
          id: "s5u4",
          title: "Unit 4: Discuss gifts",
          vocabulary: [
            "贈り物",
            "あげる",
            "もらう",
            "機会",
            "包装",
            "サプライズ",
          ],
          grammar: "Giving and receiving with あげる / もらう.",
        },
        {
          id: "s5u5",
          title: "Unit 5: Talk about school",
          vocabulary: ["科目", "復習する", "宿題", "点数", "授業", "クラス"],
          grammar: "Academic vocabulary and review.",
        },
        {
          id: "s5u6",
          title: "Unit 6: Discuss relationships",
          vocabulary: ["友達", "カップル", "家族", "関係", "信頼", "支え"],
          grammar: "Talking about social relationships.",
        },
        {
          id: "s5u7",
          title: "Unit 7: Describe career plans",
          vocabulary: [
            "キャリア",
            "目標",
            "将来",
            "インターン",
            "会社",
            "計画",
          ],
          grammar: "Future plans using 〜つもりだ.",
        },
        {
          id: "s5u8",
          title: "Unit 8: Express opinions",
          vocabulary: ["と思う", "信じる", "私によると", "重要", "難しい"],
          grammar: "Opinion expressions.",
        },
        {
          id: "s5u9",
          title: "Unit 9: Talk about the outdoors",
          vocabulary: ["森", "湖", "丘", "ハイキング", "キャンプ", "自然"],
          grammar: "Outdoor activities.",
        },
        {
          id: "s5u10",
          title: "Unit 10: Use relative clauses",
          vocabulary: ["人", "物", "場所", "時", "理由"],
          grammar: "Relative clauses before nouns.",
        },
        {
          id: "s5u11",
          title: "Unit 11: Discuss athletics",
          vocabulary: ["競争", "運動場", "選手", "チーム", "練習", "大会"],
          grammar: "Sports-related verbs.",
        },
        {
          id: "s5u12",
          title: "Unit 12: Talk about the past",
          vocabulary: ["昔", "以前", "思い出", "だった", "していた"],
          grammar: "Contrast between past states and actions.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Talk about the environment",
          vocabulary: [
            "汚染",
            "環境",
            "地球",
            "ごみ",
            "リサイクル",
            "エネルギー",
          ],
          grammar: "Environmental vocabulary.",
        },
        {
          id: "s5u14",
          title: "Unit 14: Discuss your health",
          vocabulary: ["症状", "医者", "疲れ", "ストレス", "治療", "病気"],
          grammar: "Health-related expressions.",
        },
        {
          id: "s5u15",
          title: "Unit 15: Talk about your job",
          vocabulary: ["仕事", "責任", "予定", "会議", "プロジェクト"],
          grammar: "Workplace communication.",
        },
        {
          id: "s5u16",
          title: "Unit 16: Use particles y / en (JP equivalent)",
          vocabulary: ["そこ", "そこに", "それ", "それについて"],
          grammar: "Referencing places and topics implicitly.",
        },
        {
          id: "s5u17",
          title: "Unit 17: Talk about your siblings",
          vocabulary: ["兄", "姉", "弟", "妹", "成長する", "家族"],
          grammar: "Family descriptions.",
        },
        {
          id: "s5u18",
          title: "Unit 18: Follow recipes",
          vocabulary: ["料理する", "混ぜる", "オーブン", "材料", "切る"],
          grammar: "Imperatives and instructions.",
        },
        {
          id: "s5u19",
          title: "Unit 19: Read a celebrity interview",
          vocabulary: ["有名", "俳優", "インタビュー", "答え", "質問", "経歴"],
          grammar: "Reported speech basics.",
        },
        {
          id: "s5u20",
          title: "Unit 20: Describe a wedding",
          vocabulary: ["結婚式", "式", "招待客", "服", "指輪", "祝う"],
          grammar: "Event narration.",
        },

        // Units 21–51 continue with the SAME TITLES as French Section 5,
        // Japanese B1 vocabulary, and appropriate grammar focus.
      ],
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 concepts",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [],
        grammar:
          "Advanced B1 Grammar (complex sentence forms, nuance, fluency).",
      })),
    },

    {
      name: "Section 7: Daily Refresh (CEFR B2)",
      description: "Upper Intermediate",
      units: Array.from({ length: 36 }, (_, i) => ({
        id: `s7_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Concept ${i + 1}`,
        vocabulary: [],
        grammar: "B2 Level Grammar (register control, abstraction, precision).",
      })),
    },

    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery",
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [],
        grammar:
          "Mastery Level Concepts (fluency, nuance, cultural competence).",
      })),
    },
  ],

  Hindi: [
    {
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic phrases",
          vocabulary: [
            "एक",
            "बिल्ली",
            "कुत्ता",
            "घोड़ा",
            "पिज़्ज़ा",
            "संतरा",
            "लड़का",
            "लड़की",
            "आदमी",
            "औरत",
            "है",
            "खाता",
            "रोटी",
            "और",
          ],
          grammar: "Basic nouns, simple verb है, and conjunction और.",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "नमस्ते",
            "हाय",
            "शुभ प्रभात",
            "शुभ रात्रि",
            "फिर मिलेंगे",
            "कल मिलते हैं",
            "स्वागत है",
            "कैसे",
            "हो",
            "ठीक",
            "बहुत",
            "धन्यवाद",
            "बहुत धन्यवाद",
            "खुशी हुई",
          ],
          grammar: "Greetings, politeness, and basic question formation.",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: [
            "मैं",
            "तुम",
            "वह",
            "यह",
            "नाम",
            "हूँ",
            "है",
            "छात्र",
            "शिक्षक",
            "भारतीय",
            "अमेरिकी",
            "अंग्रेज़ी",
            "हिंदी",
          ],
          grammar: "Subject pronouns and verb forms हूँ / है.",
        },
        {
          id: "u4",
          title: "Unit 4: Use the present tense",
          vocabulary: [
            "बोलता",
            "बोलती",
            "माफ़ कीजिए",
            "क्षमा करें",
            "कृपया",
            "समझता",
            "समझती",
            "भाषा",
          ],
          grammar: "Present tense verb agreement (gender-based).",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: [
            "कहाँ",
            "है",
            "हवाई अड्डा",
            "रेलवे स्टेशन",
            "टैक्सी",
            "कार",
            "ट्रेन",
            "होटल",
            "सड़क",
            "में",
            "पर",
          ],
          grammar: "Location questions and basic postpositions (में, पर).",
        },
        {
          id: "u6",
          title: "Unit 6: Refer to family members",
          vocabulary: [
            "मेरा",
            "मेरी",
            "पिता",
            "माता",
            "भाई",
            "बहन",
            "पति",
            "पत्नी",
            "परिवार",
          ],
          grammar: "Possessive forms (मेरा / मेरी) and family nouns.",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about things you do",
          vocabulary: [
            "रहता",
            "रहती",
            "यहाँ",
            "दिल्ली",
            "मुंबई",
            "काम करता",
            "काम करती",
            "पढ़ता",
            "पढ़ती",
            "बहुत",
          ],
          grammar: "Verb agreement with gender in present tense.",
        },
        {
          id: "u8",
          title: "Unit 8: Form the plural, use the present tense",
          vocabulary: [
            "लड़के",
            "लड़कियाँ",
            "बिल्लियाँ",
            "कुत्ते",
            "खाते हैं",
            "खाती हैं",
            "वे",
          ],
          grammar: "Plural nouns and verb agreement (हैं).",
        },
        {
          id: "u9",
          title: "Unit 9: Describe your family",
          vocabulary: [
            "दादा",
            "दादी",
            "नाना",
            "नानी",
            "बच्चा",
            "बच्ची",
            "साथ",
            "हमारा",
          ],
          grammar: "Family descriptions and possessives.",
        },
        {
          id: "u10",
          title: "Unit 10: Order food and drink",
          vocabulary: [
            "चाय",
            "कॉफ़ी",
            "पानी",
            "रस",
            "रेस्टोरेंट",
            "मेज़",
            "बिल",
            "चाहिए",
            "वेटर",
            "गिलास",
          ],
          grammar: "Polite requests using चाहिए.",
        },
      ],
    },
    {
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use gender and number agreement",
          vocabulary: [
            "बड़ा",
            "बड़ी",
            "छोटा",
            "छोटी",
            "नया",
            "नई",
            "युवा",
            "पुराना",
          ],
          grammar: "Gender agreement in adjectives (masc/fem).",
        },
        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: [
            "जाना",
            "जाता",
            "जाती",
            "को",
            "पर",
            "समुद्र",
            "शहर",
            "पहाड़",
            "सिनेमा",
          ],
          grammar: "Movement verbs and postpositions (को, पर).",
        },
        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: [
            "घर",
            "फ्लैट",
            "कमरा",
            "रसोई",
            "बैठक",
            "बगीचा",
            "बालकनी",
          ],
          grammar: "Existence using है / हैं.",
        },
        {
          id: "s2u4",
          title: "Unit 4: Describe where you work",
          vocabulary: [
            "दफ़्तर",
            "कंपनी",
            "सहकर्मी",
            "कंप्यूटर",
            "काम",
            "मालिक",
          ],
          grammar: "Workplace nouns and present tense verbs.",
        },
        {
          id: "s2u5",
          title: "Unit 5: Talk about food & agreement",
          vocabulary: ["सेब", "रोटी", "चावल", "मांस", "मछली", "स्वादिष्ट"],
          grammar: "Food nouns and adjective agreement.",
        },
        {
          id: "s2u6",
          title: "Unit 6: Use the present tense",
          vocabulary: ["बोलना", "खाना", "लेना", "जाना", "आना", "करना"],
          grammar: "Present tense verb forms with gender agreement.",
        },
        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: ["कपड़े", "शर्ट", "जूते", "पैंट", "आकार", "रंग"],
          grammar: "Shopping expressions and adjective agreement.",
        },
        {
          id: "s2u8",
          title: "Unit 8: Exchange personal information",
          vocabulary: ["उम्र", "पता", "नंबर", "पेशा", "राष्ट्रीयता", "नाम"],
          grammar: "Personal information sentences using है / हूँ.",
        },
        {
          id: "s2u9",
          title: "Unit 9: Use the infinitive",
          vocabulary: [
            "पसंद करना",
            "चाहना",
            "सकना",
            "चाहिए",
            "शुरू करना",
            "जारी रखना",
          ],
          grammar: "Infinitive constructions and modal verbs.",
        },
        {
          id: "s2u10",
          title: "Unit 10: Ask people about themselves",
          vocabulary: ["कौन", "कहाँ", "कहाँ से", "रहना", "काम करना"],
          grammar: "Question words and basic sentence order.",
        },
        {
          id: "s2u11",
          title: "Unit 11: Ask questions",
          vocabulary: ["क्यों", "कैसे", "कब", "कौन सा", "कितना"],
          grammar: "Wh-questions in Hindi.",
        },
        {
          id: "s2u12",
          title: "Unit 12: Tell time, form the present tense",
          vocabulary: ["समय", "मिनट", "सुबह", "शाम", "रात"],
          grammar: "Time expressions and daily routine verbs.",
        },
        {
          id: "s2u13",
          title: "Unit 13: Talk to someone formally",
          vocabulary: ["आप", "जी", "कृपया", "क्या आप", "धन्यवाद"],
          grammar: "Formal vs informal speech (आप vs तुम).",
        },
        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: [
            "पढ़ना",
            "खेलना",
            "नाचना",
            "यात्रा करना",
            "संगीत",
            "खेल",
          ],
          grammar: "Likes and dislikes using पसंद है.",
        },
        {
          id: "s2u15",
          title: "Unit 15: Describe your breakfast",
          vocabulary: ["चाय", "दूध", "रोटी", "मक्खन", "जैम", "रस"],
          grammar: "Daily routine and food expressions.",
        },
        {
          id: "s2u16",
          title: "Unit 16: Discuss travel plans",
          vocabulary: ["यात्रा करना", "छुट्टी", "टिकट", "ट्रेन", "बुकिंग"],
          grammar: "Future intention using जाएगा / जाएगी.",
        },
        {
          id: "s2u17",
          title: "Unit 17: Talk about school",
          vocabulary: ["स्कूल", "शिक्षक", "छात्र", "कक्षा", "होमवर्क", "पढ़ाई"],
          grammar: "School vocabulary and present tense verbs.",
        },
        {
          id: "s2u18",
          title: "Unit 18: Share work schedules",
          vocabulary: ["समय सारणी", "काम", "ब्रेक", "मीटिंग", "हर दिन"],
          grammar: "Routine and schedule expressions.",
        },
        {
          id: "s2u19",
          title: "Unit 19: Book a hotel",
          vocabulary: ["होटल", "कमरा", "चाबी", "आरक्षण", "रिसेप्शन"],
          grammar: "Booking and service expressions.",
        },
        {
          id: "s2u20",
          title: "Unit 20: Describe your routine",
          vocabulary: ["उठना", "नहाना", "खाना", "जाना", "लौटना"],
          grammar: "Daily routine verbs.",
        },
        {
          id: "s2u21",
          title: "Unit 21: Talk about the weather",
          vocabulary: ["गरम", "ठंडा", "बारिश", "बर्फ़", "धूप"],
          grammar: "Weather descriptions.",
        },
        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: ["लंबा", "छोटा", "आँखें", "बाल", "अच्छा", "होशियार"],
          grammar: "Physical and personality descriptions with agreement.",
        },
      ],
    },

    {
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: ["खुश", "दुखी", "थका", "तनाव", "गुस्सा", "संतुष्ट"],
          grammar: "Expressing feelings with adjectives and है.",
        },
        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: [
            "बाज़ार",
            "सुपरमार्केट",
            "फल",
            "सब्ज़ी",
            "पैकेट",
            "बोतल",
          ],
          grammar: "Shopping nouns and quantity expressions.",
        },
        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: [
            "आकार",
            "पहनकर देखना",
            "महँगा",
            "सस्ता",
            "दुकान",
            "ट्रायल रूम",
          ],
          grammar: "Adjectives and polite shopping requests.",
        },
        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: ["दाएँ", "बाएँ", "सीधा", "पास", "दूर", "नक्शा"],
          grammar: "Giving directions using postpositions.",
        },
        {
          id: "s3u5",
          title: "Unit 5: Talk about days & times",
          vocabulary: ["उठना", "सोना", "तैयार होना", "घड़ी", "सुबह", "शाम"],
          grammar: "Daily schedule expressions.",
        },
        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: [
            "घूमना",
            "मिलना",
            "पार्क",
            "सिनेमा",
            "गतिविधि",
            "फुर्सत",
          ],
          grammar: "Leisure verbs in present tense.",
        },
        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: [
            "मुझे लगता है",
            "मेरा मानना है",
            "मेरी राय में",
            "ज़रूरी",
            "दिलचस्प",
            "उबाऊ",
          ],
          grammar: "Opinion expressions.",
        },
        {
          id: "s3u8",
          title: "Unit 8: Use direct object markers",
          vocabulary: ["मुझे", "तुम्हें", "उसे", "हमें", "उन्हें"],
          grammar: "Direct object marker को.",
        },
        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: ["जंगल", "नदी", "पहाड़", "फूल", "सूरज", "बारिश"],
          grammar: "Describing nature using है / हैं.",
        },
        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: ["चाचा", "चाची", "मामा", "मामी", "शादीशुदा", "अविवाहित"],
          grammar: "Extended family descriptions.",
        },
        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: ["पाठ", "विषय", "शिक्षक", "छात्र", "कार्य", "दोहराना"],
          grammar: "School-related verbs and nouns.",
        },
        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: ["पकाना", "रेसिपी", "सामग्री", "ओवन", "चाकू", "कड़ाही"],
          grammar: "Cooking instructions and verbs.",
        },
        {
          id: "s3u13",
          title: "Unit 13: Describe your schedule",
          vocabulary: [
            "समय सारणी",
            "जानना",
            "समझना",
            "मीटिंग",
            "योजना",
            "गतिविधि",
          ],
          grammar: "Difference between जानना and समझना.",
        },
        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: [
            "छुट्टियाँ",
            "आरक्षण",
            "होटल",
            "समुद्र",
            "यात्रा",
            "टिकट",
          ],
          grammar: "Future intention expressions.",
        },
        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: ["बीमार", "बुखार", "खाँसी", "डॉक्टर", "दवा", "दर्द"],
          grammar: "Health expressions using है.",
        },
        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: ["इमारत", "मंज़िल", "कमरा", "दीवार", "छत", "पड़ोसी"],
          grammar: "Describing places and objects.",
        },
        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: ["परियोजना", "मीटिंग", "सहकर्मी", "बॉस", "दफ़्तर", "काम"],
          grammar: "Formal workplace language.",
        },
        {
          id: "s3u18",
          title: "Unit 18: Use the past (habits)",
          vocabulary: ["था", "थी", "करता था", "अक्सर", "हमेशा"],
          grammar: "Past habitual actions.",
        },
        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: ["कल", "पिछले हफ़्ते", "देखा", "किया", "लिया", "लौटा"],
          grammar: "Simple past tense.",
        },
        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: ["सकता हूँ", "मदद करना", "क्या मैं", "अनुरोध", "पूछना"],
          grammar: "Polite offers and requests.",
        },
        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: ["यात्रा की", "घूमा", "पहुंचा", "निकला", "यादें", "जगह"],
          grammar: "Narrating past travel experiences.",
        },
      ],
    },

    {
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Everyday topics & conversations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Use the present tense",
          vocabulary: ["बोलना", "खाना", "लेना", "जाना", "आना", "करना"],
          grammar: "Present tense verbs with gender agreement.",
        },
        {
          id: "s4u2",
          title: "Unit 2: Describe your weekend (Past Tense)",
          vocabulary: ["किया", "देखा", "खाया", "गया", "घूमा", "कल"],
          grammar: "Simple past tense.",
        },
        {
          id: "s4u3",
          title: "Unit 3: Describe people you know",
          vocabulary: [
            "अच्छा",
            "मज़ेदार",
            "शांत",
            "मेहनती",
            "शर्मीला",
            "मिलनसार",
          ],
          grammar: "Adjectives and agreement.",
        },
        {
          id: "s4u4",
          title: "Unit 4: Talk about classes",
          vocabulary: [
            "गणित",
            "इतिहास",
            "विज्ञान",
            "शिक्षक",
            "परीक्षा",
            "कक्षा",
          ],
          grammar: "School vocabulary and present tense.",
        },
        {
          id: "s4u5",
          title: "Unit 5: Refer to extended family",
          vocabulary: ["चाचा", "चाची", "मामा", "मामी", "भतीजा", "भतीजी"],
          grammar: "Extended family nouns.",
        },
        {
          id: "s4u6",
          title: "Unit 6: Talk about Delhi",
          vocabulary: ["संग्रहालय", "किला", "पुल", "इलाका", "नदी", "स्मारक"],
          grammar: "Describing places using है / हैं.",
        },
        {
          id: "s4u7",
          title: "Unit 7: Comment on clothes",
          vocabulary: [
            "सलीकेदार",
            "साधारण",
            "रंगीन",
            "शैली",
            "ब्रांड",
            "फ़ैशन",
          ],
          grammar: "Adjectives for clothing.",
        },
        {
          id: "s4u8",
          title: "Unit 8: Make requests",
          vocabulary: ["क्या आप", "कृपया", "मदद", "देना", "लाना", "पकड़ना"],
          grammar: "Polite requests using क्या आप / कृपया.",
        },
        {
          id: "s4u9",
          title: "Unit 9: Shop at a market",
          vocabulary: ["दुकानदार", "कीमत", "किलो", "ताज़ा", "ऑफ़र", "छूट"],
          grammar: "Market vocabulary and quantities.",
        },
        {
          id: "s4u10",
          title: "Unit 10: Use the past tense",
          vocabulary: ["था", "थी", "लिया", "किया", "देखा", "गया"],
          grammar: "Past tense with था / थी.",
        },
        {
          id: "s4u11",
          title: "Unit 11: Use indirect object markers",
          vocabulary: ["मुझे", "तुम्हें", "उसे", "हमें", "उन्हें"],
          grammar: "Indirect object marker को.",
        },
        {
          id: "s4u12",
          title: "Unit 12: Communicate at a hotel",
          vocabulary: ["आरक्षण", "चाबी", "कार्ड", "रिसेप्शन", "लिफ़्ट", "सेवा"],
          grammar: "Hotel communication.",
        },
        {
          id: "s4u13",
          title: "Unit 13: Talk about spending money",
          vocabulary: ["खरीदना", "खर्च करना", "बजट", "कीमत", "महँगा", "सस्ता"],
          grammar: "Money-related verbs.",
        },
        {
          id: "s4u14",
          title: "Unit 14: Talk about family gatherings",
          vocabulary: ["समारोह", "भोजन", "निमंत्रण", "मनाना", "परिवार", "मौका"],
          grammar: "Talking about events.",
        },
        {
          id: "s4u15",
          title: "Unit 15: Share travel experiences",
          vocabulary: ["यात्रा की", "घूमा", "जगह", "यादें", "देश", "रास्ता"],
          grammar: "Narrating experiences in the past.",
        },
        {
          id: "s4u16",
          title: "Unit 16: Talk about technology (Past)",
          vocabulary: [
            "कंप्यूटर",
            "मोबाइल",
            "इंटरनेट",
            "पहले",
            "नया",
            "इस्तेमाल किया",
          ],
          grammar: "Past habits.",
        },
        {
          id: "s4u17",
          title: "Unit 17: Discuss games and media",
          vocabulary: ["खेल", "फ़िल्म", "संगीत", "कार्यक्रम", "पढ़ना", "खेलना"],
          grammar: "Preferences and opinions.",
        },
        {
          id: "s4u18",
          title: "Unit 18: Talk about exercise",
          vocabulary: [
            "दौड़ना",
            "चलना",
            "जिम",
            "व्यायाम",
            "स्वास्थ्य",
            "तंदुरुस्ती",
          ],
          grammar: "Activities and routines.",
        },
        {
          id: "s4u19",
          title: "Unit 19: Discuss money",
          vocabulary: ["पैसा", "बचत", "खाता", "बैंक", "भुगतान", "वेतन"],
          grammar: "Financial vocabulary.",
        },
        {
          id: "s4u20",
          title: "Unit 20: Comment on foods",
          vocabulary: ["स्वादिष्ट", "फीका", "मीठा", "नमकीन", "कड़वा", "मसाला"],
          grammar: "Food opinions.",
        },
        {
          id: "s4u21",
          title: "Unit 21: Make plans to go out",
          vocabulary: [
            "घूमना",
            "मिलना",
            "योजना",
            "शाम",
            "रेस्टोरेंट",
            "उपलब्ध",
          ],
          grammar: "Future planning.",
        },
        {
          id: "s4u22",
          title: "Unit 22: Talk about your past",
          vocabulary: ["बचपन", "यादें", "पहले", "था", "थी", "रहता था"],
          grammar: "Past descriptions.",
        },
        {
          id: "s4u23",
          title: "Unit 23: Make transit plans",
          vocabulary: ["ट्रेन", "बस", "मेट्रो", "समय सारणी", "देरी", "टिकट"],
          grammar: "Travel planning.",
        },
        {
          id: "s4u24",
          title: "Unit 24: Use commands",
          vocabulary: ["आओ", "जाओ", "रुको", "सुनो", "लाओ", "देखो"],
          grammar: "Imperative forms.",
        },
        {
          id: "s4u25",
          title: "Unit 25: Describe what's in your home",
          vocabulary: ["कमरा", "फ़र्नीचर", "शेल्फ़", "बैठक", "रसोई", "लैंप"],
          grammar: "Describing interiors.",
        },
        {
          id: "s4u26",
          title: "Unit 26: Talk about art",
          vocabulary: [
            "चित्रकला",
            "मूर्ति",
            "संग्रहालय",
            "कलाकार",
            "कृति",
            "रंग",
          ],
          grammar: "Talking about art.",
        },
        {
          id: "s4u27",
          title: "Unit 27: Communicate in an emergency",
          vocabulary: [
            "मदद",
            "आपातकाल",
            "पुलिस",
            "एंबुलेंस",
            "खतरा",
            "दुर्घटना",
          ],
          grammar: "Emergency expressions.",
        },
        {
          id: "s4u28",
          title: "Unit 28: Use the future tense",
          vocabulary: ["करूँगा", "जाऊँगा", "देखूँगा", "होगा", "योजना", "कल"],
          grammar: "Future tense.",
        },
        {
          id: "s4u29",
          title: "Unit 29: Communicate with a doctor",
          vocabulary: [
            "दर्द",
            "लक्षण",
            "इलाज",
            "पर्ची",
            "अपॉइंटमेंट",
            "अस्पताल",
          ],
          grammar: "Medical communication.",
        },
        {
          id: "s4u30",
          title: "Unit 30: Talk about the weather (Future)",
          vocabulary: [
            "बारिश होगी",
            "बर्फ़",
            "तूफ़ान",
            "मौसम",
            "पूर्वानुमान",
            "धूप",
          ],
          grammar: "Future weather expressions.",
        },
        {
          id: "s4u31",
          title: "Unit 31: Talk about possessions",
          vocabulary: ["अपना", "पुराना", "नया", "चीज़", "उपहार", "कीमत"],
          grammar: "Possession expressions.",
        },
        {
          id: "s4u32",
          title: "Unit 32: Talk about the future",
          vocabulary: ["भविष्य", "लक्ष्य", "योजना", "करियर", "सपना", "सफलता"],
          grammar: "Future goals.",
        },
        {
          id: "s4u33",
          title: "Unit 33: Talk about a bad day",
          vocabulary: ["समस्या", "देरी", "थकान", "तनाव", "दुर्भाग्य", "टूटा"],
          grammar: "Narrating problems.",
        },
        {
          id: "s4u34",
          title: "Unit 34: Discuss careers",
          vocabulary: ["नौकरी", "पेशा", "इंटरव्यू", "कंपनी", "कौशल", "वेतन"],
          grammar: "Career-related language.",
        },
        {
          id: "s4u35",
          title: "Unit 35: Express yourself politely",
          vocabulary: [
            "अगर आप",
            "माफ़ कीजिए",
            "क्षमा करें",
            "धन्यवाद",
            "परेशान",
          ],
          grammar: "Polite expressions.",
        },
        {
          id: "s4u36",
          title: "Unit 36: Shop for sales",
          vocabulary: ["सेल", "छूट", "कीमत कम", "सामान", "काउंटर", "बिल"],
          grammar: "Shopping and discounts.",
        },
        {
          id: "s4u37",
          title: "Unit 37: Use the gerund",
          vocabulary: [
            "करते हुए",
            "बोलते हुए",
            "खाते हुए",
            "पढ़ते हुए",
            "जाते हुए",
          ],
          grammar: "Gerund constructions.",
        },
        {
          id: "s4u38",
          title: "Unit 38: Use the conditional",
          vocabulary: ["अगर", "होता", "करता", "जाता", "शर्त", "स्थिति"],
          grammar: "Conditional sentences.",
        },
        {
          id: "s4u39",
          title: "Unit 39: Make requests",
          vocabulary: ["क्या आप कर सकते हैं", "मदद", "लाना", "देना", "उधार"],
          grammar: "Formal requests.",
        },
        {
          id: "s4u40",
          title: "Unit 40: Discuss protests",
          vocabulary: [
            "प्रदर्शन",
            "अधिकार",
            "स्वतंत्रता",
            "जनता",
            "सरकार",
            "आवाज़",
          ],
          grammar: "Public issues.",
        },
        {
          id: "s4u41",
          title: "Unit 41: Order at a restaurant",
          vocabulary: ["मेनू", "वेटर", "खाना", "स्टार्टर", "मिठाई", "ऑर्डर"],
          grammar: "Restaurant communication.",
        },
        {
          id: "s4u42",
          title: "Unit 42: Comment on sports",
          vocabulary: ["खेल", "मैच", "टीम", "खिलाड़ी", "जीतना", "हारना"],
          grammar: "Sports verbs.",
        },
        {
          id: "s4u43",
          title: "Unit 43: Communicate in class",
          vocabulary: ["सवाल", "जवाब", "दोहराना", "समझाना", "लिखना", "समझना"],
          grammar: "Classroom language.",
        },
        {
          id: "s4u44",
          title: "Unit 44: Talk about road trips",
          vocabulary: ["सड़क", "हाइवे", "नक्शा", "यात्रा", "रुकना", "किलोमीटर"],
          grammar: "Travel narration.",
        },
        {
          id: "s4u45",
          title: "Unit 45: Discuss emergencies",
          vocabulary: ["आपातकाल", "दुर्घटना", "खतरा", "फ़ोन", "बचाव", "चोट"],
          grammar: "Emergency situations.",
        },
        {
          id: "s4u46",
          title: "Unit 46: Talk about meeting people",
          vocabulary: [
            "मिलना",
            "परिचय",
            "अभिवादन",
            "बात करना",
            "निमंत्रण",
            "जानना",
          ],
          grammar: "Social interactions.",
        },
      ],
    },

    {
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Wide variety of topics",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Order at a bistro",
          vocabulary: ["ऑर्डर करना", "पेय", "खाना", "वेटर", "बिल", "आरक्षण"],
          grammar: "Polite ordering using चाहिए / कृपया.",
        },
        {
          id: "s5u2",
          title: "Unit 2: Talk about festivals",
          vocabulary: [
            "त्योहार",
            "उत्सव",
            "संगीत",
            "आतिशबाज़ी",
            "नृत्य",
            "परंपरा",
          ],
          grammar: "Describing celebrations and events.",
        },
        {
          id: "s5u3",
          title: "Unit 3: Use nothing / nobody",
          vocabulary: ["कुछ नहीं", "कोई नहीं", "कभी नहीं", "बिल्कुल नहीं", "न"],
          grammar: "Negative expressions in Hindi.",
        },
        {
          id: "s5u4",
          title: "Unit 4: Discuss gifts",
          vocabulary: ["उपहार", "देना", "पाना", "मौका", "पैकिंग", "सरप्राइज़"],
          grammar: "Giving and receiving verbs.",
        },
        {
          id: "s5u5",
          title: "Unit 5: Talk about school",
          vocabulary: ["विषय", "दोहराना", "कार्य", "अंक", "पाठ्यक्रम", "कक्षा"],
          grammar: "Academic vocabulary; tense review.",
        },
        {
          id: "s5u6",
          title: "Unit 6: Discuss relationships",
          vocabulary: ["दोस्त", "जोड़ा", "परिवार", "रिश्ता", "भरोसा", "सहारा"],
          grammar: "Talking about social relationships.",
        },
        {
          id: "s5u7",
          title: "Unit 7: Describe career plans",
          vocabulary: [
            "करियर",
            "लक्ष्य",
            "भविष्य",
            "इंटर्नशिप",
            "कंपनी",
            "योजना",
          ],
          grammar: "Future plans using होगा / करूँगा.",
        },
        {
          id: "s5u8",
          title: "Unit 8: Express opinions",
          vocabulary: [
            "मुझे लगता है",
            "मेरा मानना है",
            "मेरे अनुसार",
            "महत्वपूर्ण",
            "कठिन",
          ],
          grammar: "Opinion structures.",
        },
        {
          id: "s5u9",
          title: "Unit 9: Talk about the outdoors",
          vocabulary: [
            "जंगल",
            "झील",
            "पहाड़ी",
            "ट्रेकिंग",
            "कैम्पिंग",
            "प्रकृति",
          ],
          grammar: "Outdoor activity descriptions.",
        },
        {
          id: "s5u10",
          title: "Unit 10: Use relative clauses",
          vocabulary: ["जो", "जिस", "जहाँ", "जब", "क्योंकि"],
          grammar: "Relative constructions using जो.",
        },
        {
          id: "s5u11",
          title: "Unit 11: Discuss athletics",
          vocabulary: [
            "दौड़",
            "मैदान",
            "खिलाड़ी",
            "टीम",
            "अभ्यास",
            "प्रतियोगिता",
          ],
          grammar: "Sports vocabulary.",
        },
        {
          id: "s5u12",
          title: "Unit 12: Talk about the past",
          vocabulary: ["पहले", "कभी", "याद", "था", "थी", "करता था"],
          grammar: "Contrast past states and actions.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Talk about the environment",
          vocabulary: [
            "प्रदूषण",
            "पर्यावरण",
            "पृथ्वी",
            "कचरा",
            "रीसायकल",
            "ऊर्जा",
          ],
          grammar: "Environmental concerns and solutions.",
        },
        {
          id: "s5u14",
          title: "Unit 14: Discuss your health",
          vocabulary: ["लक्षण", "डॉक्टर", "थकान", "तनाव", "इलाज", "बीमारी"],
          grammar: "Health expressions.",
        },
        {
          id: "s5u15",
          title: "Unit 15: Talk about your job",
          vocabulary: ["नौकरी", "जिम्मेदारी", "समय", "मीटिंग", "परियोजना"],
          grammar: "Workplace communication.",
        },
        {
          id: "s5u16",
          title: "Unit 16: Use reference words (Hindi equivalent of y / en)",
          vocabulary: ["वहाँ", "उसके बारे में", "वहीं", "ऐसा"],
          grammar: "Implicit reference and cohesion.",
        },
        {
          id: "s5u17",
          title: "Unit 17: Talk about your siblings",
          vocabulary: ["भाई", "बहन", "बड़ा", "छोटा", "बढ़ना", "परिवार"],
          grammar: "Family descriptions across tenses.",
        },
        {
          id: "s5u18",
          title: "Unit 18: Follow recipes",
          vocabulary: ["पकाना", "मिलाना", "ओवन", "सामग्री", "काटना"],
          grammar: "Imperative forms.",
        },
        {
          id: "s5u19",
          title: "Unit 19: Read a celebrity interview",
          vocabulary: [
            "प्रसिद्ध",
            "अभिनेता",
            "साक्षात्कार",
            "उत्तर",
            "प्रश्न",
            "करियर",
          ],
          grammar: "Reported speech basics.",
        },
        {
          id: "s5u20",
          title: "Unit 20: Describe a wedding",
          vocabulary: ["शादी", "समारोह", "मेहमान", "कपड़े", "अंगूठी", "जश्न"],
          grammar: "Event narration.",
        },

        {
          id: "s5u21",
          title: "Unit 21: Communicate on a trip",
          vocabulary: ["मार्ग", "जानकारी", "बुकिंग", "सामान", "गाइड", "यात्रा"],
          grammar: "Travel communication.",
        },
        {
          id: "s5u22",
          title: "Unit 22: Describe household tasks",
          vocabulary: ["सफ़ाई", "झाड़ू", "धोना", "साफ़ करना", "धूल", "काम"],
          grammar: "Household duties.",
        },
        {
          id: "s5u23",
          title: "Unit 23: Discuss travel abroad",
          vocabulary: ["पासपोर्ट", "वीज़ा", "सीमा", "गंतव्य", "उड़ान", "कस्टम"],
          grammar: "International travel vocabulary.",
        },
        {
          id: "s5u24",
          title: "Unit 24: Talk about the internet",
          vocabulary: [
            "इंटरनेट",
            "नेटवर्क",
            "संदेश",
            "वेबसाइट",
            "फ़ाइल",
            "पोस्ट करना",
          ],
          grammar: "Digital actions.",
        },
        {
          id: "s5u25",
          title: "Unit 25: Comment on foods",
          vocabulary: [
            "स्वादिष्ट",
            "कड़वा",
            "नमकीन",
            "मीठा",
            "मसालेदार",
            "खाना",
          ],
          grammar: "Food adjectives.",
        },
        {
          id: "s5u26",
          title: "Unit 26: Use relative clauses",
          vocabulary: ["जो", "जिसे", "जिसका", "जहाँ", "विचार"],
          grammar: "Expanded relative constructions.",
        },
        {
          id: "s5u27",
          title: "Unit 27: Navigate complex situations",
          vocabulary: [
            "समस्या",
            "निर्णय",
            "समाधान",
            "आपातकाल",
            "संघर्ष",
            "संभालना",
          ],
          grammar: "Handling complex scenarios.",
        },
        {
          id: "s5u28",
          title: "Unit 28: Discuss technology trends",
          vocabulary: [
            "डिजिटल",
            "रुझान",
            "एप्लिकेशन",
            "नवाचार",
            "रोबोट",
            "वर्चुअल",
          ],
          grammar: "Talking about trends.",
        },
        {
          id: "s5u29",
          title: "Unit 29: Analyze media",
          vocabulary: [
            "लेख",
            "अख़बार",
            "विज्ञापन",
            "स्रोत",
            "आलोचना",
            "जानकारी",
          ],
          grammar: "Media discussion.",
        },
        {
          id: "s5u30",
          title: "Unit 30: Talk about cinema",
          vocabulary: [
            "फ़िल्म",
            "अभिनेता",
            "दृश्य",
            "निर्देशक",
            "शैली",
            "ट्रेलर",
          ],
          grammar: "Cinema vocabulary.",
        },
        {
          id: "s5u31",
          title: "Unit 31: Debate current events",
          vocabulary: ["बहस", "राजनीति", "राय", "तर्क", "समाज", "समाचार"],
          grammar: "Debate structures.",
        },
        {
          id: "s5u32",
          title: "Unit 32: Use advanced negation",
          vocabulary: ["कभी नहीं", "अब नहीं", "कोई नहीं", "कुछ भी नहीं"],
          grammar: "Complex negation.",
        },
        {
          id: "s5u33",
          title: "Unit 33: Describe abstract ideas",
          vocabulary: [
            "विचार",
            "स्वतंत्रता",
            "न्याय",
            "मूल्य",
            "सिद्धांत",
            "आदर्श",
          ],
          grammar: "Abstract nouns.",
        },
        {
          id: "s5u34",
          title: "Unit 34: Talk about university life",
          vocabulary: [
            "विश्वविद्यालय",
            "विभाग",
            "पाठ्यक्रम",
            "प्रोफेसर",
            "पुस्तकालय",
            "परीक्षा",
          ],
          grammar: "Academic register.",
        },
        {
          id: "s5u35",
          title: "Unit 35: Discuss volunteering",
          vocabulary: ["स्वयंसेवा", "संस्था", "मदद", "आयोजन", "कारण", "दान"],
          grammar: "Purpose expressions.",
        },
        {
          id: "s5u36",
          title: "Unit 36: Review past tenses",
          vocabulary: ["भूतकाल", "था", "थी", "कर चुका", "कर रहा था"],
          grammar: "Past tense contrast.",
        },
        {
          id: "s5u37",
          title: "Unit 37: Use the subjunctive mood",
          vocabulary: ["चाहिए कि", "ज़रूरी है कि", "संभव है कि"],
          grammar: "Hypothetical and necessity expressions.",
        },
        {
          id: "s5u38",
          title: "Unit 38: Express doubt and uncertainty",
          vocabulary: ["शायद", "संभव", "अनिश्चित", "लगता है", "संदेह"],
          grammar: "Uncertainty expressions.",
        },
        {
          id: "s5u39",
          title: "Unit 39: Discuss environmental issues",
          vocabulary: [
            "जलवायु",
            "ग्लोबल वार्मिंग",
            "जैव विविधता",
            "प्रदूषण",
            "सतत",
            "संरक्षण",
          ],
          grammar: "Cause and consequence.",
        },
        {
          id: "s5u40",
          title: "Unit 40: Talk about performing arts",
          vocabulary: [
            "नाटक",
            "प्रदर्शन",
            "नृत्य",
            "संगीतकार",
            "कलाकार",
            "मंच",
          ],
          grammar: "Describing performances.",
        },
        {
          id: "s5u41",
          title: "Unit 41: Professional interviews",
          vocabulary: ["इंटरव्यू", "कौशल", "अनुभव", "योग्यता", "पद", "भर्ती"],
          grammar: "Formal self-presentation.",
        },
        {
          id: "s5u42",
          title: "Unit 42: Write formal emails",
          vocabulary: ["विषय", "सादर", "संलग्न", "औपचारिक", "संदेश", "पता"],
          grammar: "Formal written language.",
        },
        {
          id: "s5u43",
          title: "Unit 43: Discuss architecture",
          vocabulary: [
            "इमारत",
            "संरचना",
            "पुल",
            "डिज़ाइन",
            "प्राचीन",
            "आधुनिक",
          ],
          grammar: "Descriptive language.",
        },
        {
          id: "s5u44",
          title: "Unit 44: Talk about fashion trends",
          vocabulary: [
            "रुझान",
            "ब्रांड",
            "शैली",
            "आधुनिक",
            "एलिगेंट",
            "डिज़ाइनर",
          ],
          grammar: "Fashion opinions.",
        },
        {
          id: "s5u45",
          title: "Unit 45: Review conditional sentences",
          vocabulary: ["अगर", "तो", "होता", "करता", "हो सकता"],
          grammar: "Conditional logic.",
        },
        {
          id: "s5u46",
          title: "Unit 46: Tell jokes and stories",
          vocabulary: ["कहानी", "हँसी", "मज़ाक", "पात्र", "कहना", "स्थिति"],
          grammar: "Narrative flow.",
        },
        {
          id: "s5u47",
          title: "Unit 47: Discuss traditions",
          vocabulary: [
            "परंपरा",
            "रिवाज़",
            "विरासत",
            "संस्कृति",
            "मनाना",
            "रीति",
          ],
          grammar: "Cultural descriptions.",
        },
        {
          id: "s5u48",
          title: "Unit 48: Describe historical events",
          vocabulary: ["इतिहास", "युग", "युद्ध", "राजा", "क्रांति", "तारीख"],
          grammar: "Sequencing past events.",
        },
        {
          id: "s5u49",
          title: "Unit 49: Talk about legal matters",
          vocabulary: [
            "कानून",
            "न्याय",
            "अदालत",
            "अधिकार",
            "वकील",
            "प्रक्रिया",
          ],
          grammar: "Legal vocabulary.",
        },
        {
          id: "s5u50",
          title: "Unit 50: Use passive voice",
          vocabulary: ["किया गया", "लिखा गया", "खोला गया", "घोषित किया गया"],
          grammar: "Passive constructions in Hindi.",
        },
        {
          id: "s5u51",
          title: "Unit 51: Final B1 Review",
          vocabulary: ["दोहराना", "सारांश", "महत्वपूर्ण", "अभिव्यक्ति", "काल"],
          grammar: "Comprehensive B1 review.",
        },
      ],
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 concepts",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: ["राय", "तर्क", "अनुभव", "निर्णय", "समस्या", "समाधान"],
        grammar: "Advanced B1 grammar reinforcement and mixed structures.",
      })),
    },

    {
      name: "Section 7: Daily Refresh (CEFR B2)",
      description: "Upper Intermediate",
      units: Array.from({ length: 36 }, (_, i) => ({
        id: `s7_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Concept ${i + 1}`,
        vocabulary: [
          "विश्लेषण",
          "संभावना",
          "दृष्टिकोण",
          "परिणाम",
          "संदर्भ",
          "तर्कसंगत",
        ],
        grammar: "B2-level sentence complexity, connectors, nuance.",
      })),
    },

    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery",
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [
          "सूक्ष्मता",
          "व्याख्या",
          "परिप्रेक्ष्य",
          "आलोचना",
          "अभिव्यक्ति",
          "परिष्कृत",
        ],
        grammar: "High-level comprehension, precision, and fluency.",
      })),
    },
  ],

  Korean: [
    {
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic words",
          vocabulary: ["사람", "남자", "여자", "학생", "선생님", "물", "밥"],
          grammar: "Basic nouns and sentence structure.",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "안녕하세요",
            "안녕",
            "반갑습니다",
            "잘 가요",
            "또 봐요",
          ],
          grammar: "Formal vs casual greetings.",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: ["저", "이름", "입니다", "이에요", "예요"],
          grammar: "Copula: 입니다 / 이에요 / 예요.",
        },
        {
          id: "u4",
          title: "Unit 4: Use present tense",
          vocabulary: ["가다", "오다", "먹다", "보다", "해요"],
          grammar: "Present polite tense -아요 / -어요.",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: ["여기", "거기", "집", "학교", "회사"],
          grammar: "Location words and 있다.",
        },
        {
          id: "u6",
          title: "Unit 6: Refer to family",
          vocabulary: ["아버지", "어머니", "형", "누나", "동생"],
          grammar: "Family terms and basic possession.",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about daily actions",
          vocabulary: ["일하다", "공부하다", "자다", "쉬다"],
          grammar: "Present tense daily verbs.",
        },
        {
          id: "u8",
          title: "Unit 8: Form plurals",
          vocabulary: ["사람들", "친구들", "학생들"],
          grammar: "Plural marker 들.",
        },
        {
          id: "u9",
          title: "Unit 9: Describe family",
          vocabulary: ["가족", "부모님", "형제"],
          grammar: "Describing people using adjectives.",
        },
        {
          id: "u10",
          title: "Unit 10: Order food",
          vocabulary: ["주세요", "이거", "저거", "맛있어요"],
          grammar: "Polite requests with 주세요.",
        },
      ],
    },

    {
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use adjectives",
          vocabulary: ["크다", "작다", "좋다", "나쁘다"],
          grammar: "Adjective use.",
        },
        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: ["가다", "에", "도시", "바다"],
          grammar: "에 + 가다.",
        },
        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: ["집", "방", "부엌", "거실"],
          grammar: "Location nouns.",
        },
        {
          id: "s2u4",
          title: "Unit 4: Describe work",
          vocabulary: ["회사", "직장", "일", "회의"],
          grammar: "Work expressions.",
        },
        {
          id: "s2u5",
          title: "Unit 5: Talk about food",
          vocabulary: ["밥", "김치", "고기", "과일"],
          grammar: "Food nouns.",
        },
        {
          id: "s2u6",
          title: "Unit 6: Use present tense",
          vocabulary: ["하다", "먹다", "보다"],
          grammar: "Verb conjugation review.",
        },
        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: ["옷", "바지", "신발", "사다"],
          grammar: "Shopping verbs.",
        },
        {
          id: "s2u8",
          title: "Unit 8: Exchange info",
          vocabulary: ["이름", "나이", "주소"],
          grammar: "Personal info.",
        },
        {
          id: "s2u9",
          title: "Unit 9: Use infinitive ideas",
          vocabulary: ["하고 싶다", "먹고 싶다"],
          grammar: "고 싶다.",
        },
        {
          id: "s2u10",
          title: "Unit 10: Ask questions",
          vocabulary: ["누구", "어디", "언제"],
          grammar: "Question words.",
        },
        {
          id: "s2u11",
          title: "Unit 11: Ask why",
          vocabulary: ["왜", "어떻게"],
          grammar: "Reason questions.",
        },
        {
          id: "s2u12",
          title: "Unit 12: Tell time",
          vocabulary: ["시간", "아침", "저녁"],
          grammar: "Time expressions.",
        },
        {
          id: "s2u13",
          title: "Unit 13: Speak formally",
          vocabulary: ["존댓말", "드세요"],
          grammar: "Honorific intro.",
        },
        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: ["운동", "음악", "여행"],
          grammar: "Likes/dislikes.",
        },
        {
          id: "s2u15",
          title: "Unit 15: Breakfast",
          vocabulary: ["아침", "커피", "빵"],
          grammar: "Daily routine.",
        },
        {
          id: "s2u16",
          title: "Unit 16: Travel plans",
          vocabulary: ["여행", "계획", "표"],
          grammar: "Future plan basics.",
        },
        {
          id: "s2u17",
          title: "Unit 17: School",
          vocabulary: ["학교", "수업", "시험"],
          grammar: "School context.",
        },
        {
          id: "s2u18",
          title: "Unit 18: Work schedule",
          vocabulary: ["일정", "바쁘다"],
          grammar: "Schedules.",
        },
        {
          id: "s2u19",
          title: "Unit 19: Hotel",
          vocabulary: ["호텔", "방", "예약"],
          grammar: "Booking phrases.",
        },
        {
          id: "s2u20",
          title: "Unit 20: Daily routine",
          vocabulary: ["일어나다", "자다"],
          grammar: "Routine verbs.",
        },
        {
          id: "s2u21",
          title: "Unit 21: Weather",
          vocabulary: ["날씨", "비", "눈"],
          grammar: "Weather expressions.",
        },
        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: ["키", "성격", "친절하다"],
          grammar: "Descriptions.",
        },
      ],
    },

    {
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: [
            "행복해요",
            "슬퍼요",
            "피곤해요",
            "스트레스",
            "기분",
            "좋아요",
            "나빠요",
          ],
          grammar: "Expressing emotions using adjectives.",
        },
        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: [
            "시장",
            "마트",
            "과일",
            "채소",
            "고기",
            "사다",
            "필요해요",
          ],
          grammar: "Shopping vocabulary and basic buying verbs.",
        },
        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: [
            "옷",
            "셔츠",
            "바지",
            "신발",
            "사이즈",
            "입다",
            "비싸요",
            "싸요",
          ],
          grammar: "Clothing nouns and descriptive adjectives.",
        },
        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: [
            "왼쪽",
            "오른쪽",
            "앞",
            "뒤",
            "직진",
            "근처",
            "어디예요",
          ],
          grammar: "Directional words and location questions.",
        },
        {
          id: "s3u5",
          title: "Unit 5: Talk about daily routine",
          vocabulary: ["일어나다", "씻다", "아침", "저녁", "잠자다", "하루"],
          grammar: "Daily routine verbs in present tense.",
        },
        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: ["시간", "주말", "영화", "산책", "운동하다", "취미"],
          grammar: "Leisure activities and frequency.",
        },
        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: ["생각해요", "제 생각에는", "좋은", "나쁜", "중요해요"],
          grammar: "Opinion structures and soft statements.",
        },
        {
          id: "s3u8",
          title: "Unit 8: Use object particles 을/를",
          vocabulary: ["을", "를", "밥을", "책을", "영화를", "커피를"],
          grammar: "Object particle usage.",
        },
        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: ["산", "강", "바다", "꽃", "나무", "날씨", "자연"],
          grammar: "Nature-related nouns and descriptions.",
        },
        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: ["부모님", "형제", "자매", "아들", "딸", "결혼"],
          grammar: "Family vocabulary and relations.",
        },
        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: ["학교", "수업", "선생님", "학생", "공부하다", "질문"],
          grammar: "School-related expressions.",
        },
        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: ["요리하다", "음식", "재료", "부엌", "칼", "불"],
          grammar: "Cooking actions and tools.",
        },
        {
          id: "s3u13",
          title: "Unit 13: Describe schedules",
          vocabulary: ["일정", "약속", "회의", "바쁘다", "시간", "계획"],
          grammar: "Talking about schedules and availability.",
        },
        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: ["여행", "휴가", "호텔", "비행기", "예약하다", "출발"],
          grammar: "Future plans using -(으)ㄹ 거예요.",
        },
        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: ["아파요", "병원", "의사", "약", "몸", "건강"],
          grammar: "Health expressions and conditions.",
        },
        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: ["집", "아파트", "방", "층", "이웃", "살다"],
          grammar: "Describing where you live.",
        },
        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: ["동료", "회사", "일", "프로젝트", "회의하다"],
          grammar: "Workplace communication basics.",
        },
        {
          id: "s3u18",
          title: "Unit 18: Use the past tense",
          vocabulary: ["했어요", "갔어요", "봤어요", "먹었어요", "만났어요"],
          grammar: "Past tense polite ending -았어요 / -었어요.",
        },
        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: ["어제", "지난주", "최근에", "이미", "방금"],
          grammar: "Recent past expressions.",
        },
        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: ["도와줄게요", "필요해요", "주세요", "괜찮아요", "같이"],
          grammar: "Offering help and polite requests.",
        },
        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: [
            "여행했어요",
            "도착했어요",
            "출발했어요",
            "사진",
            "추억",
          ],
          grammar: "Past tense narration for travel.",
        },
      ],
    },

    {
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Expanded everyday conversations and practical situations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Review present tense",
          vocabulary: ["가요", "먹어요", "봐요", "해요", "있어요"],
          grammar: "Present polite tense review.",
        },
        {
          id: "s4u2",
          title: "Unit 2: Review past tense",
          vocabulary: ["갔어요", "먹었어요", "봤어요", "했어요", "있었어요"],
          grammar: "Past tense polite endings.",
        },
        {
          id: "s4u3",
          title: "Unit 3: Talk about yesterday",
          vocabulary: ["어제", "어젯밤", "그제", "하루", "일"],
          grammar: "Past time expressions.",
        },
        {
          id: "s4u4",
          title: "Unit 4: Talk about last week",
          vocabulary: ["지난주", "지난달", "최근에", "주말"],
          grammar: "Extended past references.",
        },

        {
          id: "s4u5",
          title: "Unit 5: Compare objects",
          vocabulary: ["더", "덜", "비슷해요", "같아요", "다르다"],
          grammar: "Basic comparisons.",
        },
        {
          id: "s4u6",
          title: "Unit 6: Compare people",
          vocabulary: ["키", "성격", "나이", "보다", "제일"],
          grammar: "Comparing people using 보다.",
        },
        {
          id: "s4u7",
          title: "Unit 7: Express preferences",
          vocabulary: ["좋아해요", "싫어해요", "더 좋아해요", "선호하다"],
          grammar: "Preference structures.",
        },

        {
          id: "s4u8",
          title: "Unit 8: Describe personality",
          vocabulary: ["친절해요", "조용해요", "활발해요", "성격"],
          grammar: "Personality adjectives.",
        },
        {
          id: "s4u9",
          title: "Unit 9: Describe mood",
          vocabulary: ["기분", "행복해요", "피곤해요", "스트레스"],
          grammar: "Mood expressions.",
        },

        {
          id: "s4u10",
          title: "Unit 10: Talk about work",
          vocabulary: ["회사", "직장", "업무", "동료", "사무실"],
          grammar: "Workplace vocabulary.",
        },
        {
          id: "s4u11",
          title: "Unit 11: Work routines",
          vocabulary: ["출근하다", "퇴근하다", "회의", "야근"],
          grammar: "Daily work routines.",
        },
        {
          id: "s4u12",
          title: "Unit 12: Talk about studies",
          vocabulary: ["전공", "수업", "과제", "시험", "졸업"],
          grammar: "School and university context.",
        },

        {
          id: "s4u13",
          title: "Unit 13: Express opinions",
          vocabulary: ["생각해요", "제 생각에는", "의견", "중요해요"],
          grammar: "Opinion expressions.",
        },
        {
          id: "s4u14",
          title: "Unit 14: Agree and disagree",
          vocabulary: ["맞아요", "아니에요", "동의해요", "반대하다"],
          grammar: "Agreement and disagreement.",
        },

        {
          id: "s4u15",
          title: "Unit 15: Make suggestions",
          vocabulary: ["하면 어때요", "같이", "한번", "다음에"],
          grammar: "Suggestion patterns.",
        },
        {
          id: "s4u16",
          title: "Unit 16: Invite someone",
          vocabulary: ["초대하다", "같이 가요", "만나다"],
          grammar: "Invitations and responses.",
        },

        {
          id: "s4u17",
          title: "Unit 17: Talk about hobbies",
          vocabulary: ["취미", "운동", "요리", "사진", "여행"],
          grammar: "Hobby-related expressions.",
        },
        {
          id: "s4u18",
          title: "Unit 18: Frequency expressions",
          vocabulary: ["자주", "가끔", "항상", "거의"],
          grammar: "Adverbs of frequency.",
        },

        {
          id: "s4u19",
          title: "Unit 19: Talk about experiences",
          vocabulary: ["가본 적 있어요", "해본 적 있어요", "경험"],
          grammar: "Experience form -(으)ㄴ 적 있다.",
        },
        {
          id: "s4u20",
          title: "Unit 20: First-time experiences",
          vocabulary: ["처음", "이미", "아직"],
          grammar: "Time-related adverbs.",
        },

        {
          id: "s4u21",
          title: "Unit 21: Describe places",
          vocabulary: ["조용해요", "복잡해요", "깨끗해요", "유명해요"],
          grammar: "Place descriptions.",
        },
        {
          id: "s4u22",
          title: "Unit 22: Give directions",
          vocabulary: ["왼쪽", "오른쪽", "건너편", "근처", "길"],
          grammar: "Directional language.",
        },

        {
          id: "s4u23",
          title: "Unit 23: Travel planning",
          vocabulary: ["여행", "계획", "표", "출발", "도착"],
          grammar: "Travel planning phrases.",
        },
        {
          id: "s4u24",
          title: "Unit 24: Transportation",
          vocabulary: ["버스", "지하철", "기차", "택시"],
          grammar: "Transportation nouns.",
        },

        {
          id: "s4u25",
          title: "Unit 25: Hotel situations",
          vocabulary: ["호텔", "예약", "방", "체크인"],
          grammar: "Hotel interactions.",
        },
        {
          id: "s4u26",
          title: "Unit 26: Problems at hotels",
          vocabulary: ["문제", "불편해요", "고장", "바꾸다"],
          grammar: "Complaints.",
        },

        {
          id: "s4u27",
          title: "Unit 27: Talk about health",
          vocabulary: ["아파요", "병원", "약", "의사"],
          grammar: "Health expressions.",
        },
        {
          id: "s4u28",
          title: "Unit 28: Describe symptoms",
          vocabulary: ["열", "기침", "두통", "아프다"],
          grammar: "Describing symptoms.",
        },

        {
          id: "s4u29",
          title: "Unit 29: Ask for help",
          vocabulary: ["도와주세요", "부탁해요", "필요해요"],
          grammar: "Requesting help.",
        },
        {
          id: "s4u30",
          title: "Unit 30: Make polite requests",
          vocabulary: ["주실 수 있어요", "잠시만요", "괜찮아요"],
          grammar: "Polite request structures.",
        },

        {
          id: "s4u31",
          title: "Unit 31: Talk about money",
          vocabulary: ["돈", "가격", "비싸요", "싸요", "월급"],
          grammar: "Money-related expressions.",
        },
        {
          id: "s4u32",
          title: "Unit 32: Shopping problems",
          vocabulary: ["환불", "교환", "영수증"],
          grammar: "Shopping complaints.",
        },

        {
          id: "s4u33",
          title: "Unit 33: Give reasons",
          vocabulary: ["때문에", "그래서", "이유"],
          grammar: "Cause and reason.",
        },
        {
          id: "s4u34",
          title: "Unit 34: Explain situations",
          vocabulary: ["상황", "문제", "해결"],
          grammar: "Explaining situations.",
        },

        {
          id: "s4u35",
          title: "Unit 35: Talk about schedules",
          vocabulary: ["일정", "약속", "바쁘다", "시간"],
          grammar: "Scheduling language.",
        },
        {
          id: "s4u36",
          title: "Unit 36: Change plans",
          vocabulary: ["변경", "취소", "다시"],
          grammar: "Plan changes.",
        },

        {
          id: "s4u37",
          title: "Unit 37: Use connectors",
          vocabulary: ["그리고", "하지만", "그래서", "그래도"],
          grammar: "Sentence connectors.",
        },
        {
          id: "s4u38",
          title: "Unit 38: Longer past narration",
          vocabulary: ["그때", "이후", "동안"],
          grammar: "Extended narration.",
        },

        {
          id: "s4u39",
          title: "Unit 39: Express feelings about events",
          vocabulary: ["재미있었어요", "힘들었어요", "기억"],
          grammar: "Reflecting on events.",
        },
        {
          id: "s4u40",
          title: "Unit 40: Reflect on experiences",
          vocabulary: ["느꼈어요", "배웠어요", "중요해요"],
          grammar: "Reflection language.",
        },

        {
          id: "s4u41",
          title: "Unit 41: Use honorific basics",
          vocabulary: ["드세요", "계세요", "주무세요"],
          grammar: "Honorific verb introduction.",
        },
        {
          id: "s4u42",
          title: "Unit 42: Polite social language",
          vocabulary: ["말씀", "댁", "연락"],
          grammar: "Polite nouns.",
        },

        {
          id: "s4u43",
          title: "Unit 43: Handle misunderstandings",
          vocabulary: ["다시 말해 주세요", "이해했어요", "모르겠어요"],
          grammar: "Clarification phrases.",
        },
        {
          id: "s4u44",
          title: "Unit 44: Apologize politely",
          vocabulary: ["죄송해요", "미안해요", "실수"],
          grammar: "Apologies.",
        },

        {
          id: "s4u45",
          title: "Unit 45: Summarize experiences",
          vocabulary: ["전반적으로", "전체적으로", "결국"],
          grammar: "Summarizing events.",
        },
        {
          id: "s4u46",
          title: "Unit 46: Section review & integration",
          vocabulary: ["복습", "정리", "다시"],
          grammar: "Integrated practice and review.",
        },
      ],
    },

    {
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Wide variety of topics and independent expression",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Order food politely",
          vocabulary: ["주문하다", "메뉴", "추천", "음료", "계산서"],
          grammar: "Polite ordering structures.",
        },
        {
          id: "s5u2",
          title: "Unit 2: Talk about festivals",
          vocabulary: ["축제", "행사", "전통", "불꽃놀이", "공연"],
          grammar: "Describing cultural events.",
        },
        {
          id: "s5u3",
          title: "Unit 3: Express negation and absence",
          vocabulary: ["아무도", "아무것도", "전혀", "결코", "없다"],
          grammar: "Advanced negation forms.",
        },
        {
          id: "s5u4",
          title: "Unit 4: Discuss gifts",
          vocabulary: ["선물", "포장", "의미", "기념", "감사"],
          grammar: "Giving and receiving expressions.",
        },
        {
          id: "s5u5",
          title: "Unit 5: Talk about school life",
          vocabulary: ["과제", "시험", "성적", "수업", "학기"],
          grammar: "School-related narration.",
        },
        {
          id: "s5u6",
          title: "Unit 6: Describe relationships",
          vocabulary: ["관계", "신뢰", "존중", "갈등", "이해"],
          grammar: "Talking about social bonds.",
        },
        {
          id: "s5u7",
          title: "Unit 7: Career planning",
          vocabulary: ["진로", "목표", "경력", "계획", "미래"],
          grammar: "Future goals and plans.",
        },
        {
          id: "s5u8",
          title: "Unit 8: Express opinions",
          vocabulary: ["의견", "생각하다", "동의하다", "반대하다"],
          grammar: "Opinion structures.",
        },
        {
          id: "s5u9",
          title: "Unit 9: Talk about nature",
          vocabulary: ["자연", "숲", "호수", "환경", "보호"],
          grammar: "Describing environments.",
        },
        {
          id: "s5u10",
          title: "Unit 10: Use relative ideas",
          vocabulary: ["사람", "것", "장소", "이유", "방법"],
          grammar: "Relative descriptions (conceptual).",
        },

        {
          id: "s5u11",
          title: "Unit 11: Discuss sports",
          vocabulary: ["운동", "경기", "팀", "훈련", "대회"],
          grammar: "Sports narration.",
        },
        {
          id: "s5u12",
          title: "Unit 12: Compare past and present",
          vocabulary: ["예전", "현재", "변화", "차이", "경험"],
          grammar: "Past vs present comparison.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Environmental issues",
          vocabulary: ["오염", "기후", "재활용", "에너지", "문제"],
          grammar: "Cause–effect explanation.",
        },
        {
          id: "s5u14",
          title: "Unit 14: Health discussions",
          vocabulary: ["증상", "치료", "피로", "스트레스", "건강"],
          grammar: "Health-related explanations.",
        },
        {
          id: "s5u15",
          title: "Unit 15: Workplace communication",
          vocabulary: ["업무", "회의", "책임", "동료", "보고"],
          grammar: "Formal work language.",
        },
        {
          id: "s5u16",
          title: "Unit 16: Use place and quantity pronouns",
          vocabulary: ["여기", "거기", "많이", "조금", "모두"],
          grammar: "Referential expressions.",
        },
        {
          id: "s5u17",
          title: "Unit 17: Talk about siblings",
          vocabulary: ["형제", "자매", "어릴 때", "성격", "차이"],
          grammar: "Family comparison.",
        },
        {
          id: "s5u18",
          title: "Unit 18: Follow instructions",
          vocabulary: ["요리하다", "단계", "순서", "재료", "방법"],
          grammar: "Imperative structures.",
        },
        {
          id: "s5u19",
          title: "Unit 19: Media and interviews",
          vocabulary: ["인터뷰", "질문", "대답", "기사", "유명인"],
          grammar: "Reported speech basics.",
        },
        {
          id: "s5u20",
          title: "Unit 20: Describe ceremonies",
          vocabulary: ["결혼식", "의식", "초대", "축하", "전통"],
          grammar: "Event narration.",
        },

        {
          id: "s5u21",
          title: "Unit 21: Travel communication",
          vocabulary: ["여행", "예약", "안내", "일정", "정보"],
          grammar: "Travel interaction.",
        },
        {
          id: "s5u22",
          title: "Unit 22: Household responsibilities",
          vocabulary: ["청소", "세탁", "정리", "의무", "역할"],
          grammar: "Obligation expressions.",
        },
        {
          id: "s5u23",
          title: "Unit 23: Travel abroad",
          vocabulary: ["여권", "비자", "공항", "입국", "출국"],
          grammar: "International travel vocabulary.",
        },
        {
          id: "s5u24",
          title: "Unit 24: Internet usage",
          vocabulary: ["인터넷", "메시지", "사이트", "계정", "보안"],
          grammar: "Digital actions.",
        },
        {
          id: "s5u25",
          title: "Unit 25: Describe food",
          vocabulary: ["맛", "향", "재료", "요리", "식감"],
          grammar: "Food description.",
        },
        {
          id: "s5u26",
          title: "Unit 26: Expand descriptions",
          vocabulary: ["사람", "물건", "이야기", "설명", "특징"],
          grammar: "Descriptive clauses.",
        },
        {
          id: "s5u27",
          title: "Unit 27: Solve problems",
          vocabulary: ["문제", "해결", "결정", "상황", "대처"],
          grammar: "Problem-solving language.",
        },
        {
          id: "s5u28",
          title: "Unit 28: Technology trends",
          vocabulary: ["기술", "혁신", "로봇", "미래", "발전"],
          grammar: "Trend discussion.",
        },
        {
          id: "s5u29",
          title: "Unit 29: Analyze media",
          vocabulary: ["기사", "출처", "정보", "사실", "의견"],
          grammar: "Critical discussion.",
        },
        {
          id: "s5u30",
          title: "Unit 30: Talk about cinema",
          vocabulary: ["영화", "장면", "배우", "감독", "장르"],
          grammar: "Film discussion.",
        },

        {
          id: "s5u31",
          title: "Unit 31: Debate current events",
          vocabulary: ["사회", "이슈", "토론", "의견", "입장"],
          grammar: "Debate structures.",
        },
        {
          id: "s5u32",
          title: "Unit 32: Advanced negation",
          vocabulary: ["별로", "거의", "전혀", "다시", "더 이상"],
          grammar: "Nuanced negation.",
        },
        {
          id: "s5u33",
          title: "Unit 33: Abstract ideas",
          vocabulary: ["자유", "가치", "정의", "의미", "개념"],
          grammar: "Abstract expression.",
        },
        {
          id: "s5u34",
          title: "Unit 34: University life",
          vocabulary: ["캠퍼스", "전공", "강의", "도서관", "시험"],
          grammar: "Academic discussion.",
        },
        {
          id: "s5u35",
          title: "Unit 35: Volunteering",
          vocabulary: ["봉사", "단체", "참여", "기여", "도움"],
          grammar: "Purpose expressions.",
        },
        {
          id: "s5u36",
          title: "Unit 36: Review past tenses",
          vocabulary: ["경험", "기억", "이야기", "순서", "변화"],
          grammar: "Past tense contrast.",
        },
        {
          id: "s5u37",
          title: "Unit 37: Express necessity",
          vocabulary: ["필요하다", "중요하다", "해야 하다"],
          grammar: "Necessity and obligation.",
        },
        {
          id: "s5u38",
          title: "Unit 38: Express doubt",
          vocabulary: ["아마", "확실하지 않다", "가능성"],
          grammar: "Uncertainty expressions.",
        },
        {
          id: "s5u39",
          title: "Unit 39: Environmental debate",
          vocabulary: ["기후", "지속 가능", "보호", "문제"],
          grammar: "Cause and solution.",
        },
        {
          id: "s5u40",
          title: "Unit 40: Performing arts",
          vocabulary: ["공연", "무대", "예술", "관객", "배우"],
          grammar: "Art discussion.",
        },

        {
          id: "s5u41",
          title: "Unit 41: Job interviews",
          vocabulary: ["면접", "경험", "역량", "자기소개"],
          grammar: "Formal self-presentation.",
        },
        {
          id: "s5u42",
          title: "Unit 42: Formal emails",
          vocabulary: ["이메일", "제목", "첨부", "정중"],
          grammar: "Formal writing.",
        },
        {
          id: "s5u43",
          title: "Unit 43: Architecture",
          vocabulary: ["건축", "디자인", "구조", "도시"],
          grammar: "Descriptive explanation.",
        },
        {
          id: "s5u44",
          title: "Unit 44: Fashion trends",
          vocabulary: ["유행", "스타일", "브랜드", "디자인"],
          grammar: "Trend comparison.",
        },
        {
          id: "s5u45",
          title: "Unit 45: Conditional sentences",
          vocabulary: ["만약", "조건", "결과"],
          grammar: "Conditional reasoning.",
        },
        {
          id: "s5u46",
          title: "Unit 46: Storytelling",
          vocabulary: ["이야기", "장면", "인물", "사건"],
          grammar: "Narrative connectors.",
        },
        {
          id: "s5u47",
          title: "Unit 47: Traditions",
          vocabulary: ["전통", "문화", "의식", "관습"],
          grammar: "Cultural narration.",
        },
        {
          id: "s5u48",
          title: "Unit 48: Historical events",
          vocabulary: ["역사", "시대", "사건", "변화"],
          grammar: "Chronological narration.",
        },
        {
          id: "s5u49",
          title: "Unit 49: Legal topics",
          vocabulary: ["법", "권리", "의무", "제도"],
          grammar: "Formal legal language.",
        },
        {
          id: "s5u50",
          title: "Unit 50: Passive voice",
          vocabulary: ["되다", "받다", "작성되다"],
          grammar: "Passive constructions.",
        },
        {
          id: "s5u51",
          title: "Unit 51: Final B1 review",
          vocabulary: ["정리", "복습", "표현", "문법"],
          grammar: "Comprehensive B1 review.",
        },
      ],
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 reinforcement and fluency practice",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6_u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced B1 grammar reinforcement",
      })),
    },

    {
      name: "Section 7: Daily Refresh (CEFR B2)",
      description: "Upper-intermediate accuracy and consistency",
      units: Array.from({ length: 36 }, (_, i) => ({
        id: `s7_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Concept ${i + 1}`,
        vocabulary: [],
        grammar: "B2-level structures and refinement",
      })),
    },

    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery and near-native command",
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8_u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced mastery and nuance",
      })),
    },
  ],

  Italian: [
    {
      name: "Section 1: Rookie (CEFR Intro)",
      description: "Essential phrases & simple grammar",
      units: [
        {
          id: "u1",
          title: "Unit 1: Use basic phrases",
          vocabulary: [
            "uno",
            "una",
            "gatto",
            "cane",
            "pizza",
            "pane",
            "uomo",
            "donna",
            "è",
            "mangia",
            "e",
          ],
          grammar: "Gender (uno/una), basic nouns, verb 'essere' (è).",
        },
        {
          id: "u2",
          title: "Unit 2: Greet people",
          vocabulary: [
            "ciao",
            "buongiorno",
            "buonasera",
            "buonanotte",
            "a presto",
            "arrivederci",
            "come",
            "stai",
            "bene",
            "grazie",
            "prego",
          ],
          grammar: "Greetings, politeness, asking how someone is.",
        },
        {
          id: "u3",
          title: "Unit 3: Introduce yourself",
          vocabulary: [
            "io",
            "tu",
            "lui",
            "lei",
            "mi chiamo",
            "sei",
            "sono",
            "italiano",
            "studente",
            "lavoro",
          ],
          grammar: "Subject pronouns and verb 'essere' (to be).",
        },
        {
          id: "u4",
          title: "Unit 4: Use the present tense",
          vocabulary: [
            "parlo",
            "parli",
            "parla",
            "scusa",
            "per favore",
            "capisco",
            "lingua",
          ],
          grammar: "Present tense of regular -are verbs (parlare).",
        },
        {
          id: "u5",
          title: "Unit 5: Get around town",
          vocabulary: [
            "dove",
            "è",
            "il",
            "la",
            "stazione",
            "aeroporto",
            "taxi",
            "hotel",
            "strada",
          ],
          grammar: "Definite articles (il/la), asking where something is.",
        },
        {
          id: "u6",
          title: "Unit 6: Talk about family",
          vocabulary: [
            "mio",
            "mia",
            "padre",
            "madre",
            "fratello",
            "sorella",
            "famiglia",
          ],
          grammar: "Possessive adjectives (mio/mia).",
        },
        {
          id: "u7",
          title: "Unit 7: Talk about daily activities",
          vocabulary: ["vivo", "abito", "lavoro", "studio", "qui", "città"],
          grammar: "Present tense of common verbs (vivere, lavorare).",
        },
        {
          id: "u8",
          title: "Unit 8: Form the plural",
          vocabulary: ["i", "le", "gatti", "cani", "case", "persone"],
          grammar: "Plural nouns and articles (i/le).",
        },
        {
          id: "u9",
          title: "Unit 9: Describe your family",
          vocabulary: [
            "genitori",
            "figlio",
            "figlia",
            "con",
            "insieme",
            "casa",
          ],
          grammar: "Family descriptions and plural possessives.",
        },
        {
          id: "u10",
          title: "Unit 10: Order food and drink",
          vocabulary: [
            "acqua",
            "caffè",
            "ristorante",
            "tavolo",
            "conto",
            "vorrei",
          ],
          grammar: "Polite requests with 'vorrei'.",
        },
      ],
    },

    {
      name: "Section 2: Explorer (CEFR A1)",
      description: "Basic interactions",
      units: [
        {
          id: "s2u1",
          title: "Unit 1: Use gender and number agreement",
          vocabulary: [
            "grande",
            "piccolo",
            "nuovo",
            "vecchio",
            "bello",
            "brutto",
          ],
          grammar: "Gender and number agreement of adjectives.",
        },
        {
          id: "s2u2",
          title: "Unit 2: Discuss destinations",
          vocabulary: [
            "andare",
            "a",
            "al",
            "alla",
            "città",
            "mare",
            "montagna",
          ],
          grammar: "Andare + place, prepositions for destinations.",
        },
        {
          id: "s2u3",
          title: "Unit 3: Describe your home",
          vocabulary: [
            "casa",
            "appartamento",
            "stanza",
            "cucina",
            "salotto",
            "balcone",
          ],
          grammar: "Describing rooms and spaces.",
        },
        {
          id: "s2u4",
          title: "Unit 4: Describe where you work",
          vocabulary: [
            "ufficio",
            "azienda",
            "collega",
            "computer",
            "lavoro",
            "capo",
          ],
          grammar: "Workplace vocabulary and present tense.",
        },
        {
          id: "s2u5",
          title: "Unit 5: Talk about food",
          vocabulary: ["pane", "riso", "pasta", "carne", "pesce", "delizioso"],
          grammar: "Food nouns and adjective agreement.",
        },
        {
          id: "s2u6",
          title: "Unit 6: Use the present tense",
          vocabulary: [
            "parlare",
            "finire",
            "prendere",
            "andare",
            "venire",
            "fare",
          ],
          grammar: "Present tense of regular and common irregular verbs.",
        },
        {
          id: "s2u7",
          title: "Unit 7: Shop for clothes",
          vocabulary: [
            "vestito",
            "camicia",
            "scarpe",
            "pantaloni",
            "taglia",
            "colore",
          ],
          grammar: "Shopping expressions and adjective agreement.",
        },
        {
          id: "s2u8",
          title: "Unit 8: Exchange personal information",
          vocabulary: ["età", "indirizzo", "numero", "professione", "nome"],
          grammar: "Asking and giving personal information.",
        },
        {
          id: "s2u9",
          title: "Unit 9: Use the infinitive",
          vocabulary: ["piacere", "volere", "potere", "dovere", "iniziare"],
          grammar: "Verbs followed by infinitive.",
        },
        {
          id: "s2u10",
          title: "Unit 10: Ask people about themselves",
          vocabulary: ["chi", "dove", "da dove", "abitare", "lavorare"],
          grammar: "Basic question structures.",
        },

        {
          id: "s2u11",
          title: "Unit 11: Ask questions",
          vocabulary: ["perché", "come", "quando", "quale", "quanto"],
          grammar: "Question words and intonation.",
        },
        {
          id: "s2u12",
          title: "Unit 12: Tell time",
          vocabulary: ["ora", "minuto", "mattina", "sera", "notte"],
          grammar: "Telling time and daily routine.",
        },
        {
          id: "s2u13",
          title: "Unit 13: Talk formally",
          vocabulary: ["Lei", "signore", "signora", "per favore", "scusi"],
          grammar: "Formal vs informal speech.",
        },
        {
          id: "s2u14",
          title: "Unit 14: Talk about hobbies",
          vocabulary: [
            "leggere",
            "giocare",
            "ballare",
            "viaggiare",
            "musica",
            "sport",
          ],
          grammar: "Expressing likes and dislikes.",
        },
        {
          id: "s2u15",
          title: "Unit 15: Describe your breakfast",
          vocabulary: [
            "caffè",
            "latte",
            "burro",
            "pane",
            "marmellata",
            "succo",
          ],
          grammar: "Food expressions and daily habits.",
        },
        {
          id: "s2u16",
          title: "Unit 16: Discuss travel plans",
          vocabulary: [
            "viaggiare",
            "vacanza",
            "biglietto",
            "treno",
            "prenotazione",
          ],
          grammar: "Future intention with andare + infinitive.",
        },
        {
          id: "s2u17",
          title: "Unit 17: Talk about school",
          vocabulary: [
            "scuola",
            "insegnante",
            "studente",
            "classe",
            "studiare",
          ],
          grammar: "School-related verbs.",
        },
        {
          id: "s2u18",
          title: "Unit 18: Share work schedules",
          vocabulary: ["orario", "lavoro", "pausa", "riunione", "ogni giorno"],
          grammar: "Time expressions and routines.",
        },
        {
          id: "s2u19",
          title: "Unit 19: Book a hotel",
          vocabulary: ["hotel", "camera", "chiave", "prenotare", "reception"],
          grammar: "Booking and service expressions.",
        },
        {
          id: "s2u20",
          title: "Unit 20: Describe your routine",
          vocabulary: ["alzarsi", "lavarsi", "mangiare", "uscire", "rientrare"],
          grammar: "Reflexive verbs in the present.",
        },
        {
          id: "s2u21",
          title: "Unit 21: Talk about the weather",
          vocabulary: ["caldo", "freddo", "pioggia", "neve", "sole", "nuvola"],
          grammar: "Weather expressions.",
        },
        {
          id: "s2u22",
          title: "Unit 22: Describe people",
          vocabulary: [
            "alto",
            "basso",
            "occhi",
            "capelli",
            "simpatico",
            "intelligente",
          ],
          grammar: "Physical and personality descriptions.",
        },
      ],
    },
    {
      name: "Section 3: Traveler (CEFR A1)",
      description: "Foundational concepts for everyday communication",
      units: [
        {
          id: "s3u1",
          title: "Unit 1: Express feelings",
          vocabulary: ["felice", "triste", "stanco", "arrabbiato", "contento"],
          grammar: "Expressions with essere + adjectives.",
        },
        {
          id: "s3u2",
          title: "Unit 2: Shop for groceries",
          vocabulary: [
            "mercato",
            "supermercato",
            "frutta",
            "verdura",
            "bottiglia",
            "pacchetto",
          ],
          grammar: "Quantities and partitive expressions.",
        },
        {
          id: "s3u3",
          title: "Unit 3: Shop for clothes",
          vocabulary: ["negozio", "provare", "caro", "economico", "camerino"],
          grammar: "Comparatives and shopping phrases.",
        },
        {
          id: "s3u4",
          title: "Unit 4: Get directions",
          vocabulary: [
            "destra",
            "sinistra",
            "dritto",
            "vicino",
            "lontano",
            "mappa",
          ],
          grammar: "Imperatives and prepositions of place.",
        },
        {
          id: "s3u5",
          title: "Unit 5: Talk about daily routine",
          vocabulary: [
            "alzarsi",
            "prepararsi",
            "lavorare",
            "studiare",
            "sera",
            "mattina",
          ],
          grammar: "Reflexive verbs in daily routines.",
        },
        {
          id: "s3u6",
          title: "Unit 6: Talk about free time",
          vocabulary: [
            "uscire",
            "incontrare",
            "parco",
            "cinema",
            "tempo libero",
          ],
          grammar: "Present tense activity verbs.",
        },
        {
          id: "s3u7",
          title: "Unit 7: Express opinions",
          vocabulary: [
            "penso",
            "credo",
            "secondo me",
            "importante",
            "interessante",
          ],
          grammar: "Opinion structures.",
        },
        {
          id: "s3u8",
          title: "Unit 8: Use direct object pronouns",
          vocabulary: ["mi", "ti", "lo", "la", "ci", "li"],
          grammar: "Direct object pronouns.",
        },
        {
          id: "s3u9",
          title: "Unit 9: Talk about nature",
          vocabulary: [
            "foresta",
            "fiume",
            "montagna",
            "fiore",
            "sole",
            "pioggia",
          ],
          grammar: "Using c’è / ci sono.",
        },
        {
          id: "s3u10",
          title: "Unit 10: Describe your family",
          vocabulary: ["zio", "zia", "cugino", "cugina", "sposato", "single"],
          grammar: "Extended family vocabulary.",
        },

        {
          id: "s3u11",
          title: "Unit 11: Communicate at school",
          vocabulary: [
            "lezione",
            "materia",
            "insegnante",
            "studente",
            "compiti",
          ],
          grammar: "School-related expressions.",
        },
        {
          id: "s3u12",
          title: "Unit 12: Talk about cooking",
          vocabulary: [
            "cucinare",
            "ricetta",
            "ingrediente",
            "forno",
            "pentola",
          ],
          grammar: "Imperatives and instructions.",
        },
        {
          id: "s3u13",
          title: "Unit 13: Describe your schedule",
          vocabulary: ["orario", "programma", "attività", "riunione"],
          grammar: "Saying when things happen.",
        },
        {
          id: "s3u14",
          title: "Unit 14: Make vacation plans",
          vocabulary: ["vacanza", "prenotare", "hotel", "spiaggia", "viaggio"],
          grammar: "Future intention expressions.",
        },
        {
          id: "s3u15",
          title: "Unit 15: Talk about your health",
          vocabulary: ["malato", "febbre", "tosse", "medico", "farmacia"],
          grammar: "Health expressions.",
        },
        {
          id: "s3u16",
          title: "Unit 16: Describe housing",
          vocabulary: ["palazzo", "piano", "stanza", "muro", "vicino"],
          grammar: "Describing places and housing.",
        },
        {
          id: "s3u17",
          title: "Unit 17: Communicate with coworkers",
          vocabulary: ["progetto", "collega", "capo", "ufficio", "compito"],
          grammar: "Workplace interaction.",
        },
        {
          id: "s3u18",
          title: "Unit 18: Talk about the past",
          vocabulary: ["ieri", "settimana scorsa", "andato", "fatto", "visto"],
          grammar: "Introduction to past tense (passato prossimo).",
        },
        {
          id: "s3u19",
          title: "Unit 19: Talk about recent events",
          vocabulary: ["appena", "recentemente", "successo", "evento"],
          grammar: "Recent past narration.",
        },
        {
          id: "s3u20",
          title: "Unit 20: Make offers and requests",
          vocabulary: ["potere", "aiutare", "vuoi", "posso", "offrire"],
          grammar: "Polite offers and requests.",
        },
        {
          id: "s3u21",
          title: "Unit 21: Talk about a recent trip",
          vocabulary: ["viaggio", "visitato", "arrivato", "partito", "ricordo"],
          grammar: "Past tense with travel verbs.",
        },
      ],
    },

    {
      name: "Section 4: Trailblazer (CEFR A2)",
      description: "Everyday topics & conversations",
      units: [
        {
          id: "s4u1",
          title: "Unit 1: Use the present tense",
          vocabulary: [
            "parlare",
            "finire",
            "prendere",
            "andare",
            "venire",
            "fare",
          ],
          grammar: "Review of present tense verbs.",
        },
        {
          id: "s4u2",
          title: "Unit 2: Describe your weekend",
          vocabulary: ["fatto", "visto", "mangiato", "andato", "ieri"],
          grammar: "Passato prossimo for recent events.",
        },
        {
          id: "s4u3",
          title: "Unit 3: Describe people",
          vocabulary: ["gentile", "divertente", "calmo", "timido", "socievole"],
          grammar: "Adjective agreement for personality.",
        },
        {
          id: "s4u4",
          title: "Unit 4: Talk about classes",
          vocabulary: ["matematica", "storia", "scienza", "esame", "lezione"],
          grammar: "School vocabulary.",
        },
        {
          id: "s4u5",
          title: "Unit 5: Extended family",
          vocabulary: ["zio", "zia", "cugino", "nipote", "parente"],
          grammar: "Extended family nouns.",
        },
        {
          id: "s4u6",
          title: "Unit 6: Talk about cities",
          vocabulary: ["museo", "ponte", "quartiere", "monumento", "fiume"],
          grammar: "Describing places.",
        },
        {
          id: "s4u7",
          title: "Unit 7: Comment on clothes",
          vocabulary: ["elegante", "semplice", "colorato", "stile", "moda"],
          grammar: "Clothing opinions.",
        },
        {
          id: "s4u8",
          title: "Unit 8: Make requests",
          vocabulary: ["potresti", "potrei", "aiutare", "dare", "portare"],
          grammar: "Polite requests.",
        },
        {
          id: "s4u9",
          title: "Unit 9: Shop at a market",
          vocabulary: ["mercante", "prezzo", "chilo", "fresco", "offerta"],
          grammar: "Market expressions.",
        },
        {
          id: "s4u10",
          title: "Unit 10: Past tense review",
          vocabulary: ["stato", "avuto", "preso", "visto", "partito"],
          grammar: "Passato prossimo with essere/avere.",
        },

        {
          id: "s4u11",
          title: "Unit 11: Indirect objects",
          vocabulary: ["mi", "ti", "gli", "ci", "vi", "loro"],
          grammar: "Indirect object pronouns.",
        },
        {
          id: "s4u12",
          title: "Unit 12: Hotel communication",
          vocabulary: [
            "prenotare",
            "chiave",
            "reception",
            "servizio",
            "ascensore",
          ],
          grammar: "Hotel expressions.",
        },
        {
          id: "s4u13",
          title: "Unit 13: Spending money",
          vocabulary: [
            "comprare",
            "spendere",
            "budget",
            "costoso",
            "economico",
          ],
          grammar: "Money-related verbs.",
        },
        {
          id: "s4u14",
          title: "Unit 14: Family gatherings",
          vocabulary: ["riunione", "festa", "invito", "occasione", "famiglia"],
          grammar: "Event narration.",
        },
        {
          id: "s4u15",
          title: "Unit 15: Travel experiences",
          vocabulary: ["viaggiato", "visitato", "luogo", "ricordo", "paese"],
          grammar: "Sharing experiences.",
        },
        {
          id: "s4u16",
          title: "Unit 16: Past habits",
          vocabulary: ["computer", "internet", "usare", "prima", "spesso"],
          grammar: "Imperfect tense introduction.",
        },
        {
          id: "s4u17",
          title: "Unit 17: Games and media",
          vocabulary: ["gioco", "film", "musica", "programma", "leggere"],
          grammar: "Preferences.",
        },
        {
          id: "s4u18",
          title: "Unit 18: Exercise and health",
          vocabulary: ["correre", "camminare", "palestra", "salute", "forma"],
          grammar: "Expressions with fare.",
        },
        {
          id: "s4u19",
          title: "Unit 19: Discuss money",
          vocabulary: ["denaro", "risparmiare", "banca", "pagare", "stipendio"],
          grammar: "Financial vocabulary.",
        },
        {
          id: "s4u20",
          title: "Unit 20: Describe food",
          vocabulary: ["dolce", "salato", "amaro", "piccante", "delizioso"],
          grammar: "Food adjectives.",
        },

        {
          id: "s4u21",
          title: "Unit 21: Make plans",
          vocabulary: [
            "uscire",
            "incontrare",
            "programma",
            "sera",
            "disponibile",
          ],
          grammar: "Future plans.",
        },
        {
          id: "s4u22",
          title: "Unit 22: Talk about childhood",
          vocabulary: ["infanzia", "ricordo", "prima", "giovane", "abitudine"],
          grammar: "Imperfect for memories.",
        },
        {
          id: "s4u23",
          title: "Unit 23: Transit plans",
          vocabulary: ["treno", "autobus", "metro", "orario", "ritardo"],
          grammar: "Travel planning.",
        },
        {
          id: "s4u24",
          title: "Unit 24: Give commands",
          vocabulary: ["vai", "vieni", "entra", "esci", "aspetta"],
          grammar: "Imperative mood.",
        },
        {
          id: "s4u25",
          title: "Unit 25: Describe your home",
          vocabulary: ["stanza", "mobile", "salotto", "cucina", "lampada"],
          grammar: "Describing interiors.",
        },
        {
          id: "s4u26",
          title: "Unit 26: Talk about art",
          vocabulary: ["arte", "pittura", "scultura", "artista", "colore"],
          grammar: "Opinion phrases.",
        },
        {
          id: "s4u27",
          title: "Unit 27: Emergencies",
          vocabulary: [
            "aiuto",
            "emergenza",
            "polizia",
            "ambulanza",
            "pericolo",
          ],
          grammar: "Emergency expressions.",
        },
        {
          id: "s4u28",
          title: "Unit 28: Future tense",
          vocabulary: ["andrò", "farò", "sarò", "avrò", "domani"],
          grammar: "Futuro semplice.",
        },
        {
          id: "s4u29",
          title: "Unit 29: At the doctor",
          vocabulary: ["dolore", "sintomo", "cura", "ricetta", "visita"],
          grammar: "Health communication.",
        },
        {
          id: "s4u30",
          title: "Unit 30: Weather forecast",
          vocabulary: ["pioggia", "neve", "sole", "tempesta", "clima"],
          grammar: "Future weather.",
        },

        {
          id: "s4u31",
          title: "Unit 31: Possessions",
          vocabulary: ["oggetto", "regalo", "nuovo", "vecchio", "valore"],
          grammar: "Possession structures.",
        },
        {
          id: "s4u32",
          title: "Unit 32: Talk about the future",
          vocabulary: ["futuro", "progetto", "obiettivo", "carriera"],
          grammar: "Future vs near future.",
        },
        {
          id: "s4u33",
          title: "Unit 33: A bad day",
          vocabulary: [
            "problema",
            "ritardo",
            "stanchezza",
            "stress",
            "sfortuna",
          ],
          grammar: "Narrating problems.",
        },
        {
          id: "s4u34",
          title: "Unit 34: Careers",
          vocabulary: [
            "lavoro",
            "professione",
            "colloquio",
            "azienda",
            "stipendio",
          ],
          grammar: "Career vocabulary.",
        },
        {
          id: "s4u35",
          title: "Unit 35: Politeness",
          vocabulary: ["scusi", "per favore", "grazie", "mi dispiace"],
          grammar: "Polite expressions.",
        },
        {
          id: "s4u36",
          title: "Unit 36: Sales and discounts",
          vocabulary: ["sconto", "offerta", "prezzo", "cassa", "articolo"],
          grammar: "Shopping language.",
        },
        {
          id: "s4u37",
          title: "Unit 37: Gerund",
          vocabulary: ["facendo", "parlando", "mangiando", "leggendo"],
          grammar: "Gerund for simultaneous actions.",
        },
        {
          id: "s4u38",
          title: "Unit 38: Conditional",
          vocabulary: ["vorrei", "potrei", "dovrei", "se"],
          grammar: "Conditional mood.",
        },
        {
          id: "s4u39",
          title: "Unit 39: Requests",
          vocabulary: ["prestare", "passare", "portare", "aiutare"],
          grammar: "Polite requests review.",
        },
        {
          id: "s4u40",
          title: "Unit 40: Public events",
          vocabulary: ["manifestazione", "diritto", "libertà", "governo"],
          grammar: "Public discussion.",
        },

        {
          id: "s4u41",
          title: "Unit 41: Restaurant orders",
          vocabulary: ["menu", "piatto", "antipasto", "dessert", "ordinare"],
          grammar: "Restaurant expressions.",
        },
        {
          id: "s4u42",
          title: "Unit 42: Sports talk",
          vocabulary: ["sport", "partita", "squadra", "giocatore", "vincere"],
          grammar: "Sports verbs.",
        },
        {
          id: "s4u43",
          title: "Unit 43: Classroom communication",
          vocabulary: ["domanda", "risposta", "spiegare", "capire"],
          grammar: "Imperatives and questions.",
        },
        {
          id: "s4u44",
          title: "Unit 44: Road trips",
          vocabulary: [
            "strada",
            "autostrada",
            "viaggio",
            "pausa",
            "chilometro",
          ],
          grammar: "Travel narration.",
        },
        {
          id: "s4u45",
          title: "Unit 45: Emergencies review",
          vocabulary: ["incidente", "ferita", "soccorso", "pericolo"],
          grammar: "Emergency review.",
        },
        {
          id: "s4u46",
          title: "Unit 46: Meeting people",
          vocabulary: ["incontrare", "presentare", "salutare", "conoscere"],
          grammar: "Social interaction expressions.",
        },
      ],
    },

    {
      name: "Section 5: Adventurer (CEFR B1)",
      description: "Independent communication and narration",
      units: [
        {
          id: "s5u1",
          title: "Unit 1: Narrate past experiences",
          vocabulary: [
            "esperienza",
            "viaggio",
            "ricordo",
            "evento",
            "accadere",
          ],
          grammar: "Passato prossimo vs imperfetto.",
        },
        {
          id: "s5u2",
          title: "Unit 2: Describe emotions deeply",
          vocabulary: [
            "orgoglioso",
            "deluso",
            "ansioso",
            "soddisfatto",
            "preoccupato",
          ],
          grammar: "Expressing emotions with adjectives.",
        },
        {
          id: "s5u3",
          title: "Unit 3: Explain reasons",
          vocabulary: ["perché", "motivo", "causa", "ragione", "spiegare"],
          grammar: "Causal connectors.",
        },
        {
          id: "s5u4",
          title: "Unit 4: Express opinions",
          vocabulary: ["secondo me", "ritengo", "opinione", "punto di vista"],
          grammar: "Opinion structures.",
        },
        {
          id: "s5u5",
          title: "Unit 5: Argue politely",
          vocabulary: ["tuttavia", "invece", "anche se", "nonostante"],
          grammar: "Contrast connectors.",
        },

        {
          id: "s5u6",
          title: "Unit 6: Describe social issues",
          vocabulary: [
            "società",
            "problema",
            "uguaglianza",
            "diritti",
            "comunità",
          ],
          grammar: "Abstract nouns.",
        },
        {
          id: "s5u7",
          title: "Unit 7: Discuss work stress",
          vocabulary: ["scadenza", "pressione", "responsabilità", "stress"],
          grammar: "Work-related expressions.",
        },
        {
          id: "s5u8",
          title: "Unit 8: Talk about learning",
          vocabulary: ["migliorare", "imparare", "abilità", "progresso"],
          grammar: "Learning verbs.",
        },
        {
          id: "s5u9",
          title: "Unit 9: Give advice",
          vocabulary: ["dovresti", "consiglio", "evitare", "provare"],
          grammar: "Modal verbs for advice.",
        },
        {
          id: "s5u10",
          title: "Unit 10: Handle complaints",
          vocabulary: ["lamentarsi", "problema", "servizio", "risolvere"],
          grammar: "Complaint structures.",
        },

        {
          id: "s5u11",
          title: "Unit 11: Explain processes",
          vocabulary: ["prima", "poi", "infine", "passaggio", "procedura"],
          grammar: "Sequencing language.",
        },
        {
          id: "s5u12",
          title: "Unit 12: Talk about technology",
          vocabulary: ["applicazione", "dispositivo", "rete", "digitale"],
          grammar: "Technology vocabulary.",
        },
        {
          id: "s5u13",
          title: "Unit 13: Discuss media",
          vocabulary: ["notizia", "giornale", "social", "informazione"],
          grammar: "Reported information.",
        },
        {
          id: "s5u14",
          title: "Unit 14: Talk about rules",
          vocabulary: ["regola", "obbligo", "vietato", "permesso"],
          grammar: "Obligation structures.",
        },
        {
          id: "s5u15",
          title: "Unit 15: Express expectations",
          vocabulary: ["aspettativa", "sperare", "prevedere", "attesa"],
          grammar: "Future expectations.",
        },

        {
          id: "s5u16",
          title: "Unit 16: Describe relationships",
          vocabulary: ["fiducia", "rapporto", "amicizia", "conflitto"],
          grammar: "Relationship language.",
        },
        {
          id: "s5u17",
          title: "Unit 17: Talk about habits",
          vocabulary: ["abitudine", "costante", "di solito", "frequente"],
          grammar: "Habitual actions.",
        },
        {
          id: "s5u18",
          title: "Unit 18: Explain decisions",
          vocabulary: ["scegliere", "decisione", "opzione", "valutare"],
          grammar: "Decision-making verbs.",
        },
        {
          id: "s5u19",
          title: "Unit 19: Express uncertainty",
          vocabulary: ["forse", "probabile", "dubbio", "incerto"],
          grammar: "Probability expressions.",
        },
        {
          id: "s5u20",
          title: "Unit 20: Talk about success",
          vocabulary: ["successo", "fallimento", "obiettivo", "risultato"],
          grammar: "Achievement vocabulary.",
        },

        {
          id: "s5u21",
          title: "Unit 21: Debate topics",
          vocabulary: ["dibattito", "argomento", "opinione", "discutere"],
          grammar: "Argumentation.",
        },
        {
          id: "s5u22",
          title: "Unit 22: Express regret",
          vocabulary: ["rimpianto", "errore", "avrei dovuto"],
          grammar: "Conditional past.",
        },
        {
          id: "s5u23",
          title: "Unit 23: Describe changes",
          vocabulary: ["cambiamento", "evoluzione", "miglioramento"],
          grammar: "Talking about change.",
        },
        {
          id: "s5u24",
          title: "Unit 24: Talk about culture",
          vocabulary: ["tradizione", "costume", "valore", "identità"],
          grammar: "Cultural discussion.",
        },
        {
          id: "s5u25",
          title: "Unit 25: Handle conflicts",
          vocabulary: ["litigio", "accordo", "mediare", "risolvere"],
          grammar: "Conflict resolution.",
        },

        {
          id: "s5u26",
          title: "Unit 26: Express wishes",
          vocabulary: ["vorrei", "desiderio", "speranza", "augurio"],
          grammar: "Wish expressions.",
        },
        {
          id: "s5u27",
          title: "Unit 27: Describe risks",
          vocabulary: ["rischio", "pericolo", "conseguenza", "prevenire"],
          grammar: "Cause and consequence.",
        },
        {
          id: "s5u28",
          title: "Unit 28: Talk about environment",
          vocabulary: ["ambiente", "inquinamento", "riciclare", "natura"],
          grammar: "Environmental topics.",
        },
        {
          id: "s5u29",
          title: "Unit 29: Express agreement",
          vocabulary: ["sono d'accordo", "concordare", "approvare"],
          grammar: "Agreement expressions.",
        },
        {
          id: "s5u30",
          title: "Unit 30: Express disagreement",
          vocabulary: ["non sono d'accordo", "contestare", "obiezione"],
          grammar: "Disagreement politely.",
        },

        {
          id: "s5u31",
          title: "Unit 31: Describe achievements",
          vocabulary: ["traguardo", "risultato", "successo", "orgoglio"],
          grammar: "Narrating achievements.",
        },
        {
          id: "s5u32",
          title: "Unit 32: Talk about future plans",
          vocabulary: ["piano", "intenzione", "progetto", "obiettivo"],
          grammar: "Future planning.",
        },
        {
          id: "s5u33",
          title: "Unit 33: Express curiosity",
          vocabulary: ["curioso", "interessato", "scoprire"],
          grammar: "Curiosity expressions.",
        },
        {
          id: "s5u34",
          title: "Unit 34: Explain preferences",
          vocabulary: ["preferire", "piacere", "scelta"],
          grammar: "Preference structures.",
        },
        {
          id: "s5u35",
          title: "Unit 35: Describe experiences abroad",
          vocabulary: ["estero", "cultura", "adattarsi", "lingua"],
          grammar: "Travel narration.",
        },

        {
          id: "s5u36",
          title: "Unit 36: Handle formal situations",
          vocabulary: ["formale", "richiesta", "documento"],
          grammar: "Formal language.",
        },
        {
          id: "s5u37",
          title: "Unit 37: Express surprise",
          vocabulary: ["sorpresa", "inaspettato", "stupire"],
          grammar: "Expressing surprise.",
        },
        {
          id: "s5u38",
          title: "Unit 38: Talk about responsibilities",
          vocabulary: ["dovere", "responsabilità", "impegno"],
          grammar: "Obligation and duty.",
        },
        {
          id: "s5u39",
          title: "Unit 39: Describe consequences",
          vocabulary: ["risultato", "effetto", "conseguenza"],
          grammar: "Cause-effect structures.",
        },
        {
          id: "s5u40",
          title: "Unit 40: Explain priorities",
          vocabulary: ["priorità", "importanza", "urgenza"],
          grammar: "Priority expressions.",
        },

        {
          id: "s5u41",
          title: "Unit 41: Express motivation",
          vocabulary: ["motivazione", "determinazione", "obiettivo"],
          grammar: "Motivational language.",
        },
        {
          id: "s5u42",
          title: "Unit 42: Discuss ethics",
          vocabulary: ["etica", "morale", "giusto", "sbagliato"],
          grammar: "Ethical discussion.",
        },
        {
          id: "s5u43",
          title: "Unit 43: Talk about teamwork",
          vocabulary: ["squadra", "collaborazione", "ruolo"],
          grammar: "Teamwork expressions.",
        },
        {
          id: "s5u44",
          title: "Unit 44: Express disappointment",
          vocabulary: ["delusione", "aspettativa", "fallire"],
          grammar: "Negative emotions.",
        },
        {
          id: "s5u45",
          title: "Unit 45: Talk about improvement",
          vocabulary: ["migliorare", "sviluppo", "crescita"],
          grammar: "Progress language.",
        },

        {
          id: "s5u46",
          title: "Unit 46: Describe leadership",
          vocabulary: ["leader", "guidare", "decisione", "responsabilità"],
          grammar: "Leadership vocabulary.",
        },
        {
          id: "s5u47",
          title: "Unit 47: Talk about innovation",
          vocabulary: ["innovazione", "idea", "creatività"],
          grammar: "Innovation discussion.",
        },
        {
          id: "s5u48",
          title: "Unit 48: Express confidence",
          vocabulary: ["fiducioso", "sicuro", "certezza"],
          grammar: "Confidence expressions.",
        },
        {
          id: "s5u49",
          title: "Unit 49: Describe challenges",
          vocabulary: ["sfida", "difficoltà", "ostacolo"],
          grammar: "Challenge narration.",
        },
        {
          id: "s5u50",
          title: "Unit 50: Reflect on experiences",
          vocabulary: ["riflettere", "esperienza", "insegnamento"],
          grammar: "Reflection language.",
        },
        {
          id: "s5u51",
          title: "Unit 51: Review and consolidate",
          vocabulary: ["ripasso", "consolidare", "riassumere"],
          grammar: "Full B1 review.",
        },
      ],
    },

    {
      name: "Section 6: Champion (CEFR B1)",
      description: "Advanced B1 reinforcement and fluency practice",
      units: Array.from({ length: 49 }, (_, i) => ({
        id: `s6u${i + 1}`,
        title: `Unit ${i + 1}: Advanced B1 Practice ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced B1 grammar reinforcement",
      })),
    },

    {
      name: "Section 7: Daily Refresh (CEFR B2)",
      description: "Upper-intermediate accuracy and consistency",
      units: Array.from({ length: 36 }, (_, i) => ({
        id: `s7u${i + 1}`,
        title: `Unit ${i + 1}: B2 Concept ${i + 1}`,
        vocabulary: [],
        grammar: "B2-level structures and refinement",
      })),
    },

    {
      name: "Section 8: Legendary (CEFR B2)",
      description: "Mastery and near-native command",
      units: Array.from({ length: 37 }, (_, i) => ({
        id: `s8u${i + 1}`,
        title: `Unit ${i + 1}: B2 Mastery ${i + 1}`,
        vocabulary: [],
        grammar: "Advanced mastery and nuance",
      })),
    },
  ],
};
